// This file is auto-generated by next/scripts/writeNavData.ts
// do not edit directly
export const selectedNavId = "e785eb0c-1255-454e-9a47-4399c2f3aa40";
export const allNavs = {
  "02603d5d-f149-48ac-bfbc-c8f219381279": {
    _type: "navigation",
    _id: "02603d5d-f149-48ac-bfbc-c8f219381279",
    _updatedAt: "2024-12-10T21:51:10Z",
    title: "11/26 - Get started button navigation experiment ",
    mobileBreakpoint: null,
    left: [
      {
        _key: "4c3ddc93ebdc",
        _type: "navMenu",
        text: "Products",
        description: null,
        submenu: [
          {
            _key: "79e9582c4b49",
            _type: "navGroup",
            span: 2,
            theme: "PrimaryWhite",
            title: {
              text: "Products",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: null,
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "7e342c9182fa",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8b14c557e5f9",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "055b248ba3d7",
                        link: {
                          to: "/product/credit-card",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Corporate card",
                        subtitle: "Get 10-20x higher credit limits",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M0 6C0 4.34315 1.34315 3 3 3H21C22.6569 3 24 4.34315 24 6V18C24 19.6569 22.6569 21 21 21H3C1.34314 21 0 19.6569 0 18V6ZM3 5C2.44772 5 2 5.44772 2 6V16H11.1415C11.8311 16 12.472 15.6448 12.8375 15.06L14.1625 12.94C14.528 12.3552 15.1689 12 15.8585 12H22V6C22 5.44771 21.5523 5 21 5H3Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "0d30fe481533",
                        link: {
                          to: "/product/spend-management",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Expense management",
                        subtitle: "Simplify expenses and reimbursements",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '    <svg\n      width="24"\n      height="24"\n      viewBox="0 0 24 24"\n      fill="none"\n      xmlns="http://www.w3.org/2000/svg"\n    >\n      <path\n        fill-rule="evenodd"\n        clip-rule="evenodd"\n        d="M23.8162 14.1036C23.937 13.4206 24 12.7177 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C12.7177 24 13.4206 23.937 14.1036 23.8162C13.3793 23.3301 12.7509 22.7122 12.2525 21.9969C12.1686 21.999 12.0844 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.0844 21.999 12.1686 21.9969 12.2525C22.7122 12.7509 23.3301 13.3793 23.8162 14.1036ZM18 24C21.3137 24 24 21.3137 24 18C24 14.6863 21.3137 12 18 12C14.6863 12 12 14.6863 12 18C12 21.3137 14.6863 24 18 24ZM19 14L15 19H17.5L17 22L21 17H18.5L19 14ZM14.9332 11.7058C14.4111 11.2654 13.7365 11 13 11H11C10.4477 11 10 10.5523 10 10C10 9.44771 10.4477 9 11 9H14V10H16V7H13V4H11V7C9.34315 7 8 8.34315 8 10C8 11.6569 9.34315 13 11 13H13C13.0325 13 13.0646 13.0016 13.0963 13.0046C13.6318 12.4789 14.2515 12.0386 14.9332 11.7058ZM11.4616 15.5338C11.5462 15.3303 11.6235 15.1443 11.6736 15H10V14H8V17H11C11 16.6443 11.253 16.0356 11.4616 15.5338L11.4616 15.5338Z"\n        fill="currentColor"\n      />\n    </svg>\n',
                        },
                      },
                      {
                        _key: "ed0c78f23112",
                        link: {
                          to: "/product/business-account",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Business banking",
                        subtitle: "Earn yield and move money fast",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 0.922852L21.1142 4.56852C22.2531 5.02411 23 6.12724 23 7.35395V9.99988H20V15.9999H23V18.9999C23 20.6567 21.6569 21.9999 20 21.9999H4C2.34315 21.9999 1 20.6567 1 18.9999V15.9999H4V9.99988H1V7.35395C1 6.12724 1.74685 5.02411 2.88583 4.56852L12 0.922852ZM6 15.9999H11V9.99988H6V15.9999ZM13 15.9999H18V9.99988H13V15.9999ZM12 3.07692L3.62861 6.42547C3.24895 6.57734 3 6.94505 3 7.35395V7.99988H15V4.27692L12 3.07692ZM3 18.9999V17.9999H15V19.9999H4C3.44772 19.9999 3 19.5522 3 18.9999Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "7d84741536b6",
                        link: {
                          to: "/product/bill-pay",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Bill pay",
                        subtitle: "Pay vendors faster and easier",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C4.34315 0 3 1.34314 3 3V21C3 22.6569 4.34315 24 6 24H18C19.6569 24 21 22.6569 21 21H19C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44771 2 6 2H14V7H19V11H21V5.58579L15.4142 0H6ZM8 11H16V13H8V11ZM12 15H8V17H12V15ZM23.6715 16L20.6914 12.4238L19.3086 13.5762L20.5785 15.1H16V16.9H20.5785L19.3086 18.4238L20.6914 19.5762L23.6715 16Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
              {
                _key: "381f7b96912b",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "3a4115508c0b",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "b4bd1183c3f0",
                        link: {
                          to: "/platform/accounting-automation",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Accounting automation",
                        subtitle: "Close the books in minutes",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="fill=currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M3 2C1.89543 2 1 2.89543 1 4V17C1 18.1046 1.89543 19 3 19H9C9.53043 19 10.0391 19.2107 10.4142 19.5858C10.7893 19.9609 11 20.4696 11 21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21C13 20.4696 13.2107 19.9609 13.5858 19.5858C13.9609 19.2107 14.4696 19 15 19H21C22.1046 19 23 18.1046 23 17V4C23 2.89543 22.1046 2 21 2H16C14.6739 2 13.4021 2.52678 12.4645 3.46447C12.2962 3.63275 12.1411 3.81178 12 3.99997C11.8589 3.81178 11.7038 3.63275 11.5355 3.46447C10.5979 2.52678 9.32608 2 8 2H3ZM13 17.5359C13.6029 17.1878 14.2918 17 15 17H21V4H16C15.2044 4 14.4413 4.31607 13.8787 4.87868C13.3161 5.44129 13 6.20435 13 7V17.5359ZM11 17.5359V7C11 6.20435 10.6839 5.44129 10.1213 4.87868C9.55871 4.31607 8.79565 4 8 4H3V17H9C9.70823 17 10.3971 17.1878 11 17.5359Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "f60fe03cd936",
                        link: {
                          to: "/product/travel-expense-management",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Travel",
                        subtitle: "Book and manage global travel",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M9 0C7.89543 0 7 0.89543 7 2V7H4H3V8V19C3 20.8819 4.2996 22.4603 6.05029 22.8866C6.2208 23.5277 6.80523 24 7.5 24C8.15311 24 8.70873 23.5826 8.91465 23H15.0854C15.2913 23.5826 15.8469 24 16.5 24C17.1948 24 17.7792 23.5277 17.9497 22.8866C19.7004 22.4603 21 20.8819 21 19V8V7H20H17V2C17 0.895431 16.1046 0 15 0H9ZM17 21C18.1046 21 19 20.1046 19 19V9H17H16H8H7H5V19C5 20.1046 5.89543 21 7 21H9H15H17ZM15 7V2L9 2V7H15ZM17 14H7V12H17V14ZM7 18H17V16H7V18Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "569a75fd4e4d",
                        link: {
                          to: "/product/embedded-finance",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Brex Embedded",
                        subtitle: "Embed our cards in your products",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.00004 5.3335C4.00004 3.12436 5.7909 1.3335 8.00004 1.3335H24C26.2092 1.3335 28 3.12436 28 5.3335V6.35202C28.8184 7.08445 29.3334 8.14883 29.3334 9.3335V10.352C30.1517 11.0844 30.6667 12.1488 30.6667 13.3335V26.6668C30.6667 28.876 28.8758 30.6668 26.6667 30.6668H5.33337C3.12424 30.6668 1.33337 28.876 1.33337 26.6668V13.3335C1.33337 12.1488 1.84837 11.0844 2.66671 10.352V9.3335C2.66671 8.14883 3.18171 7.08445 4.00004 6.35202V5.3335ZM24 4.00016C24.7364 4.00016 25.3334 4.59712 25.3334 5.3335H6.66671C6.66671 4.59712 7.26366 4.00016 8.00004 4.00016H24ZM25.3334 8.00016H6.66671C5.93033 8.00016 5.33337 8.59712 5.33337 9.3335H26.6667C26.6667 8.59712 26.0698 8.00016 25.3334 8.00016ZM5.33337 12.0002C4.59699 12.0002 4.00004 12.5971 4.00004 13.3335V24.0002H15.0844C15.8758 24.0002 16.6263 23.6486 17.133 23.0407L18.8671 20.9597C19.3738 20.3517 20.1243 20.0002 20.9157 20.0002H28V13.3335C28 12.5971 27.4031 12.0002 26.6667 12.0002H5.33337Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "2af71eb99ff6",
                        link: {
                          to: "/release",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Product releases",
                        subtitle: "See what’s new at Brex",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m26.6667 2.66675v4 3.99995c1.4145 0 2.771.562 3.7712 1.5621 1.0002 1.0002 1.5621 2.3568 1.5621 3.7713s-.5619 2.771-1.5621 3.7712-2.3567 1.5621-3.7712 1.5621v4 4h-2.6667v-2.8705l-9.4081-1.568c-.4256 2.5195-2.618 4.4386-5.25857 4.4386-2.94551 0-5.33333-2.3879-5.33333-5.3334 0-.292.02359-.579.06902-.859l-.72662-.1211c-1.92875-.3215-3.3424-1.9902-3.3424-3.9456v-6.1486c0-1.9554 1.41365-3.62416 3.3424-3.94562l20.6576-3.44293v-2.8705zm-19.96724 20.91275 5.26164.8769c-.2165 1.2554-1.3106 2.2104-2.62777 2.2104-1.47276 0-2.66666-1.1939-2.66666-2.6667 0-.1435.01122-.2839.03279-.4206zm17.30054-15.3388-20.2192 3.3699c-.64292.1071-1.11413.6634-1.11413 1.3152v6.1486c0 .6518.47121 1.208 1.11413 1.3152l20.2192 3.3699z" fill="currentColor" fill-rule="evenodd"/></svg>',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "af0469f4ab57062d2d3adc5443bdfee5",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "Platform",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: null,
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "7e342c9182fa",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8b14c557e5f9",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "055b248ba3d7",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/platform/brex-ai",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Brex AI",
                        subtitle: "Automations and insights",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill=currentColor xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_6620_871)">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.97183 10.4917C5 10.8023 5.21127 11 5.50704 11C5.78873 11 6 10.8023 6.02817 10.5199C6.52016 6.78525 6.63336 6.76387 10.4983 6.03383L10.5211 6.02952C10.8028 5.98716 11 5.78947 11 5.50706C11 5.21053 10.7887 4.99872 10.5211 4.97047C6.64789 4.43389 6.52113 4.3068 6.02817 0.494223C6 0.197689 5.78873 0 5.50704 0C5.21127 0 5 0.197689 4.97183 0.508344C4.51102 4.21832 4.34094 4.25005 0.577071 4.95215L0.478873 4.97047C0.197183 5.01284 0 5.21053 0 5.50706C0 5.80359 0.197183 5.98716 0.535211 6.02952C4.35211 6.63671 4.50704 6.74968 4.97183 10.4917ZM14.5 24C14.1424 24 13.8563 23.7376 13.7967 23.3559C12.8789 16.8914 12.0088 16.0565 5.6675 15.2097C5.27415 15.162 5 14.8638 5 14.494C5 14.1243 5.27415 13.838 5.67942 13.7903C12.0326 13.0866 12.9385 12.1086 13.7967 5.64407C13.8563 5.2624 14.1305 5 14.5 5C14.8695 5 15.1437 5.2624 15.2033 5.64407C16.0972 12.1086 16.9793 13.0508 23.3325 13.7903C23.7258 13.838 24 14.1243 24 14.494C24 14.8757 23.7258 15.162 23.3325 15.2097C16.9674 15.9134 16.0615 16.8914 15.2033 23.3559C15.1437 23.7376 14.8695 24 14.5 24Z" fill=currentColor/>\n</g>\n<defs>\n<clipPath id="clip0_6620_871">\n<rect width="24" height="24" fill="white"/>\n</clipPath>\n</defs>\n</svg>',
                        },
                      },
                      {
                        _key: "0d30fe481533",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/product/global",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Global ready",
                        subtitle: "Multi-currency and multi-entity",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12 22C12.7474 22 13.7509 21.2878 14.6252 19.3644C14.9377 18.6767 15.2093 17.8808 15.4265 17H8.57345C8.79074 17.8808 9.06226 18.6767 9.37483 19.3644C10.2491 21.2878 11.2526 22 12 22ZM8.19682 15H15.8032C15.9306 14.0553 16 13.0485 16 12C16 10.9515 15.9306 9.94466 15.8032 9H8.19682C8.06943 9.94466 8 10.9515 8 12C8 13.0485 8.06943 14.0553 8.19682 15ZM8.57345 7C8.79074 6.11921 9.06226 5.32328 9.37483 4.63563C10.2491 2.71217 11.2526 2 12 2C12.7474 2 13.7509 2.71217 14.6252 4.63563C14.9377 5.32328 15.2093 6.11921 15.4265 7H8.57345ZM17.8196 9C17.9378 9.96135 18 10.9672 18 12C18 13.0328 17.9378 14.0387 17.8196 15H21.5422C21.8396 14.053 22 13.0452 22 12C22 10.9548 21.8396 9.94704 21.5422 9H17.8196ZM20.6622 7H17.48C17.2208 5.8214 16.8712 4.74364 16.4459 3.80802C16.2881 3.4608 16.1143 3.12233 15.9247 2.79955C17.9212 3.65232 19.5839 5.13598 20.6622 7ZM6.51996 7H3.33782C4.4161 5.13598 6.07877 3.65232 8.07531 2.79955C7.88574 3.12233 7.71193 3.4608 7.5541 3.80802C7.12882 4.74364 6.77917 5.8214 6.51996 7ZM2.4578 9H6.18036C6.06223 9.96135 6 10.9672 6 12C6 13.0328 6.06223 14.0387 6.18036 15H2.4578C2.16035 14.053 2 13.0452 2 12C2 10.9548 2.16035 9.94704 2.4578 9ZM16.4459 20.192C16.8712 19.2564 17.2208 18.1786 17.48 17H20.6622C19.5839 18.864 17.9212 20.3477 15.9247 21.2005C16.1143 20.8777 16.2881 20.5392 16.4459 20.192ZM8.07532 21.2005C6.07877 20.3477 4.4161 18.864 3.33782 17H6.51996C6.77917 18.1786 7.12882 19.2564 7.5541 20.192C7.71193 20.5392 7.88574 20.8777 8.07532 21.2005Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                      {
                        _key: "23bc46b3797f",
                        link: {
                          to: "/platform/budgets",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Live Budgets™",
                        subtitle: "Real-time tracking and agility",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M16.5922 0.913451C14.3995 0.00519943 11.9867 -0.232441 9.65892 0.230582C7.33115 0.693605 5.19295 1.83649 3.51472 3.51472C1.83649 5.19295 0.693605 7.33115 0.230582 9.65892C-0.232441 11.9867 0.00519943 14.3995 0.913451 16.5922C1.8217 18.7849 3.35977 20.6591 5.33316 21.9776C7.30655 23.2962 9.62663 24 12 24C13.5759 24 15.1363 23.6896 16.5922 23.0866C18.0481 22.4835 19.371 21.5996 20.4853 20.4853C21.5996 19.371 22.4835 18.0481 23.0866 16.5922C23.6896 15.1363 24 13.5759 24 12C24 9.62663 23.2962 7.30655 21.9776 5.33316C20.6591 3.35977 18.7849 1.8217 16.5922 0.913451ZM10.0491 2.19215C11.9889 1.8063 13.9996 2.00433 15.8268 2.76121C17.6541 3.51809 19.2159 4.79981 20.3147 6.4443C21.2274 7.81025 21.7866 9.37552 21.9499 11H12C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12V21.9499C9.37552 21.7866 7.81025 21.2274 6.4443 20.3147C4.79981 19.2159 3.51809 17.6541 2.76121 15.8268C2.00433 13.9996 1.8063 11.9889 2.19215 10.0491C2.578 8.10929 3.53041 6.32746 4.92894 4.92894C6.32746 3.53041 8.10929 2.57801 10.0491 2.19215Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "c3a30c8019e8c5c43cc3d2ad08a8984e",
                        link: {
                          to: "/platform/spend-limits",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Spend limits",
                        subtitle: "Custom limits with built-in controls",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11 7C11 9.20914 9.20914 11 7 11C4.79086 11 3 9.20914 3 7C3 4.79086 4.79086 3 7 3L7 6C7 6.55228 7.44772 7 8 7H11ZM7 1C8.6454 1 10.1361 1.66232 11.2201 2.7349L11.2426 2.75736L11.2651 2.77994C11.665 3.18408 12.0079 3.64476 12.2806 4.14892C14.1484 3.82292 16.0722 4.03441 17.8268 4.76121C19.6541 5.51808 21.2159 6.79981 22.3147 8.4443C23.4135 10.0888 24 12.0222 24 14C24 15.3132 23.7413 16.6136 23.2388 17.8268C22.7362 19.0401 21.9997 20.1425 21.0711 21.0711C20.1425 21.9997 19.0401 22.7362 17.8268 23.2388C16.6145 23.7409 15.3153 23.9996 14.0031 24C14.0021 24 14.001 24 14 24C12.0222 24 10.0888 23.4135 8.4443 22.3147C6.79981 21.2159 5.51808 19.6541 4.76121 17.8268C4.0344 16.0722 3.82292 14.1484 4.14892 12.2806C2.27371 11.2661 1 9.28178 1 7C1 3.68629 3.68629 1 7 1ZM6.07206 12.9287C5.88315 14.3266 6.06691 15.7528 6.60897 17.0615C7.21447 18.5233 8.23985 19.7727 9.55544 20.6518C10.592 21.3444 11.7721 21.7826 13 21.9373V14C13 13.7348 13.1054 13.4804 13.2929 13.2929C13.4804 13.1054 13.7348 13 14 13H21.9373C21.7826 11.7721 21.3444 10.592 20.6518 9.55544C19.7727 8.23985 18.5233 7.21447 17.0615 6.60897C15.7528 6.06691 14.3266 5.88315 12.9287 6.07206C12.9756 6.3745 13 6.6844 13 7C13 10.3137 10.3137 13 7 13C6.6844 13 6.3745 12.9756 6.07206 12.9287Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "5c9a8a4197a57f715fe90402fab034ea",
                        link: {
                          to: "/product/integrations",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Native integrations",
                        subtitle: "ERP, HRIS, productivity, security",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12.168 5.33337C12.7601 3.03307 14.8482 1.33337 17.3333 1.33337C19.8185 1.33337 21.9066 3.03307 22.4986 5.33337H29.3333V14.6667H28C26.5272 14.6667 25.3333 15.8606 25.3333 17.3334C25.3333 18.8061 26.5272 20 28 20H29.3333V29.3334H5.33333V22.4987C3.03303 21.9066 1.33333 19.8185 1.33333 17.3334C1.33333 14.8483 3.03303 12.7601 5.33333 12.1681V5.33337H12.168ZM17.3333 4.00004C15.8606 4.00004 14.6667 5.19395 14.6667 6.66671V8.00004H8V14.6667H6.66667C5.19391 14.6667 4 15.8606 4 17.3334C4 18.8061 5.19391 20 6.66667 20H8V26.6667H26.6667V22.4987C24.3664 21.9066 22.6667 19.8185 22.6667 17.3334C22.6667 14.8483 24.3664 12.7601 26.6667 12.1681V8.00004H20V6.66671C20 5.19395 18.8061 4.00004 17.3333 4.00004Z" fill="#currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "25420cfd0b03a9254f9b94701064cdb7",
                        link: {
                          to: "/product/mobile",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Mobile",
                        subtitle: "Available on iOS and Android",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M7 0C5.34315 0 4 1.34314 4 3V21C4 22.6569 5.34315 24 7 24H17C18.6569 24 20 22.6569 20 21V3C20 1.34315 18.6569 0 17 0H7ZM6 3C6 2.44772 6.44771 2 7 2H17C17.5523 2 18 2.44772 18 3V21C18 21.5523 17.5523 22 17 22H7C6.44772 22 6 21.5523 6 21V3ZM12 20C13.1046 20 14 19.1046 14 18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18C10 19.1046 10.8954 20 12 20Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "1e2b0492bcc1",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryGray",
            title: {
              text: "New release",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: { to: "", toExternal: null, noFollow: null, hash: null },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "5860dde6ed0e",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "b3536b8af5b0",
                    _type: "linkHeroNavModule",
                    title: "Make every dollar count",
                    subtitle:
                      "Maximize the value you get from Brex with an all-new Impact Dashboard, smart search, global bill pay, and much more. Check it out!",
                    subtitleV2Raw: null,
                    link: {
                      to: "/release",
                      toExternal: null,
                      noFollow: null,
                      hash: null,
                    },
                    icon: null,
                    media: {
                      media: {
                        type: "IMAGE",
                        datUrl:
                          "https://brand.brex.com/transform/3645f6cc-90e6-46d2-8042-c89a031adc2a/Fall-release_nav",
                        description: null,
                        aspectRatio: 0.6125,
                        videoUrl: null,
                      },
                      mediaStyle: {
                        borderRadius: "6px",
                        customBorderRadius: null,
                      },
                      disableVideoLoop: false,
                    },
                    modifier: null,
                    mediaPosition: "top",
                    showMediaOnMobile: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _key: "53ce45644bd9",
        _type: "navMenu",
        text: "Solutions",
        description: null,
        submenu: [
          {
            _key: "7c4cb829ab72",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "By company size",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: { to: "", toExternal: null, noFollow: null, hash: null },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "aba2aba1f772",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "27f22e08ffc1",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "57d88210c49c",
                        link: {
                          to: "/solutions/startups",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Startups",
                        subtitle: "Get the #1 financial stack for startups",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M0 6C0 4.34315 1.34315 3 3 3H21C22.6569 3 24 4.34315 24 6V18C24 19.6569 22.6569 21 21 21H3C1.34314 21 0 19.6569 0 18V6ZM3 5C2.44772 5 2 5.44772 2 6V16H11.1415C11.8311 16 12.472 15.6448 12.8375 15.06L14.1625 12.94C14.528 12.3552 15.1689 12 15.8585 12H22V6C22 5.44771 21.5523 5 21 5H3Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "72d93b76bb04",
                        link: {
                          to: "/solutions/mid-size-companies",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Mid-sized companies",
                        subtitle: "Scale faster with smart cards & controls",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M13.5629 4.89329C11.6112 4.24273 9.46846 4.52968 7.75671 5.67085L5.92707 6.89061L4.26297 8.00001L5.92707 9.10941L10.263 12L8.51064 13.1682L5.82852 12.0954L5.37504 11.914L4.9117 12.0684L2.95837 12.7195C1.07774 13.3464 0.514287 15.7332 1.91602 17.135L4.64044 19.8594C7.27459 22.4935 11.3783 22.9609 14.5373 20.9865L29.8507 11.4157C31.3672 10.4678 31.5393 8.32517 30.1933 7.14748L29.5796 6.61049C27.1349 4.47137 23.6394 4.02293 20.7339 5.47569L18.5644 6.56045L13.5629 4.89329ZM9.23591 7.88965C10.263 7.20495 11.5486 7.03277 12.7196 7.42311L18.245 9.26492L18.769 9.43957L19.263 9.19258L21.9265 7.86083C23.8635 6.89232 26.1938 7.19128 27.8236 8.61736L28.4373 9.15435L13.124 18.7252C11.018 20.0415 8.28216 19.7299 6.52606 17.9738L3.80164 15.2494L5.29162 14.7527L8.17148 15.9046L8.82269 16.1651L9.40627 15.7761L13.4063 13.1094L15.0704 12L13.4063 10.8906L9.07037 8.00001L9.23591 7.88965ZM2.66667 28H21.3333V25.3333H2.66667V28Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                      {
                        _key: "751c09fb19d7",
                        link: {
                          to: "/solutions/enterprise",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Enterprise",
                        subtitle: "Spend smart across entities, currencies",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="33" height="32" viewBox="0 0 33 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 0C6.29086 0 4.5 1.79086 4.5 4V30V31.924L6.3015 31.2484L8.42376 30.4526L10.5704 31.5259L11.1667 31.824L11.763 31.5259L13.8333 30.4907L15.9037 31.5259L16.5 31.824L17.0963 31.5259L19.1667 30.4907L21.237 31.5259L21.8333 31.824L22.4296 31.5259L24.5762 30.4526L26.6985 31.2484L28.5 31.924V30V4C28.5 1.79086 26.7091 0 24.5 0H8.5ZM7.16667 4C7.16667 3.26362 7.76362 2.66667 8.5 2.66667H24.5C25.2364 2.66667 25.8333 3.26362 25.8333 4V28.076L24.9682 27.7516L24.4238 27.5474L23.9037 27.8074L21.8333 28.8426L19.763 27.8074L19.1667 27.5093L18.5704 27.8074L16.5 28.8426L14.4296 27.8074L13.8333 27.5093L13.237 27.8074L11.1667 28.8426L9.09628 27.8074L8.57624 27.5474L8.03184 27.7516L7.16667 28.076V4ZM19.1667 8H13.8333V5.33333H19.1667V8ZM21.8333 13.3333H11.1667V10.6667H21.8333V13.3333ZM11.1667 18.6667H21.8333V16H11.1667V18.6667ZM16.5 24V21.3333H21.8333V24H16.5Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "b6f631dcf896",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "For partners",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: {
                  to: null,
                  toExternal: null,
                  noFollow: false,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: false,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "32731f9ee7ac",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "3362e675a734",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "d5fde9919472",
                        link: {
                          to: "/partners/accounting",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Accounting firms",
                        subtitle: "Simplify close and earn rewards",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M10.6667 4C7.35296 4 4.66667 6.68629 4.66667 10C4.66667 13.3137 7.35296 16 10.6667 16C13.9804 16 16.6667 13.3137 16.6667 10C16.6667 6.68629 13.9804 4 10.6667 4ZM7.33334 10C7.33334 8.15905 8.82572 6.66667 10.6667 6.66667C12.5076 6.66667 14 8.15905 14 10C14 11.8409 12.5076 13.3333 10.6667 13.3333C8.82572 13.3333 7.33334 11.8409 7.33334 10Z" fill="currentColor"/>\n<path d="M18.3334 10C18.3334 11.6533 17.7863 13.1788 16.8632 14.4054C17.8308 15.3896 19.1774 16 20.6667 16C23.6122 16 26 13.6122 26 10.6667C26 7.72115 23.6122 5.33333 20.6667 5.33333C19.4418 5.33333 18.3134 5.74623 17.4131 6.44042C17.9994 7.49451 18.3334 8.70825 18.3334 10Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M21.3333 21.4744V28H5.54861C4.84575 28 4.23939 28 3.73997 27.9592C3.21284 27.9162 2.68855 27.8211 2.18404 27.564C1.43139 27.1805 0.81947 26.5686 0.435976 25.816C0.178918 25.3115 0.0838297 24.7872 0.0407617 24.26C-4.33574e-05 23.7606 -2.2695e-05 23.1543 1.14681e-06 22.4514V20.7201C0.865588 19.9782 0.310448 20.4539 0.466628 20.3201L0.467715 20.3192C0.489714 20.3005 0.51208 20.2821 0.534606 20.264C0.570185 20.2355 0.618371 20.1977 0.679169 20.1521C0.800747 20.0609 0.972894 19.9383 1.19566 19.7951C1.64114 19.5087 2.28971 19.1395 3.14144 18.7745C4.84824 18.043 7.35963 17.3333 10.6667 17.3333C14.0255 17.3333 16.5734 18.2351 18.2963 19.158C19.1553 19.6182 19.807 20.0823 20.2519 20.4398C20.4744 20.6187 20.6458 20.7713 20.7661 20.8841C20.8263 20.9405 20.8737 20.987 20.9084 21.0219C20.9258 21.0393 20.94 21.0539 20.9511 21.0653L20.9706 21.0858L20.9728 21.0882L20.9738 21.0893C21.1327 21.2595 20.6069 20.6962 21.3333 21.4744ZM2.66667 22.0197V22.4C2.66667 23.1687 2.66771 23.6651 2.69857 24.0429C2.72817 24.4051 2.7784 24.5394 2.81199 24.6053C2.93982 24.8562 3.1438 25.0602 3.39468 25.188C3.46061 25.2216 3.5949 25.2718 3.95712 25.3014C4.3349 25.3323 4.83126 25.3333 5.6 25.3333H18.6667V22.588C18.6398 22.5657 18.6114 22.5425 18.5815 22.5185C18.2486 22.251 17.7336 21.8818 17.037 21.5086C15.6488 20.7649 13.53 20 10.6667 20C7.75149 20 5.59621 20.6237 4.19189 21.2255C3.50822 21.5185 2.99978 21.8076 2.66667 22.0197Z" fill="currentColor"/>\n<path d="M22.6667 21.2174V28H27.7333C29.2268 28 29.9736 28 30.544 27.7094C31.0458 27.4537 31.4537 27.0457 31.7094 26.544C32 25.9735 32 25.2268 32 23.7333V20.6667C32 20.6667 27.5556 17.3333 21.3333 17.3333C20.0653 17.3333 18.9264 17.4441 17.9168 17.6205C21.0834 19.1522 22.6667 21.2174 22.6667 21.2174Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "102d59011244",
                        link: {
                          to: "/product/embedded-finance",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "B2B software",
                        subtitle: "Embed Brex cards in your products",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.00004 5.3335C4.00004 3.12436 5.7909 1.3335 8.00004 1.3335H24C26.2092 1.3335 28 3.12436 28 5.3335V6.35202C28.8184 7.08445 29.3334 8.14883 29.3334 9.3335V10.352C30.1517 11.0844 30.6667 12.1488 30.6667 13.3335V26.6668C30.6667 28.876 28.8758 30.6668 26.6667 30.6668H5.33337C3.12424 30.6668 1.33337 28.876 1.33337 26.6668V13.3335C1.33337 12.1488 1.84837 11.0844 2.66671 10.352V9.3335C2.66671 8.14883 3.18171 7.08445 4.00004 6.35202V5.3335ZM24 4.00016C24.7364 4.00016 25.3334 4.59712 25.3334 5.3335H6.66671C6.66671 4.59712 7.26366 4.00016 8.00004 4.00016H24ZM25.3334 8.00016H6.66671C5.93033 8.00016 5.33337 8.59712 5.33337 9.3335H26.6667C26.6667 8.59712 26.0698 8.00016 25.3334 8.00016ZM5.33337 12.0002C4.59699 12.0002 4.00004 12.5971 4.00004 13.3335V24.0002H15.0844C15.8758 24.0002 16.6263 23.6486 17.133 23.0407L18.8671 20.9597C19.3738 20.3517 20.1243 20.0002 20.9157 20.0002H28V13.3335C28 12.5971 27.4031 12.0002 26.6667 12.0002H5.33337Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _key: "3adc58d91a4b",
        _type: "navMenu",
        text: "Resources",
        description: null,
        submenu: [
          {
            _key: "79d0fdf35784",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "Customer Hub",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: "/customer-hub",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "86ec301ad222",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "/support",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Help Center",
                        subtitle: "Find answers to common questions.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M10.5 17.5C10.5 16.6716 11.1716 16 12 16C12.8284 16 13.5 16.6716 13.5 17.5C13.5 18.3284 12.8284 19 12 19C11.1716 19 10.5 18.3284 10.5 17.5Z" fill="currentColor"/>\n<path d="M12 5C9.79086 5 8 6.79086 8 9H10C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9V9.39445C14 10.0632 13.6658 10.6876 13.1094 11.0585L12.7812 11.2774C11.6684 12.0192 11 13.2681 11 14.6056V15H13V14.6056C13 13.9368 13.3342 13.3124 13.8906 12.9415L14.2188 12.7226C15.3316 11.9808 16 10.7319 16 9.39445V9C16 6.79086 14.2091 5 12 5Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/implementation",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Implementation guides",
                        subtitle: "Learn how to set up key features.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_5399_39609)">\n<path d="M9 12V10H13V16H15V18H9V16H11V12H9Z" fill="currentColor"/>\n<path d="M12 9C12.8284 9 13.5 8.32843 13.5 7.5C13.5 6.67157 12.8284 6 12 6C11.1716 6 10.5 6.67157 10.5 7.5C10.5 8.32843 11.1716 9 12 9Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor"/>\n</g>\n<defs>\n<clipPath id="clip0_5399_39609">\n<rect width="24" height="24" fill="currentColor"/>\n</clipPath>\n</defs>\n</svg>\n',
                        },
                      },
                      {
                        _key: "78c4db945bb1",
                        link: {
                          to: "/release",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Product releases",
                        subtitle: "See what’s new at Brex",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m26.6667 2.66675v4 3.99995c1.4145 0 2.771.562 3.7712 1.5621 1.0002 1.0002 1.5621 2.3568 1.5621 3.7713s-.5619 2.771-1.5621 3.7712-2.3567 1.5621-3.7712 1.5621v4 4h-2.6667v-2.8705l-9.4081-1.568c-.4256 2.5195-2.618 4.4386-5.25857 4.4386-2.94551 0-5.33333-2.3879-5.33333-5.3334 0-.292.02359-.579.06902-.859l-.72662-.1211c-1.92875-.3215-3.3424-1.9902-3.3424-3.9456v-6.1486c0-1.9554 1.41365-3.62416 3.3424-3.94562l20.6576-3.44293v-2.8705zm-19.96724 20.91275 5.26164.8769c-.2165 1.2554-1.3106 2.2104-2.62777 2.2104-1.47276 0-2.66666-1.1939-2.66666-2.6667 0-.1435.01122-.2839.03279-.4206zm17.30054-15.3388-20.2192 3.3699c-.64292.1071-1.11413.6634-1.11413 1.3152v6.1486c0 .6518.47121 1.208 1.11413 1.3152l20.2192 3.3699z" fill="currentColor" fill-rule="evenodd"/></svg>',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "4ce7782d1713ef14f57e6d62fb24e62e",
            _type: "navGroup",
            span: 2,
            theme: "PrimaryWhite",
            title: {
              text: "Resource Center",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: "/resources",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "86ec301ad222",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/resources/ebooks",
                          noFollow: null,
                          hash: null,
                        },
                        text: "White papers and e-books",
                        subtitle: "Access exclusive research and reports.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="33" height="32" viewBox="0 0 33 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M21.8333 18.6667V16H11.1667V18.6667H21.8333Z" fill="currentColor"/>\n<path d="M11.1667 24V21.3333H21.8333V24H11.1667Z" fill="currentColor"/>\n<path d="M16.5 6.66667H11.1667V9.33333H16.5V6.66667Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 4C4.5 1.79086 6.29086 0 8.5 0H21.0523L28.5 7.44772V28C28.5 30.2091 26.7091 32 24.5 32H8.5C6.29086 32 4.5 30.2091 4.5 28V4ZM8.5 2.66667C7.76362 2.66667 7.16667 3.26362 7.16667 4V28C7.16667 28.7364 7.76362 29.3333 8.5 29.3333H24.5C25.2364 29.3333 25.8333 28.7364 25.8333 28V9.33333H19.1667V2.66667H8.5Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: null,
                          toExternal: "https://www.brex.com/resources/webinars",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Webinars",
                        subtitle: "Tune in for actionable insights.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="21" viewBox="0 0 24 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M2.47117 16.9754C1.70016 16.9754 1.0939 16.758 0.652389 16.3231C0.217463 15.8815 0 15.272 0 14.4944V2.59324C0 1.81565 0.217463 1.20938 0.652389 0.774459C1.0939 0.339533 1.70016 0.12207 2.47117 0.12207H21.5288C22.2998 0.12207 22.9028 0.339533 23.3377 0.774459C23.7792 1.20938 24 1.81565 24 2.59324V14.4944C24 15.272 23.7792 15.8815 23.3377 16.3231C22.9028 16.758 22.2998 16.9754 21.5288 16.9754H2.47117ZM2.31301 12.3988H21.6771C21.9605 12.3988 22.1021 12.2605 22.1021 11.9837V2.71186C22.1021 2.49439 22.0395 2.32635 21.9143 2.20774C21.7891 2.08253 21.6244 2.01993 21.4201 2.01993H2.5799C2.37562 2.01993 2.21087 2.08253 2.08567 2.20774C1.96046 2.32635 1.89786 2.49439 1.89786 2.71186V11.9837C1.89786 12.2605 2.03624 12.3988 2.31301 12.3988ZM9 19V15.8792H15V19.0117L9 19ZM8.72817 20.5537C8.47776 20.5537 8.26359 20.4647 8.08567 20.2868C7.91433 20.1089 7.82867 19.898 7.82867 19.6542C7.82867 19.4038 7.91433 19.1896 8.08567 19.0117C8.26359 18.8404 8.47776 18.7547 8.72817 18.7547H15.2718C15.5222 18.7547 15.7331 18.8404 15.9044 19.0117C16.0758 19.1896 16.1614 19.4038 16.1614 19.6542C16.1614 19.898 16.0758 20.1089 15.9044 20.2868C15.7331 20.4647 15.5222 20.5537 15.2718 20.5537H8.72817Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "78c4db945bb1",
                        link: {
                          to: "",
                          toExternal:
                            "https://www.brex.com/resources/case-studies",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Customer stories",
                        subtitle: "See how top companies use Brex.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M16.0002 2.66663C12.3551 2.66663 9.40016 5.65139 9.40016 9.33329C9.40016 13.0152 12.3551 16 16.0002 16C19.6452 16 22.6002 13.0152 22.6002 9.33329C22.6002 5.65139 19.6452 2.66663 16.0002 2.66663ZM12.3335 9.33329C12.3335 7.28779 13.9751 5.62959 16.0002 5.62959C18.0252 5.62959 19.6668 7.28779 19.6668 9.33329C19.6668 11.3788 18.0252 13.037 16.0002 13.037C13.9751 13.037 12.3335 11.3788 12.3335 9.33329Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M29.9331 21.3834L29.9296 21.3814L29.9238 21.378L29.9052 21.3673L29.8407 21.3307C29.7858 21.2998 29.7072 21.2562 29.6063 21.2016C29.4046 21.0924 29.1135 20.9394 28.7446 20.7571C28.0076 20.393 26.9557 19.9101 25.6818 19.4276C23.1502 18.4687 19.6654 17.4814 16.0002 17.4814C12.3836 17.4814 8.93303 18.2615 6.41205 19.0254C5.14551 19.4092 4.09913 19.7934 3.36571 20.0833C2.99871 20.2284 2.70925 20.3501 2.50888 20.4369C2.40867 20.4803 2.33066 20.5149 2.27631 20.5394L2.21268 20.5682L2.19448 20.5766L2.18885 20.5792L2.18691 20.5801C2.17992 20.5834 2.18555 20.5808 2.18555 20.5808L1.3335 20.978V23.1682C1.33347 23.9491 1.33345 24.6229 1.37834 25.1778C1.42571 25.7635 1.53031 26.346 1.81307 26.9066C2.23491 27.7429 2.90803 28.4228 3.73594 28.8489C4.2909 29.1345 4.86762 29.2402 5.44746 29.288C5.99683 29.3333 6.66382 29.3333 7.43697 29.3333H24.5634C25.3365 29.3333 26.0035 29.3333 26.5529 29.288C27.1327 29.2402 27.7094 29.1345 28.2644 28.8489C29.0923 28.4228 29.7654 27.7429 30.1873 26.9066C30.47 26.346 30.5746 25.7635 30.622 25.1778C30.6669 24.6229 30.6669 23.9492 30.6668 23.1682V21.811C30.6668 21.811 30.2196 21.5504 29.9331 21.3834ZM4.26683 23.1111V22.9094C4.32046 22.8879 4.37641 22.8655 4.43462 22.8425C5.10676 22.5769 6.07704 22.2203 7.25494 21.8634C9.62285 21.1459 12.7722 20.4444 16.0002 20.4444C19.1794 20.4444 22.2946 21.309 24.6518 22.2019C25.8224 22.6453 26.7872 23.0884 27.4557 23.4187C27.5549 23.4677 27.6475 23.5142 27.7332 23.5578C27.7319 24.166 27.726 24.5949 27.6984 24.9365C27.6658 25.339 27.6106 25.4882 27.5736 25.5614C27.433 25.8402 27.2087 26.0668 26.9327 26.2089C26.8602 26.2462 26.7124 26.302 26.314 26.3349C25.8984 26.3692 25.3524 26.3703 24.5068 26.3703H7.4935C6.64789 26.3703 6.10189 26.3692 5.68632 26.3349C5.28789 26.302 5.14016 26.2462 5.06765 26.2089C4.79168 26.0668 4.5673 25.8402 4.42669 25.5614C4.38974 25.4882 4.33448 25.339 4.30193 24.9365C4.26797 24.5167 4.26683 23.9652 4.26683 23.1111Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
              {
                _key: "0b003d0fba89c554ca29eddff812e579",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "/journal",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Blog",
                        subtitle: "Get insights, tips, news, and advice.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M18 0.585815L2 16.5858V22H7.41421L23.4142 6.00003L18 0.585815ZM4 20V17.4142L14.7071 6.70714L17.2929 9.29292L6.58579 20H4Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: null,
                          toExternal: "https://www.brex.com/resources/events",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Events",
                        subtitle: "Connect with us at an event near you.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M3 4C1.34315 4 0 5.34315 0 7V9V10H1C2.10457 10 3 10.8954 3 12C3 13.1046 2.10457 14 1 14H0V15V17C0 18.6569 1.34314 20 3 20H21C22.6569 20 24 18.6569 24 17V15V14H23C21.8954 14 21 13.1046 21 12C21 10.8954 21.8954 10 23 10H24V9V7C24 5.34315 22.6569 4 21 4H3ZM2 7C2 6.44772 2.44772 6 3 6H21C21.5523 6 22 6.44772 22 7V8.12602C20.2748 8.57006 19 10.1362 19 12C19 13.8638 20.2748 15.4299 22 15.874V17C22 17.5523 21.5523 18 21 18H3C2.44772 18 2 17.5523 2 17V15.874C3.72523 15.4299 5 13.8638 5 12C5 10.1362 3.72523 8.57006 2 8.12602V7ZM13.1226 10.4549L12 7L10.8774 10.4549H7.24472L10.1836 12.5902L9.06107 16.0451L12 13.9098L14.9389 16.0451L13.8164 12.5902L16.7553 10.4549H13.1226Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "41c298baca51",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryGray",
            title: {
              text: "The latest",
              linkOnlyOnMobile: true,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: null,
                  toExternal: "https://www.brex.com/resources",
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "b77a81746138",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "4ef1a870102e",
                    _type: "articleListNavModule",
                    articles: [
                      {
                        _type: "articleListNavModuleArticle",
                        _key: "a3bd454da576",
                        page: {
                          _id: "f523bb6f-0963-42f5-b78c-b81c1c061761",
                          _type: "contentHubArticle",
                          contentHubArticleContent: {
                            articleGroup: { parent: "journal" },
                            articleImage: {
                              image: {
                                datUrl:
                                  "https://brand.brex.com/transform/dd3014e9-285b-434d-a9a6-dbf7a84e87a3/Momentum-article",
                                description: null,
                              },
                            },
                          },
                          meta: {
                            title:
                              "How Brex is doing, 10 months into founder mode",
                            slug: { current: "brex-in-founder-mode" },
                          },
                        },
                        titleOverride:
                          "How Brex is doing, 10 months into founder mode",
                        imageOverride: {
                          datUrl:
                            "https://brand.brex.com/transform/dd3014e9-285b-434d-a9a6-dbf7a84e87a3/Momentum-article",
                          description: null,
                        },
                      },
                      {
                        _type: "articleListNavModuleArticle",
                        _key: "d0704f4dffcc",
                        page: {
                          _id: "e0d5dfb7-261c-477d-b3ab-5bb7f87b8790",
                          _type: "contentHubArticle",
                          contentHubArticleContent: {
                            articleGroup: { parent: "journal" },
                            articleImage: {
                              image: {
                                datUrl:
                                  "https://brand.brex.com/transform/36d253e4-28a1-463f-be25-71b90ff2ca47/BB_navan_announcement_preview",
                                description: null,
                              },
                            },
                          },
                          meta: {
                            title:
                              "Reimagining global cards and travel management for the enterprise",
                            slug: { current: "brex-navan-partnership" },
                          },
                        },
                        titleOverride:
                          "A message from Brex and Navan’s CEOs on our new partnership",
                        imageOverride: {
                          datUrl:
                            "https://brand.brex.com/transform/554212bc-7fd2-49de-b051-8014a9f58f8a/Brex-navan-square",
                          description: null,
                        },
                      },
                      {
                        _type: "articleListNavModuleArticle",
                        _key: "1e1c801e098c",
                        page: {
                          _id: "1f69c98c-805c-4496-aa25-c43cc110b2b2",
                          _type: "corePage",
                          corePageContent: {
                            image: {
                              image: {
                                datUrl:
                                  "https://brand.brex.com/transform/3645f6cc-90e6-46d2-8042-c89a031adc2a/Fall-release_nav",
                                description: null,
                              },
                            },
                          },
                          meta: {
                            title: "Fall Release 2024: Make every dollar count",
                            slug: { current: "fall-2024" },
                          },
                        },
                        titleOverride:
                          "See what's new in Brex with Fall Release '24",
                        imageOverride: {
                          datUrl:
                            "https://brand.brex.com/transform/336e3bba-f82e-48a3-9493-8376ff6793fe/Fall-release_nav-preview",
                          description: null,
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _key: "94381d8efb96",
        _type: "navLink",
        text: "Customers",
        link: {
          to: "/customers",
          toExternal: null,
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "852f2e01f2ec39bc74c89ce6050293fc",
        _type: "navLink",
        text: "Pricing",
        link: {
          to: "",
          toExternal: "https://www.brex.com/pricing",
          noFollow: null,
          hash: null,
        },
      },
    ],
    right: [
      {
        _key: "7140f7b3727f",
        _type: "navLink",
        text: "Sign in",
        link: {
          to: null,
          toExternal: "https://dashboard.brex.com/",
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "31052062d8c7",
        _type: "navLink",
        text: "See a demo",
        link: {
          to: "/book-a-demo",
          toExternal: null,
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "55593003b8b9",
        _type: "navLink",
        text: "Sign up for free",
        link: { to: "/signup", toExternal: null, noFollow: null, hash: null },
      },
    ],
    cta: {
      text: "Control all your spend before it happens, all in one place.",
      link: {
        _key: null,
        _type: "navLink",
        text: "Get started",
        link: { to: "/sales", toExternal: null, noFollow: null, hash: null },
      },
    },
  },
  "31e38482-9546-493d-b7e0-601ed234df22": {
    _type: "navigation",
    _id: "31e38482-9546-493d-b7e0-601ed234df22",
    _updatedAt: "2025-03-06T14:05:27Z",
    title: "3/5 Navigation - Spring Release",
    mobileBreakpoint: null,
    left: [
      {
        _key: "4c3ddc93ebdc",
        _type: "navMenu",
        text: "Products",
        description: null,
        submenu: [
          {
            _key: "79e9582c4b49",
            _type: "navGroup",
            span: 2,
            theme: "PrimaryWhite",
            title: {
              text: "Products",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: null,
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "7e342c9182fa",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8b14c557e5f9",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "055b248ba3d7",
                        link: {
                          to: "/product/credit-card",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Corporate card",
                        subtitle: "Get up to 10-20x higher limits",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M0 6C0 4.34315 1.34315 3 3 3H21C22.6569 3 24 4.34315 24 6V18C24 19.6569 22.6569 21 21 21H3C1.34314 21 0 19.6569 0 18V6ZM3 5C2.44772 5 2 5.44772 2 6V16H11.1415C11.8311 16 12.472 15.6448 12.8375 15.06L14.1625 12.94C14.528 12.3552 15.1689 12 15.8585 12H22V6C22 5.44771 21.5523 5 21 5H3Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "ed0c78f23112",
                        link: {
                          to: "/product/business-account",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Business banking",
                        subtitle: "Earn yield and move money fast",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 0.922852L21.1142 4.56852C22.2531 5.02411 23 6.12724 23 7.35395V9.99988H20V15.9999H23V18.9999C23 20.6567 21.6569 21.9999 20 21.9999H4C2.34315 21.9999 1 20.6567 1 18.9999V15.9999H4V9.99988H1V7.35395C1 6.12724 1.74685 5.02411 2.88583 4.56852L12 0.922852ZM6 15.9999H11V9.99988H6V15.9999ZM13 15.9999H18V9.99988H13V15.9999ZM12 3.07692L3.62861 6.42547C3.24895 6.57734 3 6.94505 3 7.35395V7.99988H15V4.27692L12 3.07692ZM3 18.9999V17.9999H15V19.9999H4C3.44772 19.9999 3 19.5522 3 18.9999Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "0d30fe481533",
                        link: {
                          to: "/product/spend-management",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Spend management",
                        subtitle: "Eliminate manual expense work",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '    <svg\n      width="24"\n      height="24"\n      viewBox="0 0 24 24"\n      fill="none"\n      xmlns="http://www.w3.org/2000/svg"\n    >\n      <path\n        fill-rule="evenodd"\n        clip-rule="evenodd"\n        d="M23.8162 14.1036C23.937 13.4206 24 12.7177 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C12.7177 24 13.4206 23.937 14.1036 23.8162C13.3793 23.3301 12.7509 22.7122 12.2525 21.9969C12.1686 21.999 12.0844 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.0844 21.999 12.1686 21.9969 12.2525C22.7122 12.7509 23.3301 13.3793 23.8162 14.1036ZM18 24C21.3137 24 24 21.3137 24 18C24 14.6863 21.3137 12 18 12C14.6863 12 12 14.6863 12 18C12 21.3137 14.6863 24 18 24ZM19 14L15 19H17.5L17 22L21 17H18.5L19 14ZM14.9332 11.7058C14.4111 11.2654 13.7365 11 13 11H11C10.4477 11 10 10.5523 10 10C10 9.44771 10.4477 9 11 9H14V10H16V7H13V4H11V7C9.34315 7 8 8.34315 8 10C8 11.6569 9.34315 13 11 13H13C13.0325 13 13.0646 13.0016 13.0963 13.0046C13.6318 12.4789 14.2515 12.0386 14.9332 11.7058ZM11.4616 15.5338C11.5462 15.3303 11.6235 15.1443 11.6736 15H10V14H8V17H11C11 16.6443 11.253 16.0356 11.4616 15.5338L11.4616 15.5338Z"\n        fill="currentColor"\n      />\n    </svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
              {
                _key: "381f7b96912b",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "3a4115508c0b",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "b4bd1183c3f0",
                        link: {
                          to: "/product/bill-pay",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Bill pay",
                        subtitle: "Pay vendors faster and easier",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C4.34315 0 3 1.34314 3 3V21C3 22.6569 4.34315 24 6 24H18C19.6569 24 21 22.6569 21 21H19C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44771 2 6 2H14V7H19V11H21V5.58579L15.4142 0H6ZM8 11H16V13H8V11ZM12 15H8V17H12V15ZM23.6715 16L20.6914 12.4238L19.3086 13.5762L20.5785 15.1H16V16.9H20.5785L19.3086 18.4238L20.6914 19.5762L23.6715 16Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "f60fe03cd936",
                        link: {
                          to: "/product/travel-expense-management",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Travel",
                        subtitle: "Book and manage global travel",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M9 0C7.89543 0 7 0.89543 7 2V7H4H3V8V19C3 20.8819 4.2996 22.4603 6.05029 22.8866C6.2208 23.5277 6.80523 24 7.5 24C8.15311 24 8.70873 23.5826 8.91465 23H15.0854C15.2913 23.5826 15.8469 24 16.5 24C17.1948 24 17.7792 23.5277 17.9497 22.8866C19.7004 22.4603 21 20.8819 21 19V8V7H20H17V2C17 0.895431 16.1046 0 15 0H9ZM17 21C18.1046 21 19 20.1046 19 19V9H17H16H8H7H5V19C5 20.1046 5.89543 21 7 21H9H15H17ZM15 7V2L9 2V7H15ZM17 14H7V12H17V14ZM7 18H17V16H7V18Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "569a75fd4e4d",
                        link: {
                          to: "/platform/accounting-automation",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Accounting automation",
                        subtitle: "Close your books in minutes",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="fill=currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M3 2C1.89543 2 1 2.89543 1 4V17C1 18.1046 1.89543 19 3 19H9C9.53043 19 10.0391 19.2107 10.4142 19.5858C10.7893 19.9609 11 20.4696 11 21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21C13 20.4696 13.2107 19.9609 13.5858 19.5858C13.9609 19.2107 14.4696 19 15 19H21C22.1046 19 23 18.1046 23 17V4C23 2.89543 22.1046 2 21 2H16C14.6739 2 13.4021 2.52678 12.4645 3.46447C12.2962 3.63275 12.1411 3.81178 12 3.99997C11.8589 3.81178 11.7038 3.63275 11.5355 3.46447C10.5979 2.52678 9.32608 2 8 2H3ZM13 17.5359C13.6029 17.1878 14.2918 17 15 17H21V4H16C15.2044 4 14.4413 4.31607 13.8787 4.87868C13.3161 5.44129 13 6.20435 13 7V17.5359ZM11 17.5359V7C11 6.20435 10.6839 5.44129 10.1213 4.87868C9.55871 4.31607 8.79565 4 8 4H3V17H9C9.70823 17 10.3971 17.1878 11 17.5359Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "af0469f4ab57062d2d3adc5443bdfee5",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "Platform",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: null,
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "7e342c9182fa",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8b14c557e5f9",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "25420cfd0b03a9254f9b94701064cdb7",
                        link: {
                          to: "/product/embedded-finance",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Brex Embedded",
                        subtitle: "API-driven global payments",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.00004 5.3335C4.00004 3.12436 5.7909 1.3335 8.00004 1.3335H24C26.2092 1.3335 28 3.12436 28 5.3335V6.35202C28.8184 7.08445 29.3334 8.14883 29.3334 9.3335V10.352C30.1517 11.0844 30.6667 12.1488 30.6667 13.3335V26.6668C30.6667 28.876 28.8758 30.6668 26.6667 30.6668H5.33337C3.12424 30.6668 1.33337 28.876 1.33337 26.6668V13.3335C1.33337 12.1488 1.84837 11.0844 2.66671 10.352V9.3335C2.66671 8.14883 3.18171 7.08445 4.00004 6.35202V5.3335ZM24 4.00016C24.7364 4.00016 25.3334 4.59712 25.3334 5.3335H6.66671C6.66671 4.59712 7.26366 4.00016 8.00004 4.00016H24ZM25.3334 8.00016H6.66671C5.93033 8.00016 5.33337 8.59712 5.33337 9.3335H26.6667C26.6667 8.59712 26.0698 8.00016 25.3334 8.00016ZM5.33337 12.0002C4.59699 12.0002 4.00004 12.5971 4.00004 13.3335V24.0002H15.0844C15.8758 24.0002 16.6263 23.6486 17.133 23.0407L18.8671 20.9597C19.3738 20.3517 20.1243 20.0002 20.9157 20.0002H28V13.3335C28 12.5971 27.4031 12.0002 26.6667 12.0002H5.33337Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "5c9a8a4197a57f715fe90402fab034ea",
                        link: {
                          to: "/product/integrations",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Native integrations",
                        subtitle: "ERP, HRIS, productivity, security",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12.168 5.33337C12.7601 3.03307 14.8482 1.33337 17.3333 1.33337C19.8185 1.33337 21.9066 3.03307 22.4986 5.33337H29.3333V14.6667H28C26.5272 14.6667 25.3333 15.8606 25.3333 17.3334C25.3333 18.8061 26.5272 20 28 20H29.3333V29.3334H5.33333V22.4987C3.03303 21.9066 1.33333 19.8185 1.33333 17.3334C1.33333 14.8483 3.03303 12.7601 5.33333 12.1681V5.33337H12.168ZM17.3333 4.00004C15.8606 4.00004 14.6667 5.19395 14.6667 6.66671V8.00004H8V14.6667H6.66667C5.19391 14.6667 4 15.8606 4 17.3334C4 18.8061 5.19391 20 6.66667 20H8V26.6667H26.6667V22.4987C24.3664 21.9066 22.6667 19.8185 22.6667 17.3334C22.6667 14.8483 24.3664 12.7601 26.6667 12.1681V8.00004H20V6.66671C20 5.19395 18.8061 4.00004 17.3333 4.00004Z" fill="#currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "055b248ba3d7",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/platform/brex-ai",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Brex AI",
                        subtitle: "AI-powered assistant & analytics",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill=currentColor xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_6620_871)">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.97183 10.4917C5 10.8023 5.21127 11 5.50704 11C5.78873 11 6 10.8023 6.02817 10.5199C6.52016 6.78525 6.63336 6.76387 10.4983 6.03383L10.5211 6.02952C10.8028 5.98716 11 5.78947 11 5.50706C11 5.21053 10.7887 4.99872 10.5211 4.97047C6.64789 4.43389 6.52113 4.3068 6.02817 0.494223C6 0.197689 5.78873 0 5.50704 0C5.21127 0 5 0.197689 4.97183 0.508344C4.51102 4.21832 4.34094 4.25005 0.577071 4.95215L0.478873 4.97047C0.197183 5.01284 0 5.21053 0 5.50706C0 5.80359 0.197183 5.98716 0.535211 6.02952C4.35211 6.63671 4.50704 6.74968 4.97183 10.4917ZM14.5 24C14.1424 24 13.8563 23.7376 13.7967 23.3559C12.8789 16.8914 12.0088 16.0565 5.6675 15.2097C5.27415 15.162 5 14.8638 5 14.494C5 14.1243 5.27415 13.838 5.67942 13.7903C12.0326 13.0866 12.9385 12.1086 13.7967 5.64407C13.8563 5.2624 14.1305 5 14.5 5C14.8695 5 15.1437 5.2624 15.2033 5.64407C16.0972 12.1086 16.9793 13.0508 23.3325 13.7903C23.7258 13.838 24 14.1243 24 14.494C24 14.8757 23.7258 15.162 23.3325 15.2097C16.9674 15.9134 16.0615 16.8914 15.2033 23.3559C15.1437 23.7376 14.8695 24 14.5 24Z" fill=currentColor/>\n</g>\n<defs>\n<clipPath id="clip0_6620_871">\n<rect width="24" height="24" fill="white"/>\n</clipPath>\n</defs>\n</svg>',
                        },
                      },
                      {
                        _key: "0d30fe481533",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/product/global",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Global ready",
                        subtitle: "Multi-currency and multi-entity",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12 22C12.7474 22 13.7509 21.2878 14.6252 19.3644C14.9377 18.6767 15.2093 17.8808 15.4265 17H8.57345C8.79074 17.8808 9.06226 18.6767 9.37483 19.3644C10.2491 21.2878 11.2526 22 12 22ZM8.19682 15H15.8032C15.9306 14.0553 16 13.0485 16 12C16 10.9515 15.9306 9.94466 15.8032 9H8.19682C8.06943 9.94466 8 10.9515 8 12C8 13.0485 8.06943 14.0553 8.19682 15ZM8.57345 7C8.79074 6.11921 9.06226 5.32328 9.37483 4.63563C10.2491 2.71217 11.2526 2 12 2C12.7474 2 13.7509 2.71217 14.6252 4.63563C14.9377 5.32328 15.2093 6.11921 15.4265 7H8.57345ZM17.8196 9C17.9378 9.96135 18 10.9672 18 12C18 13.0328 17.9378 14.0387 17.8196 15H21.5422C21.8396 14.053 22 13.0452 22 12C22 10.9548 21.8396 9.94704 21.5422 9H17.8196ZM20.6622 7H17.48C17.2208 5.8214 16.8712 4.74364 16.4459 3.80802C16.2881 3.4608 16.1143 3.12233 15.9247 2.79955C17.9212 3.65232 19.5839 5.13598 20.6622 7ZM6.51996 7H3.33782C4.4161 5.13598 6.07877 3.65232 8.07531 2.79955C7.88574 3.12233 7.71193 3.4608 7.5541 3.80802C7.12882 4.74364 6.77917 5.8214 6.51996 7ZM2.4578 9H6.18036C6.06223 9.96135 6 10.9672 6 12C6 13.0328 6.06223 14.0387 6.18036 15H2.4578C2.16035 14.053 2 13.0452 2 12C2 10.9548 2.16035 9.94704 2.4578 9ZM16.4459 20.192C16.8712 19.2564 17.2208 18.1786 17.48 17H20.6622C19.5839 18.864 17.9212 20.3477 15.9247 21.2005C16.1143 20.8777 16.2881 20.5392 16.4459 20.192ZM8.07532 21.2005C6.07877 20.3477 4.4161 18.864 3.33782 17H6.51996C6.77917 18.1786 7.12882 19.2564 7.5541 20.192C7.71193 20.5392 7.88574 20.8777 8.07532 21.2005Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "1e2b0492bcc1",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryGray",
            title: {
              text: "New release",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: { to: "", toExternal: null, noFollow: null, hash: null },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "5860dde6ed0e",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "b3536b8af5b0",
                    _type: "linkHeroNavModule",
                    title: "Customize anything. Control everything.",
                    subtitle:
                      "Introducing custom fields, custom user roles, and an AI policy engine that can make any rule a reality. Check it out!",
                    subtitleV2Raw: null,
                    link: {
                      to: "/spring-2025",
                      toExternal: null,
                      noFollow: null,
                      hash: null,
                    },
                    icon: null,
                    media: {
                      media: {
                        type: "IMAGE",
                        datUrl:
                          "https://brand.brex.com/transform/6dab6cd4-eea3-4644-92b0-730ffb5748e7/Spring-release_nav-preview",
                        description: null,
                        aspectRatio: 0.525,
                        videoUrl: null,
                      },
                      mediaStyle: {
                        borderRadius: "6px",
                        customBorderRadius: null,
                      },
                      disableVideoLoop: false,
                    },
                    modifier: null,
                    mediaPosition: "top",
                    showMediaOnMobile: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _key: "53ce45644bd9",
        _type: "navMenu",
        text: "Solutions",
        description: null,
        submenu: [
          {
            _key: "7c4cb829ab72",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "By company size",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: { to: "", toExternal: null, noFollow: null, hash: null },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "aba2aba1f772",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "27f22e08ffc1",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "57d88210c49c",
                        link: {
                          to: "/solutions/startups",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Startups",
                        subtitle: "Get the #1 financial stack for startups",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M0 6C0 4.34315 1.34315 3 3 3H21C22.6569 3 24 4.34315 24 6V18C24 19.6569 22.6569 21 21 21H3C1.34314 21 0 19.6569 0 18V6ZM3 5C2.44772 5 2 5.44772 2 6V16H11.1415C11.8311 16 12.472 15.6448 12.8375 15.06L14.1625 12.94C14.528 12.3552 15.1689 12 15.8585 12H22V6C22 5.44771 21.5523 5 21 5H3Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "72d93b76bb04",
                        link: {
                          to: "/solutions/mid-size-companies",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Mid-sized companies",
                        subtitle: "Scale faster with smart cards & controls",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M13.5629 4.89329C11.6112 4.24273 9.46846 4.52968 7.75671 5.67085L5.92707 6.89061L4.26297 8.00001L5.92707 9.10941L10.263 12L8.51064 13.1682L5.82852 12.0954L5.37504 11.914L4.9117 12.0684L2.95837 12.7195C1.07774 13.3464 0.514287 15.7332 1.91602 17.135L4.64044 19.8594C7.27459 22.4935 11.3783 22.9609 14.5373 20.9865L29.8507 11.4157C31.3672 10.4678 31.5393 8.32517 30.1933 7.14748L29.5796 6.61049C27.1349 4.47137 23.6394 4.02293 20.7339 5.47569L18.5644 6.56045L13.5629 4.89329ZM9.23591 7.88965C10.263 7.20495 11.5486 7.03277 12.7196 7.42311L18.245 9.26492L18.769 9.43957L19.263 9.19258L21.9265 7.86083C23.8635 6.89232 26.1938 7.19128 27.8236 8.61736L28.4373 9.15435L13.124 18.7252C11.018 20.0415 8.28216 19.7299 6.52606 17.9738L3.80164 15.2494L5.29162 14.7527L8.17148 15.9046L8.82269 16.1651L9.40627 15.7761L13.4063 13.1094L15.0704 12L13.4063 10.8906L9.07037 8.00001L9.23591 7.88965ZM2.66667 28H21.3333V25.3333H2.66667V28Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                      {
                        _key: "751c09fb19d7",
                        link: {
                          to: "/solutions/enterprise",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Enterprise",
                        subtitle: "Spend smart across entities, currencies",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="33" height="32" viewBox="0 0 33 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 0C6.29086 0 4.5 1.79086 4.5 4V30V31.924L6.3015 31.2484L8.42376 30.4526L10.5704 31.5259L11.1667 31.824L11.763 31.5259L13.8333 30.4907L15.9037 31.5259L16.5 31.824L17.0963 31.5259L19.1667 30.4907L21.237 31.5259L21.8333 31.824L22.4296 31.5259L24.5762 30.4526L26.6985 31.2484L28.5 31.924V30V4C28.5 1.79086 26.7091 0 24.5 0H8.5ZM7.16667 4C7.16667 3.26362 7.76362 2.66667 8.5 2.66667H24.5C25.2364 2.66667 25.8333 3.26362 25.8333 4V28.076L24.9682 27.7516L24.4238 27.5474L23.9037 27.8074L21.8333 28.8426L19.763 27.8074L19.1667 27.5093L18.5704 27.8074L16.5 28.8426L14.4296 27.8074L13.8333 27.5093L13.237 27.8074L11.1667 28.8426L9.09628 27.8074L8.57624 27.5474L8.03184 27.7516L7.16667 28.076V4ZM19.1667 8H13.8333V5.33333H19.1667V8ZM21.8333 13.3333H11.1667V10.6667H21.8333V13.3333ZM11.1667 18.6667H21.8333V16H11.1667V18.6667ZM16.5 24V21.3333H21.8333V24H16.5Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "b6f631dcf896",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "For partners",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: {
                  to: null,
                  toExternal: null,
                  noFollow: false,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: false,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "32731f9ee7ac",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "3362e675a734",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "d5fde9919472",
                        link: {
                          to: "/partners/accounting",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Accounting firms",
                        subtitle: "Simplify close and earn rewards",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M10.6667 4C7.35296 4 4.66667 6.68629 4.66667 10C4.66667 13.3137 7.35296 16 10.6667 16C13.9804 16 16.6667 13.3137 16.6667 10C16.6667 6.68629 13.9804 4 10.6667 4ZM7.33334 10C7.33334 8.15905 8.82572 6.66667 10.6667 6.66667C12.5076 6.66667 14 8.15905 14 10C14 11.8409 12.5076 13.3333 10.6667 13.3333C8.82572 13.3333 7.33334 11.8409 7.33334 10Z" fill="currentColor"/>\n<path d="M18.3334 10C18.3334 11.6533 17.7863 13.1788 16.8632 14.4054C17.8308 15.3896 19.1774 16 20.6667 16C23.6122 16 26 13.6122 26 10.6667C26 7.72115 23.6122 5.33333 20.6667 5.33333C19.4418 5.33333 18.3134 5.74623 17.4131 6.44042C17.9994 7.49451 18.3334 8.70825 18.3334 10Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M21.3333 21.4744V28H5.54861C4.84575 28 4.23939 28 3.73997 27.9592C3.21284 27.9162 2.68855 27.8211 2.18404 27.564C1.43139 27.1805 0.81947 26.5686 0.435976 25.816C0.178918 25.3115 0.0838297 24.7872 0.0407617 24.26C-4.33574e-05 23.7606 -2.2695e-05 23.1543 1.14681e-06 22.4514V20.7201C0.865588 19.9782 0.310448 20.4539 0.466628 20.3201L0.467715 20.3192C0.489714 20.3005 0.51208 20.2821 0.534606 20.264C0.570185 20.2355 0.618371 20.1977 0.679169 20.1521C0.800747 20.0609 0.972894 19.9383 1.19566 19.7951C1.64114 19.5087 2.28971 19.1395 3.14144 18.7745C4.84824 18.043 7.35963 17.3333 10.6667 17.3333C14.0255 17.3333 16.5734 18.2351 18.2963 19.158C19.1553 19.6182 19.807 20.0823 20.2519 20.4398C20.4744 20.6187 20.6458 20.7713 20.7661 20.8841C20.8263 20.9405 20.8737 20.987 20.9084 21.0219C20.9258 21.0393 20.94 21.0539 20.9511 21.0653L20.9706 21.0858L20.9728 21.0882L20.9738 21.0893C21.1327 21.2595 20.6069 20.6962 21.3333 21.4744ZM2.66667 22.0197V22.4C2.66667 23.1687 2.66771 23.6651 2.69857 24.0429C2.72817 24.4051 2.7784 24.5394 2.81199 24.6053C2.93982 24.8562 3.1438 25.0602 3.39468 25.188C3.46061 25.2216 3.5949 25.2718 3.95712 25.3014C4.3349 25.3323 4.83126 25.3333 5.6 25.3333H18.6667V22.588C18.6398 22.5657 18.6114 22.5425 18.5815 22.5185C18.2486 22.251 17.7336 21.8818 17.037 21.5086C15.6488 20.7649 13.53 20 10.6667 20C7.75149 20 5.59621 20.6237 4.19189 21.2255C3.50822 21.5185 2.99978 21.8076 2.66667 22.0197Z" fill="currentColor"/>\n<path d="M22.6667 21.2174V28H27.7333C29.2268 28 29.9736 28 30.544 27.7094C31.0458 27.4537 31.4537 27.0457 31.7094 26.544C32 25.9735 32 25.2268 32 23.7333V20.6667C32 20.6667 27.5556 17.3333 21.3333 17.3333C20.0653 17.3333 18.9264 17.4441 17.9168 17.6205C21.0834 19.1522 22.6667 21.2174 22.6667 21.2174Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "102d59011244",
                        link: {
                          to: "/product/embedded-finance",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "B2B software",
                        subtitle: "Embed Brex cards in your products",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.00004 5.3335C4.00004 3.12436 5.7909 1.3335 8.00004 1.3335H24C26.2092 1.3335 28 3.12436 28 5.3335V6.35202C28.8184 7.08445 29.3334 8.14883 29.3334 9.3335V10.352C30.1517 11.0844 30.6667 12.1488 30.6667 13.3335V26.6668C30.6667 28.876 28.8758 30.6668 26.6667 30.6668H5.33337C3.12424 30.6668 1.33337 28.876 1.33337 26.6668V13.3335C1.33337 12.1488 1.84837 11.0844 2.66671 10.352V9.3335C2.66671 8.14883 3.18171 7.08445 4.00004 6.35202V5.3335ZM24 4.00016C24.7364 4.00016 25.3334 4.59712 25.3334 5.3335H6.66671C6.66671 4.59712 7.26366 4.00016 8.00004 4.00016H24ZM25.3334 8.00016H6.66671C5.93033 8.00016 5.33337 8.59712 5.33337 9.3335H26.6667C26.6667 8.59712 26.0698 8.00016 25.3334 8.00016ZM5.33337 12.0002C4.59699 12.0002 4.00004 12.5971 4.00004 13.3335V24.0002H15.0844C15.8758 24.0002 16.6263 23.6486 17.133 23.0407L18.8671 20.9597C19.3738 20.3517 20.1243 20.0002 20.9157 20.0002H28V13.3335C28 12.5971 27.4031 12.0002 26.6667 12.0002H5.33337Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _key: "3adc58d91a4b",
        _type: "navMenu",
        text: "Resources",
        description: null,
        submenu: [
          {
            _key: "79d0fdf35784",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "Customer Hub",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: "/customer-hub",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "86ec301ad222",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "/support",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Help Center",
                        subtitle: "Find answers to common questions.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M10.5 17.5C10.5 16.6716 11.1716 16 12 16C12.8284 16 13.5 16.6716 13.5 17.5C13.5 18.3284 12.8284 19 12 19C11.1716 19 10.5 18.3284 10.5 17.5Z" fill="currentColor"/>\n<path d="M12 5C9.79086 5 8 6.79086 8 9H10C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9V9.39445C14 10.0632 13.6658 10.6876 13.1094 11.0585L12.7812 11.2774C11.6684 12.0192 11 13.2681 11 14.6056V15H13V14.6056C13 13.9368 13.3342 13.3124 13.8906 12.9415L14.2188 12.7226C15.3316 11.9808 16 10.7319 16 9.39445V9C16 6.79086 14.2091 5 12 5Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/implementation",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Implementation guides",
                        subtitle: "Learn how to set up key features.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_5399_39609)">\n<path d="M9 12V10H13V16H15V18H9V16H11V12H9Z" fill="currentColor"/>\n<path d="M12 9C12.8284 9 13.5 8.32843 13.5 7.5C13.5 6.67157 12.8284 6 12 6C11.1716 6 10.5 6.67157 10.5 7.5C10.5 8.32843 11.1716 9 12 9Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor"/>\n</g>\n<defs>\n<clipPath id="clip0_5399_39609">\n<rect width="24" height="24" fill="currentColor"/>\n</clipPath>\n</defs>\n</svg>\n',
                        },
                      },
                      {
                        _key: "78c4db945bb1",
                        link: {
                          to: "/release",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Product releases",
                        subtitle: "See what’s new at Brex",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m26.6667 2.66675v4 3.99995c1.4145 0 2.771.562 3.7712 1.5621 1.0002 1.0002 1.5621 2.3568 1.5621 3.7713s-.5619 2.771-1.5621 3.7712-2.3567 1.5621-3.7712 1.5621v4 4h-2.6667v-2.8705l-9.4081-1.568c-.4256 2.5195-2.618 4.4386-5.25857 4.4386-2.94551 0-5.33333-2.3879-5.33333-5.3334 0-.292.02359-.579.06902-.859l-.72662-.1211c-1.92875-.3215-3.3424-1.9902-3.3424-3.9456v-6.1486c0-1.9554 1.41365-3.62416 3.3424-3.94562l20.6576-3.44293v-2.8705zm-19.96724 20.91275 5.26164.8769c-.2165 1.2554-1.3106 2.2104-2.62777 2.2104-1.47276 0-2.66666-1.1939-2.66666-2.6667 0-.1435.01122-.2839.03279-.4206zm17.30054-15.3388-20.2192 3.3699c-.64292.1071-1.11413.6634-1.11413 1.3152v6.1486c0 .6518.47121 1.208 1.11413 1.3152l20.2192 3.3699z" fill="currentColor" fill-rule="evenodd"/></svg>',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "4ce7782d1713ef14f57e6d62fb24e62e",
            _type: "navGroup",
            span: 2,
            theme: "PrimaryWhite",
            title: {
              text: "Resource Center",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: "/resources",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "86ec301ad222",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/resources/ebooks",
                          noFollow: null,
                          hash: null,
                        },
                        text: "White papers and e-books",
                        subtitle: "Access exclusive research and reports.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="33" height="32" viewBox="0 0 33 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M21.8333 18.6667V16H11.1667V18.6667H21.8333Z" fill="currentColor"/>\n<path d="M11.1667 24V21.3333H21.8333V24H11.1667Z" fill="currentColor"/>\n<path d="M16.5 6.66667H11.1667V9.33333H16.5V6.66667Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 4C4.5 1.79086 6.29086 0 8.5 0H21.0523L28.5 7.44772V28C28.5 30.2091 26.7091 32 24.5 32H8.5C6.29086 32 4.5 30.2091 4.5 28V4ZM8.5 2.66667C7.76362 2.66667 7.16667 3.26362 7.16667 4V28C7.16667 28.7364 7.76362 29.3333 8.5 29.3333H24.5C25.2364 29.3333 25.8333 28.7364 25.8333 28V9.33333H19.1667V2.66667H8.5Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: null,
                          toExternal: "https://www.brex.com/resources/webinars",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Webinars",
                        subtitle: "Tune in for actionable insights.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="21" viewBox="0 0 24 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M2.47117 16.9754C1.70016 16.9754 1.0939 16.758 0.652389 16.3231C0.217463 15.8815 0 15.272 0 14.4944V2.59324C0 1.81565 0.217463 1.20938 0.652389 0.774459C1.0939 0.339533 1.70016 0.12207 2.47117 0.12207H21.5288C22.2998 0.12207 22.9028 0.339533 23.3377 0.774459C23.7792 1.20938 24 1.81565 24 2.59324V14.4944C24 15.272 23.7792 15.8815 23.3377 16.3231C22.9028 16.758 22.2998 16.9754 21.5288 16.9754H2.47117ZM2.31301 12.3988H21.6771C21.9605 12.3988 22.1021 12.2605 22.1021 11.9837V2.71186C22.1021 2.49439 22.0395 2.32635 21.9143 2.20774C21.7891 2.08253 21.6244 2.01993 21.4201 2.01993H2.5799C2.37562 2.01993 2.21087 2.08253 2.08567 2.20774C1.96046 2.32635 1.89786 2.49439 1.89786 2.71186V11.9837C1.89786 12.2605 2.03624 12.3988 2.31301 12.3988ZM9 19V15.8792H15V19.0117L9 19ZM8.72817 20.5537C8.47776 20.5537 8.26359 20.4647 8.08567 20.2868C7.91433 20.1089 7.82867 19.898 7.82867 19.6542C7.82867 19.4038 7.91433 19.1896 8.08567 19.0117C8.26359 18.8404 8.47776 18.7547 8.72817 18.7547H15.2718C15.5222 18.7547 15.7331 18.8404 15.9044 19.0117C16.0758 19.1896 16.1614 19.4038 16.1614 19.6542C16.1614 19.898 16.0758 20.1089 15.9044 20.2868C15.7331 20.4647 15.5222 20.5537 15.2718 20.5537H8.72817Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "78c4db945bb1",
                        link: {
                          to: "",
                          toExternal:
                            "https://www.brex.com/resources/case-studies",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Customer stories",
                        subtitle: "See how top companies use Brex.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M16.0002 2.66663C12.3551 2.66663 9.40016 5.65139 9.40016 9.33329C9.40016 13.0152 12.3551 16 16.0002 16C19.6452 16 22.6002 13.0152 22.6002 9.33329C22.6002 5.65139 19.6452 2.66663 16.0002 2.66663ZM12.3335 9.33329C12.3335 7.28779 13.9751 5.62959 16.0002 5.62959C18.0252 5.62959 19.6668 7.28779 19.6668 9.33329C19.6668 11.3788 18.0252 13.037 16.0002 13.037C13.9751 13.037 12.3335 11.3788 12.3335 9.33329Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M29.9331 21.3834L29.9296 21.3814L29.9238 21.378L29.9052 21.3673L29.8407 21.3307C29.7858 21.2998 29.7072 21.2562 29.6063 21.2016C29.4046 21.0924 29.1135 20.9394 28.7446 20.7571C28.0076 20.393 26.9557 19.9101 25.6818 19.4276C23.1502 18.4687 19.6654 17.4814 16.0002 17.4814C12.3836 17.4814 8.93303 18.2615 6.41205 19.0254C5.14551 19.4092 4.09913 19.7934 3.36571 20.0833C2.99871 20.2284 2.70925 20.3501 2.50888 20.4369C2.40867 20.4803 2.33066 20.5149 2.27631 20.5394L2.21268 20.5682L2.19448 20.5766L2.18885 20.5792L2.18691 20.5801C2.17992 20.5834 2.18555 20.5808 2.18555 20.5808L1.3335 20.978V23.1682C1.33347 23.9491 1.33345 24.6229 1.37834 25.1778C1.42571 25.7635 1.53031 26.346 1.81307 26.9066C2.23491 27.7429 2.90803 28.4228 3.73594 28.8489C4.2909 29.1345 4.86762 29.2402 5.44746 29.288C5.99683 29.3333 6.66382 29.3333 7.43697 29.3333H24.5634C25.3365 29.3333 26.0035 29.3333 26.5529 29.288C27.1327 29.2402 27.7094 29.1345 28.2644 28.8489C29.0923 28.4228 29.7654 27.7429 30.1873 26.9066C30.47 26.346 30.5746 25.7635 30.622 25.1778C30.6669 24.6229 30.6669 23.9492 30.6668 23.1682V21.811C30.6668 21.811 30.2196 21.5504 29.9331 21.3834ZM4.26683 23.1111V22.9094C4.32046 22.8879 4.37641 22.8655 4.43462 22.8425C5.10676 22.5769 6.07704 22.2203 7.25494 21.8634C9.62285 21.1459 12.7722 20.4444 16.0002 20.4444C19.1794 20.4444 22.2946 21.309 24.6518 22.2019C25.8224 22.6453 26.7872 23.0884 27.4557 23.4187C27.5549 23.4677 27.6475 23.5142 27.7332 23.5578C27.7319 24.166 27.726 24.5949 27.6984 24.9365C27.6658 25.339 27.6106 25.4882 27.5736 25.5614C27.433 25.8402 27.2087 26.0668 26.9327 26.2089C26.8602 26.2462 26.7124 26.302 26.314 26.3349C25.8984 26.3692 25.3524 26.3703 24.5068 26.3703H7.4935C6.64789 26.3703 6.10189 26.3692 5.68632 26.3349C5.28789 26.302 5.14016 26.2462 5.06765 26.2089C4.79168 26.0668 4.5673 25.8402 4.42669 25.5614C4.38974 25.4882 4.33448 25.339 4.30193 24.9365C4.26797 24.5167 4.26683 23.9652 4.26683 23.1111Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
              {
                _key: "0b003d0fba89c554ca29eddff812e579",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "/journal",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Blog",
                        subtitle: "Get insights, tips, news, and advice.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M18 0.585815L2 16.5858V22H7.41421L23.4142 6.00003L18 0.585815ZM4 20V17.4142L14.7071 6.70714L17.2929 9.29292L6.58579 20H4Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: null,
                          toExternal: "https://www.brex.com/resources/events",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Events",
                        subtitle: "Connect with us at an event near you.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M3 4C1.34315 4 0 5.34315 0 7V9V10H1C2.10457 10 3 10.8954 3 12C3 13.1046 2.10457 14 1 14H0V15V17C0 18.6569 1.34314 20 3 20H21C22.6569 20 24 18.6569 24 17V15V14H23C21.8954 14 21 13.1046 21 12C21 10.8954 21.8954 10 23 10H24V9V7C24 5.34315 22.6569 4 21 4H3ZM2 7C2 6.44772 2.44772 6 3 6H21C21.5523 6 22 6.44772 22 7V8.12602C20.2748 8.57006 19 10.1362 19 12C19 13.8638 20.2748 15.4299 22 15.874V17C22 17.5523 21.5523 18 21 18H3C2.44772 18 2 17.5523 2 17V15.874C3.72523 15.4299 5 13.8638 5 12C5 10.1362 3.72523 8.57006 2 8.12602V7ZM13.1226 10.4549L12 7L10.8774 10.4549H7.24472L10.1836 12.5902L9.06107 16.0451L12 13.9098L14.9389 16.0451L13.8164 12.5902L16.7553 10.4549H13.1226Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "41c298baca51",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryGray",
            title: {
              text: "The latest",
              linkOnlyOnMobile: true,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: null,
                  toExternal: "https://www.brex.com/resources",
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "b77a81746138",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "4ef1a870102e",
                    _type: "articleListNavModule",
                    articles: [
                      {
                        _type: "articleListNavModuleArticle",
                        _key: "1e1c801e098c",
                        page: {
                          _id: "06924345-b369-47ad-b5bf-2e068215a62d",
                          _type: "corePage",
                          corePageContent: {
                            image: {
                              image: {
                                datUrl:
                                  "https://brand.brex.com/transform/6dab6cd4-eea3-4644-92b0-730ffb5748e7/Spring-release_nav-preview",
                                description: null,
                              },
                            },
                          },
                          meta: {
                            title:
                              "Spring Release 2025: Customize anything. Control everything.",
                            slug: { current: "spring-2025" },
                          },
                        },
                        titleOverride:
                          "See what's new in Brex with Spring Release '25",
                        imageOverride: {
                          datUrl:
                            "https://brand.brex.com/transform/6dab6cd4-eea3-4644-92b0-730ffb5748e7/Spring-release_nav-preview",
                          description: null,
                        },
                      },
                      {
                        _type: "articleListNavModuleArticle",
                        _key: "28a79935d2a9",
                        page: {
                          _id: "6c4d3172-fdf7-45b5-ad53-d693525af800",
                          _type: "contentHubArticle",
                          contentHubArticleContent: {
                            articleGroup: { parent: "resources" },
                            articleImage: {
                              image: {
                                datUrl:
                                  "https://brand.brex.com/transform/da4bd18e-e32c-4f5d-a214-1dead8692061/controllers-guide-preview",
                                description: null,
                              },
                            },
                          },
                          meta: {
                            title:
                              "The controller's guide to overcoming the accountant shortage",
                            slug: {
                              current:
                                "the-controllers-guide-to-overcoming-the-accountant-shortage",
                            },
                          },
                        },
                        titleOverride:
                          "A guide to overcoming the accountant shortage in 2025",
                        imageOverride: {
                          datUrl:
                            "https://brand.brex.com/transform/da4bd18e-e32c-4f5d-a214-1dead8692061/controllers-guide-preview",
                          description: null,
                        },
                      },
                      {
                        _type: "articleListNavModuleArticle",
                        _key: "d0704f4dffcc",
                        page: {
                          _id: "511d3805-a7a6-4618-b66a-81a98a42ee8f",
                          _type: "contentHubArticle",
                          contentHubArticleContent: {
                            articleGroup: { parent: "journal" },
                            articleImage: {
                              image: { datUrl: null, description: null },
                            },
                          },
                          meta: {
                            title:
                              "How billions in spend led to a modern bill pay solution",
                            slug: {
                              current: "building-a-modern-bill-pay-solution",
                            },
                          },
                        },
                        titleOverride:
                          "How billions in spend led to a modern bill pay solution",
                        imageOverride: {
                          datUrl:
                            "https://brand.brex.com/transform/6ca0df08-d2a7-416d-b45d-598bc505978e/sem-billpay-hero",
                          description: null,
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _key: "94381d8efb96",
        _type: "navLink",
        text: "Customers",
        link: {
          to: "/customers",
          toExternal: null,
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "852f2e01f2ec39bc74c89ce6050293fc",
        _type: "navLink",
        text: "Pricing",
        link: {
          to: "",
          toExternal: "https://www.brex.com/pricing",
          noFollow: null,
          hash: null,
        },
      },
    ],
    right: [
      {
        _key: "7140f7b3727f",
        _type: "navLink",
        text: "Sign in",
        link: {
          to: null,
          toExternal: "https://dashboard.brex.com/",
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "31052062d8c7",
        _type: "navLink",
        text: "See a demo",
        link: {
          to: "/book-a-demo",
          toExternal: null,
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "55593003b8b9",
        _type: "navLink",
        text: "Get started",
        link: { to: "/signup", toExternal: null, noFollow: null, hash: null },
      },
    ],
    cta: {
      text: "Control all your spend before it happens, all in one place.",
      link: {
        _key: null,
        _type: "navLink",
        text: "Get started",
        link: { to: "/sales", toExternal: null, noFollow: null, hash: null },
      },
    },
  },
  "6ae76fe8-8983-4875-9206-a76ecaf9100e": {
    _type: "navigation",
    _id: "6ae76fe8-8983-4875-9206-a76ecaf9100e",
    _updatedAt: "2024-02-29T16:19:34Z",
    title: "Get started experiment Navigation",
    mobileBreakpoint: null,
    left: [
      {
        _key: "64ce3574d113",
        _type: "navMenu",
        text: "Products",
        description: null,
        submenu: [
          {
            _key: "3a2d928fefab",
            _type: "navGroup",
            span: 3,
            theme: "PrimaryWhite",
            title: {
              text: "Products",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: null,
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "7a8585f6444e",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "eb1e5829a360",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "a2f449088d7e",
                        link: {
                          to: null,
                          toExternal:
                            "https://www.brex.com/product/spend-management",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Expense management",
                        subtitle: "Manage all spend and reimbursements.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '    <svg\n      width="24"\n      height="24"\n      viewBox="0 0 24 24"\n      fill="none"\n      xmlns="http://www.w3.org/2000/svg"\n    >\n      <path\n        fill-rule="evenodd"\n        clip-rule="evenodd"\n        d="M23.8162 14.1036C23.937 13.4206 24 12.7177 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C12.7177 24 13.4206 23.937 14.1036 23.8162C13.3793 23.3301 12.7509 22.7122 12.2525 21.9969C12.1686 21.999 12.0844 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.0844 21.999 12.1686 21.9969 12.2525C22.7122 12.7509 23.3301 13.3793 23.8162 14.1036ZM18 24C21.3137 24 24 21.3137 24 18C24 14.6863 21.3137 12 18 12C14.6863 12 12 14.6863 12 18C12 21.3137 14.6863 24 18 24ZM19 14L15 19H17.5L17 22L21 17H18.5L19 14ZM14.9332 11.7058C14.4111 11.2654 13.7365 11 13 11H11C10.4477 11 10 10.5523 10 10C10 9.44771 10.4477 9 11 9H14V10H16V7H13V4H11V7C9.34315 7 8 8.34315 8 10C8 11.6569 9.34315 13 11 13H13C13.0325 13 13.0646 13.0016 13.0963 13.0046C13.6318 12.4789 14.2515 12.0386 14.9332 11.7058ZM11.4616 15.5338C11.5462 15.3303 11.6235 15.1443 11.6736 15H10V14H8V17H11C11 16.6443 11.253 16.0356 11.4616 15.5338L11.4616 15.5338Z"\n        fill="currentColor"\n      />\n    </svg>\n',
                        },
                      },
                      {
                        _key: "f57205c3eb25",
                        link: {
                          to: null,
                          toExternal: "https://www.brex.com/product/travel",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Travel",
                        subtitle: "Search, book, and control global travel.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M9 0C7.89543 0 7 0.89543 7 2V7H4H3V8V19C3 20.8819 4.2996 22.4603 6.05029 22.8866C6.2208 23.5277 6.80523 24 7.5 24C8.15311 24 8.70873 23.5826 8.91465 23H15.0854C15.2913 23.5826 15.8469 24 16.5 24C17.1948 24 17.7792 23.5277 17.9497 22.8866C19.7004 22.4603 21 20.8819 21 19V8V7H20H17V2C17 0.895431 16.1046 0 15 0H9ZM17 21C18.1046 21 19 20.1046 19 19V9H17H16H8H7H5V19C5 20.1046 5.89543 21 7 21H9H15H17ZM15 7V2L9 2V7H15ZM17 14H7V12H17V14ZM7 18H17V16H7V18Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "36c2ed370dde",
                        link: {
                          to: "/product/credit-card",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Global corporate card",
                        subtitle: "Cards for procurement, T&E, vendors.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M0 6C0 4.34315 1.34315 3 3 3H21C22.6569 3 24 4.34315 24 6V18C24 19.6569 22.6569 21 21 21H3C1.34314 21 0 19.6569 0 18V6ZM3 5C2.44772 5 2 5.44772 2 6V16H11.1415C11.8311 16 12.472 15.6448 12.8375 15.06L14.1625 12.94C14.528 12.3552 15.1689 12 15.8585 12H22V6C22 5.44771 21.5523 5 21 5H3Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
              {
                _key: "61b0f8b1858e",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "853cb95d4f81",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "880484d02c6b",
                        link: {
                          to: "/product/bill-pay",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Bill pay",
                        subtitle: "Automate AP workflows with AI.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C4.34315 0 3 1.34314 3 3V21C3 22.6569 4.34315 24 6 24H18C19.6569 24 21 22.6569 21 21H19C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44771 2 6 2H14V7H19V11H21V5.58579L15.4142 0H6ZM8 11H16V13H8V11ZM12 15H8V17H12V15ZM23.6715 16L20.6914 12.4238L19.3086 13.5762L20.5785 15.1H16V16.9H20.5785L19.3086 18.4238L20.6914 19.5762L23.6715 16Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "d8e4c816e453",
                        link: {
                          to: "/product/venture-debt",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Venture debt",
                        subtitle: "Founder-friendly financing options.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M3 4C1.34315 4 0 5.34315 0 7V17C0 18.6569 1.34314 20 3 20H12H21C22.6569 20 24 18.6569 24 17V7C24 5.34315 22.6569 4 21 4H12H3ZM8.69272 6H5C5 6.39397 4.9224 6.78407 4.77164 7.14805C4.62087 7.51203 4.3999 7.84274 4.12132 8.12132C3.84274 8.3999 3.51203 8.62087 3.14805 8.77164C2.78407 8.9224 2.39397 9 2 9V15C2.39397 15 2.78407 15.0776 3.14805 15.2284C3.51203 15.3791 3.84274 15.6001 4.12132 15.8787C4.3999 16.1573 4.62087 16.488 4.77164 16.8519C4.9224 17.2159 5 17.606 5 18H8.69272C7.65469 16.5341 7 14.3894 7 12C7 9.61061 7.65469 7.46589 8.69272 6ZM12 18C11.5577 18 10.8547 17.7076 10.1605 16.5969C9.48386 15.5143 9 13.8943 9 12C9 10.1057 9.48386 8.48571 10.1605 7.40314C10.8547 6.29238 11.5577 6 12 6C12.4423 6 13.1453 6.29238 13.8395 7.40314C14.5161 8.48571 15 10.1057 15 12C15 13.8943 14.5161 15.5143 13.8395 16.5969C13.1453 17.7076 12.4423 18 12 18ZM15.3073 18C16.3453 16.5341 17 14.3894 17 12C17 9.61061 16.3453 7.46589 15.3073 6H19C19 6.39397 19.0776 6.78407 19.2284 7.14805C19.3791 7.51203 19.6001 7.84274 19.8787 8.12132C20.1573 8.3999 20.488 8.62087 20.8519 8.77164C21.2159 8.9224 21.606 9 22 9V15C21.606 15 21.2159 15.0776 20.8519 15.2284C20.488 15.3791 20.1573 15.6001 19.8787 15.8787C19.6001 16.1573 19.3791 16.488 19.2284 16.8519C19.0776 17.2159 19 17.606 19 18H15.3073Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "12c5c38770e1",
                        link: {
                          to: null,
                          toExternal:
                            "https://www.brex.com/product/financial-modeling",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Financial modeling",
                        subtitle: "Forecast runway, make KPI dashboards.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M5.33335 23.2189V26.6666H29.3334V29.3333H2.66669V2.66663H5.33335V19.4477L13.3334 11.4477L17.3334 15.4477L27.0572 5.72382L28.9428 7.60944L17.3334 19.2189L13.3334 15.2189L5.33335 23.2189Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
              {
                _key: "e4e01cc76a77",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "56078aba9875",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "ac20bc7c8f8c",
                        link: {
                          to: "/product/business-account",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Business account",
                        subtitle: "Store and move your funds safely.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 0.922852L21.1142 4.56852C22.2531 5.02411 23 6.12724 23 7.35395V9.99988H20V15.9999H23V18.9999C23 20.6567 21.6569 21.9999 20 21.9999H4C2.34315 21.9999 1 20.6567 1 18.9999V15.9999H4V9.99988H1V7.35395C1 6.12724 1.74685 5.02411 2.88583 4.56852L12 0.922852ZM6 15.9999H11V9.99988H6V15.9999ZM13 15.9999H18V9.99988H13V15.9999ZM12 3.07692L3.62861 6.42547C3.24895 6.57734 3 6.94505 3 7.35395V7.99988H15V4.27692L12 3.07692ZM3 18.9999V17.9999H15V19.9999H4C3.44772 19.9999 3 19.5522 3 18.9999Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "4e818a2414f0",
                        link: {
                          to: "/product/mobile",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Mobile",
                        subtitle: "Available on iOS and Android.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M7 0C5.34315 0 4 1.34314 4 3V21C4 22.6569 5.34315 24 7 24H17C18.6569 24 20 22.6569 20 21V3C20 1.34315 18.6569 0 17 0H7ZM6 3C6 2.44772 6.44771 2 7 2H17C17.5523 2 18 2.44772 18 3V21C18 21.5523 17.5523 22 17 22H7C6.44772 22 6 21.5523 6 21V3ZM12 20C13.1046 20 14 19.1046 14 18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18C10 19.1046 10.8954 20 12 20Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "e65eec8370de",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryGray",
            title: {
              text: "Product announcements",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: null,
                  toExternal: "https://www.brex.com/product-announcements",
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "b2821163f1d1",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "16a2798af0a9",
                    _type: "linkHeroNavModule",
                    title: "Introducing Brex payables",
                    subtitle:
                      "Control procurement spend, invoiced or otherwise, with AI-backed bill pay and p-cards.",
                    subtitleV2Raw: null,
                    link: {
                      to: null,
                      toExternal: "https://www.brex.com/solutions/payables",
                      noFollow: null,
                      hash: null,
                    },
                    icon: null,
                    media: {
                      media: {
                        type: "IMAGE",
                        datUrl:
                          "https://brand.brex.com/transform/6562e8bd-4abd-4e65-b8a8-d43685cba560/Payables-Nav-Product-Announcement",
                        description: null,
                        aspectRatio: 0.605,
                        videoUrl: null,
                      },
                      mediaStyle: {
                        borderRadius: "6px",
                        customBorderRadius: null,
                      },
                      disableVideoLoop: false,
                    },
                    modifier: null,
                    mediaPosition: "top",
                    showMediaOnMobile: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _key: "d0694e92a679",
        _type: "navLink",
        text: "Global",
        link: {
          to: null,
          toExternal: "https://www.brex.com/product/global",
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "daba11eda463",
        _type: "navLink",
        text: "Startups",
        link: {
          to: null,
          toExternal: "https://www.brex.com/solutions/startups",
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "a38a0a7966aa",
        _type: "navMenu",
        text: "Resources",
        description: null,
        submenu: [
          {
            _key: "f02e2d8e1a42",
            _type: "navGroup",
            span: 2,
            theme: "PrimaryWhite",
            title: {
              text: "Resources",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: null,
            },
            addSpacerAfterOnMobile: false,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "98ababbcc102",
                _type: "navColumn",
                span: 2,
                modules: [
                  {
                    _key: "7c65632f83ed",
                    _type: "linkHeroNavModule",
                    title: "Resource center",
                    subtitle:
                      "Get results with actionable guides, case studies, webinars, and more.",
                    subtitleV2Raw: null,
                    link: {
                      to: null,
                      toExternal: "https://www.brex.com/resources",
                      noFollow: null,
                      hash: null,
                    },
                    icon: null,
                    media: {
                      media: {
                        type: "IMAGE",
                        datUrl:
                          "https://brand.brex.com/transform/d46f490e-c6e2-4f4c-b777-0230a2655d83/Resources",
                        description: null,
                        aspectRatio: 0.6325,
                        videoUrl: null,
                      },
                      mediaStyle: {
                        borderRadius: "6px",
                        customBorderRadius: null,
                      },
                      disableVideoLoop: false,
                    },
                    modifier: null,
                    mediaPosition: "top",
                    showMediaOnMobile: false,
                  },
                  {
                    _key: "f17ddfd37d93",
                    _type: "linkHeroNavModule",
                    title: "Blog",
                    subtitle: "Browse insights from Brex and industry experts.",
                    subtitleV2Raw: null,
                    link: {
                      to: null,
                      toExternal: "https://www.brex.com/journal",
                      noFollow: null,
                      hash: null,
                    },
                    icon: null,
                    media: {
                      media: {
                        type: "IMAGE",
                        datUrl:
                          "https://brand.brex.com/transform/a49026cc-ce0e-4654-aeda-e7dd4b3437df/Blog",
                        description: null,
                        aspectRatio: 0.6325,
                        videoUrl: null,
                      },
                      mediaStyle: {
                        borderRadius: "6px",
                        customBorderRadius: null,
                      },
                      disableVideoLoop: false,
                    },
                    modifier: null,
                    mediaPosition: "top",
                    showMediaOnMobile: false,
                  },
                ],
              },
            ],
          },
          {
            _key: "9766d9a90a39",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "Support",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: null,
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "f2848a658ec0",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "c78a3856c758",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "3a817fdec9b6",
                        link: {
                          to: "/contact-us",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Get customer support",
                        subtitle: "Reach us by phone or chat 24/7.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M10.5 17.5C10.5 16.6716 11.1716 16 12 16C12.8284 16 13.5 16.6716 13.5 17.5C13.5 18.3284 12.8284 19 12 19C11.1716 19 10.5 18.3284 10.5 17.5Z" fill="currentColor"/>\n<path d="M12 5C9.79086 5 8 6.79086 8 9H10C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9V9.39445C14 10.0632 13.6658 10.6876 13.1094 11.0585L12.7812 11.2774C11.6684 12.0192 11 13.2681 11 14.6056V15H13V14.6056C13 13.9368 13.3342 13.3124 13.8906 12.9415L14.2188 12.7226C15.3316 11.9808 16 10.7319 16 9.39445V9C16 6.79086 14.2091 5 12 5Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "099c1a28befb",
                        link: {
                          to: null,
                          toExternal: "https://www.brex.com/customer-hub",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Customer hub",
                        subtitle:
                          "Guides, tutorials and webinars for Brex Empower setup",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="33" height="32" viewBox="0 0 33 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M10.5003 10C10.5003 6.68629 13.1866 4 16.5003 4C19.814 4 22.5003 6.68629 22.5003 10C22.5003 13.3137 19.814 16 16.5003 16C13.1866 16 10.5003 13.3137 10.5003 10ZM16.5003 6.66667C14.6594 6.66667 13.167 8.15905 13.167 10C13.167 11.841 14.6594 13.3333 16.5003 13.3333C18.3413 13.3333 19.8337 11.841 19.8337 10C19.8337 8.15905 18.3413 6.66667 16.5003 6.66667ZM17.916 17.385C17.4488 17.3515 16.9762 17.3333 16.5003 17.3333C13.2126 17.3333 10.0757 18.0354 7.78386 18.7229C6.63246 19.0683 5.6812 19.4141 5.01446 19.675C4.68083 19.8056 4.41768 19.9152 4.23552 19.9932C4.14442 20.0323 4.07351 20.0635 4.0241 20.0855L3.96625 20.1115L3.94971 20.119L3.94459 20.1213L3.94282 20.1222C3.94253 20.1223 3.94158 20.1227 4.50033 21.3333L3.94158 20.1227L3.16699 20.4802V22.4514C3.16697 23.1542 3.16695 23.7606 3.20775 24.26C3.25082 24.7872 3.34591 25.3115 3.60297 25.816C3.98646 26.5686 4.59839 27.1805 5.35103 27.564C5.85554 27.8211 6.37983 27.9162 6.90696 27.9592C7.40639 28 8.01274 28 8.7156 28H16.0652C15.6714 27.1711 15.3962 26.2749 15.2615 25.3333H8.767C7.99826 25.3333 7.50189 25.3323 7.12411 25.3014C6.76189 25.2718 6.6276 25.2216 6.56167 25.188C6.31079 25.0602 6.10682 24.8562 5.97899 24.6053C5.9454 24.5394 5.89516 24.4051 5.86557 24.0429C5.8347 23.6651 5.83366 23.1687 5.83366 22.4V22.2185C5.88241 22.1991 5.93328 22.179 5.98619 22.1583C6.59723 21.9192 7.47931 21.5983 8.55013 21.2771C10.5957 20.6634 13.2827 20.0629 16.063 20.0046C16.5273 19.0257 17.157 18.1405 17.916 17.385Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M24.5 32C28.9183 32 32.5 28.4183 32.5 24C32.5 19.5817 28.9183 16 24.5 16C20.0817 16 16.5 19.5817 16.5 24C16.5 28.4183 20.0817 32 24.5 32ZM29.4428 22.2761L27.5572 20.3905L23.1667 24.781L21.4428 23.0572L19.5572 24.9428L23.1667 28.5523L29.4428 22.2761Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                      {
                        _key: "fdb09092e0d8",
                        link: {
                          to: "/support",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Help center",
                        subtitle: "Find the answers you need.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_5399_39609)">\n<path d="M9 12V10H13V16H15V18H9V16H11V12H9Z" fill="currentColor"/>\n<path d="M12 9C12.8284 9 13.5 8.32843 13.5 7.5C13.5 6.67157 12.8284 6 12 6C11.1716 6 10.5 6.67157 10.5 7.5C10.5 8.32843 11.1716 9 12 9Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor"/>\n</g>\n<defs>\n<clipPath id="clip0_5399_39609">\n<rect width="24" height="24" fill="currentColor"/>\n</clipPath>\n</defs>\n</svg>\n',
                        },
                      },
                      {
                        _key: "f4c076382d49",
                        link: {
                          to: null,
                          toExternal: "https://www.brex.com/directory",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Accounting services",
                        subtitle: "Get help to close your books faster.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M3 15V0H5V15H7V17H1V15H3Z" fill="currentColor"/>\n<path d="M11 24H13V9H15V7H9V9H11V24Z" fill="currentColor"/>\n<path d="M21 0H19V15H17V17H23V15H21V0Z" fill="currentColor"/>\n<path d="M3 24L3 18H5L5 24H3Z" fill="currentColor"/>\n<path d="M11 6V0H13V6H11Z" fill="currentColor"/>\n<path d="M19 24V18H21V24H19Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "b9c3203678aa",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryGray",
            title: {
              text: "The latest",
              linkOnlyOnMobile: true,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: null,
                  toExternal: "https://www.brex.com/resources",
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "4f16355aca85",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "5dfb342e05ce",
                    _type: "articleListNavModule",
                    articles: [
                      {
                        _type: "articleListNavModuleArticle",
                        _key: "6a5d1263ebdd",
                        page: {
                          _id: "eea4dcc6-9629-4752-a588-5fd1fc7350e7",
                          _type: "contentHubArticle",
                          contentHubArticleContent: {
                            articleGroup: { parent: "resources" },
                            articleImage: {
                              image: {
                                datUrl:
                                  "https://brand.brex.com/transform/cb3a942f-a9a2-440b-a5b2-fd19e9afe611/Lemonade-article-preview",
                                description: null,
                              },
                            },
                          },
                          meta: {
                            title:
                              "Lemonade streamlines multi-entity spend on one global platform with Brex",
                            slug: { current: "customer/lemonade" },
                          },
                        },
                        titleOverride: null,
                        imageOverride: null,
                      },
                      {
                        _type: "articleListNavModuleArticle",
                        _key: "a36a89609216",
                        page: {
                          _id: "ed886cb1-7386-4620-b9d3-f8c58c12443c",
                          _type: "contentHubArticle",
                          contentHubArticleContent: {
                            articleGroup: { parent: "resources" },
                            articleImage: {
                              image: {
                                datUrl:
                                  "https://brand.brex.com/transform/a3cd2ff4-3d8f-49f1-9fdf-d6bb81fc41a8/T-E-ebook-preview",
                                description: null,
                              },
                            },
                          },
                          meta: {
                            title:
                              "How to solve the T&E challenges holding your business back",
                            slug: {
                              current:
                                "solve-travel-and-expense-challenges-holding-your-business-back-register",
                            },
                          },
                        },
                        titleOverride:
                          "The State of Corporate Travel and Expenses",
                        imageOverride: null,
                      },
                      {
                        _type: "articleListNavModuleArticle",
                        _key: "216bd56c85b2",
                        page: {
                          _id: "f373e816-3e9b-4600-b178-1b04c867a345",
                          _type: "contentHubArticle",
                          contentHubArticleContent: {
                            articleGroup: { parent: "journal" },
                            articleImage: {
                              image: {
                                datUrl:
                                  "https://brand.brex.com/transform/3452dd65-6de1-4e4b-b69e-6c5896cb55fb/Payables-meta-data-image-1",
                                description: null,
                              },
                            },
                          },
                          meta: {
                            title:
                              "The employee-centric way to manage procurement spend",
                            slug: {
                              current:
                                "employee-centric-approach-to-procurement-spend",
                            },
                          },
                        },
                        titleOverride: null,
                        imageOverride: null,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    right: [
      {
        _key: "e26c043d948e",
        _type: "navLink",
        text: "Sign in",
        link: {
          to: null,
          toExternal: "https://dashboard.brex.com/",
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "055fae2857c1",
        _type: "navLink",
        text: "Get started",
        link: {
          to: null,
          toExternal: "https://www.brex.com/signup",
          noFollow: null,
          hash: null,
        },
      },
    ],
    cta: {
      text: "Control all your spend before it happens, all in one place.",
      link: {
        _key: null,
        _type: "navLink",
        text: "Get started",
        link: { to: "/signup", toExternal: null, noFollow: null, hash: null },
      },
    },
  },
  "8817a26f-78f4-4efa-9462-1bc4e2a3de49": {
    _type: "navigation",
    _id: "8817a26f-78f4-4efa-9462-1bc4e2a3de49",
    _updatedAt: "2025-01-08T15:58:13Z",
    title: "[LIVE] 2/1 Navigation",
    mobileBreakpoint: null,
    left: [
      {
        _key: "4c3ddc93ebdc",
        _type: "navMenu",
        text: "Products",
        description: null,
        submenu: [
          {
            _key: "79e9582c4b49",
            _type: "navGroup",
            span: 2,
            theme: "PrimaryWhite",
            title: {
              text: "Products",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: null,
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "7e342c9182fa",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8b14c557e5f9",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "055b248ba3d7",
                        link: {
                          to: "/product/credit-card",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Corporate card",
                        subtitle: "Get 10-20x higher credit limits",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M0 6C0 4.34315 1.34315 3 3 3H21C22.6569 3 24 4.34315 24 6V18C24 19.6569 22.6569 21 21 21H3C1.34314 21 0 19.6569 0 18V6ZM3 5C2.44772 5 2 5.44772 2 6V16H11.1415C11.8311 16 12.472 15.6448 12.8375 15.06L14.1625 12.94C14.528 12.3552 15.1689 12 15.8585 12H22V6C22 5.44771 21.5523 5 21 5H3Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "0d30fe481533",
                        link: {
                          to: "/product/spend-management",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Spend management",
                        subtitle: "Simplify expenses and reimbursements",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '    <svg\n      width="24"\n      height="24"\n      viewBox="0 0 24 24"\n      fill="none"\n      xmlns="http://www.w3.org/2000/svg"\n    >\n      <path\n        fill-rule="evenodd"\n        clip-rule="evenodd"\n        d="M23.8162 14.1036C23.937 13.4206 24 12.7177 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C12.7177 24 13.4206 23.937 14.1036 23.8162C13.3793 23.3301 12.7509 22.7122 12.2525 21.9969C12.1686 21.999 12.0844 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.0844 21.999 12.1686 21.9969 12.2525C22.7122 12.7509 23.3301 13.3793 23.8162 14.1036ZM18 24C21.3137 24 24 21.3137 24 18C24 14.6863 21.3137 12 18 12C14.6863 12 12 14.6863 12 18C12 21.3137 14.6863 24 18 24ZM19 14L15 19H17.5L17 22L21 17H18.5L19 14ZM14.9332 11.7058C14.4111 11.2654 13.7365 11 13 11H11C10.4477 11 10 10.5523 10 10C10 9.44771 10.4477 9 11 9H14V10H16V7H13V4H11V7C9.34315 7 8 8.34315 8 10C8 11.6569 9.34315 13 11 13H13C13.0325 13 13.0646 13.0016 13.0963 13.0046C13.6318 12.4789 14.2515 12.0386 14.9332 11.7058ZM11.4616 15.5338C11.5462 15.3303 11.6235 15.1443 11.6736 15H10V14H8V17H11C11 16.6443 11.253 16.0356 11.4616 15.5338L11.4616 15.5338Z"\n        fill="currentColor"\n      />\n    </svg>\n',
                        },
                      },
                      {
                        _key: "ed0c78f23112",
                        link: {
                          to: "/product/business-account",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Business banking",
                        subtitle: "Earn yield and move money fast",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 0.922852L21.1142 4.56852C22.2531 5.02411 23 6.12724 23 7.35395V9.99988H20V15.9999H23V18.9999C23 20.6567 21.6569 21.9999 20 21.9999H4C2.34315 21.9999 1 20.6567 1 18.9999V15.9999H4V9.99988H1V7.35395C1 6.12724 1.74685 5.02411 2.88583 4.56852L12 0.922852ZM6 15.9999H11V9.99988H6V15.9999ZM13 15.9999H18V9.99988H13V15.9999ZM12 3.07692L3.62861 6.42547C3.24895 6.57734 3 6.94505 3 7.35395V7.99988H15V4.27692L12 3.07692ZM3 18.9999V17.9999H15V19.9999H4C3.44772 19.9999 3 19.5522 3 18.9999Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "7d84741536b6",
                        link: {
                          to: "/product/bill-pay",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Bill pay",
                        subtitle: "Pay vendors faster and easier",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C4.34315 0 3 1.34314 3 3V21C3 22.6569 4.34315 24 6 24H18C19.6569 24 21 22.6569 21 21H19C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44771 2 6 2H14V7H19V11H21V5.58579L15.4142 0H6ZM8 11H16V13H8V11ZM12 15H8V17H12V15ZM23.6715 16L20.6914 12.4238L19.3086 13.5762L20.5785 15.1H16V16.9H20.5785L19.3086 18.4238L20.6914 19.5762L23.6715 16Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
              {
                _key: "381f7b96912b",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "3a4115508c0b",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "b4bd1183c3f0",
                        link: {
                          to: "/platform/accounting-automation",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Accounting automation",
                        subtitle: "Close the books in minutes",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="fill=currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M3 2C1.89543 2 1 2.89543 1 4V17C1 18.1046 1.89543 19 3 19H9C9.53043 19 10.0391 19.2107 10.4142 19.5858C10.7893 19.9609 11 20.4696 11 21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21C13 20.4696 13.2107 19.9609 13.5858 19.5858C13.9609 19.2107 14.4696 19 15 19H21C22.1046 19 23 18.1046 23 17V4C23 2.89543 22.1046 2 21 2H16C14.6739 2 13.4021 2.52678 12.4645 3.46447C12.2962 3.63275 12.1411 3.81178 12 3.99997C11.8589 3.81178 11.7038 3.63275 11.5355 3.46447C10.5979 2.52678 9.32608 2 8 2H3ZM13 17.5359C13.6029 17.1878 14.2918 17 15 17H21V4H16C15.2044 4 14.4413 4.31607 13.8787 4.87868C13.3161 5.44129 13 6.20435 13 7V17.5359ZM11 17.5359V7C11 6.20435 10.6839 5.44129 10.1213 4.87868C9.55871 4.31607 8.79565 4 8 4H3V17H9C9.70823 17 10.3971 17.1878 11 17.5359Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "f60fe03cd936",
                        link: {
                          to: "/product/travel-expense-management",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Travel",
                        subtitle: "Book and manage global travel",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M9 0C7.89543 0 7 0.89543 7 2V7H4H3V8V19C3 20.8819 4.2996 22.4603 6.05029 22.8866C6.2208 23.5277 6.80523 24 7.5 24C8.15311 24 8.70873 23.5826 8.91465 23H15.0854C15.2913 23.5826 15.8469 24 16.5 24C17.1948 24 17.7792 23.5277 17.9497 22.8866C19.7004 22.4603 21 20.8819 21 19V8V7H20H17V2C17 0.895431 16.1046 0 15 0H9ZM17 21C18.1046 21 19 20.1046 19 19V9H17H16H8H7H5V19C5 20.1046 5.89543 21 7 21H9H15H17ZM15 7V2L9 2V7H15ZM17 14H7V12H17V14ZM7 18H17V16H7V18Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "569a75fd4e4d",
                        link: {
                          to: "/product/embedded-finance",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Brex Embedded",
                        subtitle: "Embed our cards in your products",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.00004 5.3335C4.00004 3.12436 5.7909 1.3335 8.00004 1.3335H24C26.2092 1.3335 28 3.12436 28 5.3335V6.35202C28.8184 7.08445 29.3334 8.14883 29.3334 9.3335V10.352C30.1517 11.0844 30.6667 12.1488 30.6667 13.3335V26.6668C30.6667 28.876 28.8758 30.6668 26.6667 30.6668H5.33337C3.12424 30.6668 1.33337 28.876 1.33337 26.6668V13.3335C1.33337 12.1488 1.84837 11.0844 2.66671 10.352V9.3335C2.66671 8.14883 3.18171 7.08445 4.00004 6.35202V5.3335ZM24 4.00016C24.7364 4.00016 25.3334 4.59712 25.3334 5.3335H6.66671C6.66671 4.59712 7.26366 4.00016 8.00004 4.00016H24ZM25.3334 8.00016H6.66671C5.93033 8.00016 5.33337 8.59712 5.33337 9.3335H26.6667C26.6667 8.59712 26.0698 8.00016 25.3334 8.00016ZM5.33337 12.0002C4.59699 12.0002 4.00004 12.5971 4.00004 13.3335V24.0002H15.0844C15.8758 24.0002 16.6263 23.6486 17.133 23.0407L18.8671 20.9597C19.3738 20.3517 20.1243 20.0002 20.9157 20.0002H28V13.3335C28 12.5971 27.4031 12.0002 26.6667 12.0002H5.33337Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "2af71eb99ff6",
                        link: {
                          to: "/release",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Product releases",
                        subtitle: "See what’s new at Brex",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m26.6667 2.66675v4 3.99995c1.4145 0 2.771.562 3.7712 1.5621 1.0002 1.0002 1.5621 2.3568 1.5621 3.7713s-.5619 2.771-1.5621 3.7712-2.3567 1.5621-3.7712 1.5621v4 4h-2.6667v-2.8705l-9.4081-1.568c-.4256 2.5195-2.618 4.4386-5.25857 4.4386-2.94551 0-5.33333-2.3879-5.33333-5.3334 0-.292.02359-.579.06902-.859l-.72662-.1211c-1.92875-.3215-3.3424-1.9902-3.3424-3.9456v-6.1486c0-1.9554 1.41365-3.62416 3.3424-3.94562l20.6576-3.44293v-2.8705zm-19.96724 20.91275 5.26164.8769c-.2165 1.2554-1.3106 2.2104-2.62777 2.2104-1.47276 0-2.66666-1.1939-2.66666-2.6667 0-.1435.01122-.2839.03279-.4206zm17.30054-15.3388-20.2192 3.3699c-.64292.1071-1.11413.6634-1.11413 1.3152v6.1486c0 .6518.47121 1.208 1.11413 1.3152l20.2192 3.3699z" fill="currentColor" fill-rule="evenodd"/></svg>',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "af0469f4ab57062d2d3adc5443bdfee5",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "Platform",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: null,
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "7e342c9182fa",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8b14c557e5f9",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "055b248ba3d7",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/platform/brex-ai",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Brex AI",
                        subtitle: "Automations and insights",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill=currentColor xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_6620_871)">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.97183 10.4917C5 10.8023 5.21127 11 5.50704 11C5.78873 11 6 10.8023 6.02817 10.5199C6.52016 6.78525 6.63336 6.76387 10.4983 6.03383L10.5211 6.02952C10.8028 5.98716 11 5.78947 11 5.50706C11 5.21053 10.7887 4.99872 10.5211 4.97047C6.64789 4.43389 6.52113 4.3068 6.02817 0.494223C6 0.197689 5.78873 0 5.50704 0C5.21127 0 5 0.197689 4.97183 0.508344C4.51102 4.21832 4.34094 4.25005 0.577071 4.95215L0.478873 4.97047C0.197183 5.01284 0 5.21053 0 5.50706C0 5.80359 0.197183 5.98716 0.535211 6.02952C4.35211 6.63671 4.50704 6.74968 4.97183 10.4917ZM14.5 24C14.1424 24 13.8563 23.7376 13.7967 23.3559C12.8789 16.8914 12.0088 16.0565 5.6675 15.2097C5.27415 15.162 5 14.8638 5 14.494C5 14.1243 5.27415 13.838 5.67942 13.7903C12.0326 13.0866 12.9385 12.1086 13.7967 5.64407C13.8563 5.2624 14.1305 5 14.5 5C14.8695 5 15.1437 5.2624 15.2033 5.64407C16.0972 12.1086 16.9793 13.0508 23.3325 13.7903C23.7258 13.838 24 14.1243 24 14.494C24 14.8757 23.7258 15.162 23.3325 15.2097C16.9674 15.9134 16.0615 16.8914 15.2033 23.3559C15.1437 23.7376 14.8695 24 14.5 24Z" fill=currentColor/>\n</g>\n<defs>\n<clipPath id="clip0_6620_871">\n<rect width="24" height="24" fill="white"/>\n</clipPath>\n</defs>\n</svg>',
                        },
                      },
                      {
                        _key: "0d30fe481533",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/product/global",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Global ready",
                        subtitle: "Multi-currency and multi-entity",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12 22C12.7474 22 13.7509 21.2878 14.6252 19.3644C14.9377 18.6767 15.2093 17.8808 15.4265 17H8.57345C8.79074 17.8808 9.06226 18.6767 9.37483 19.3644C10.2491 21.2878 11.2526 22 12 22ZM8.19682 15H15.8032C15.9306 14.0553 16 13.0485 16 12C16 10.9515 15.9306 9.94466 15.8032 9H8.19682C8.06943 9.94466 8 10.9515 8 12C8 13.0485 8.06943 14.0553 8.19682 15ZM8.57345 7C8.79074 6.11921 9.06226 5.32328 9.37483 4.63563C10.2491 2.71217 11.2526 2 12 2C12.7474 2 13.7509 2.71217 14.6252 4.63563C14.9377 5.32328 15.2093 6.11921 15.4265 7H8.57345ZM17.8196 9C17.9378 9.96135 18 10.9672 18 12C18 13.0328 17.9378 14.0387 17.8196 15H21.5422C21.8396 14.053 22 13.0452 22 12C22 10.9548 21.8396 9.94704 21.5422 9H17.8196ZM20.6622 7H17.48C17.2208 5.8214 16.8712 4.74364 16.4459 3.80802C16.2881 3.4608 16.1143 3.12233 15.9247 2.79955C17.9212 3.65232 19.5839 5.13598 20.6622 7ZM6.51996 7H3.33782C4.4161 5.13598 6.07877 3.65232 8.07531 2.79955C7.88574 3.12233 7.71193 3.4608 7.5541 3.80802C7.12882 4.74364 6.77917 5.8214 6.51996 7ZM2.4578 9H6.18036C6.06223 9.96135 6 10.9672 6 12C6 13.0328 6.06223 14.0387 6.18036 15H2.4578C2.16035 14.053 2 13.0452 2 12C2 10.9548 2.16035 9.94704 2.4578 9ZM16.4459 20.192C16.8712 19.2564 17.2208 18.1786 17.48 17H20.6622C19.5839 18.864 17.9212 20.3477 15.9247 21.2005C16.1143 20.8777 16.2881 20.5392 16.4459 20.192ZM8.07532 21.2005C6.07877 20.3477 4.4161 18.864 3.33782 17H6.51996C6.77917 18.1786 7.12882 19.2564 7.5541 20.192C7.71193 20.5392 7.88574 20.8777 8.07532 21.2005Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                      {
                        _key: "23bc46b3797f",
                        link: {
                          to: "/platform/budgets",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Live Budgets™",
                        subtitle: "Real-time tracking and agility",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M16.5922 0.913451C14.3995 0.00519943 11.9867 -0.232441 9.65892 0.230582C7.33115 0.693605 5.19295 1.83649 3.51472 3.51472C1.83649 5.19295 0.693605 7.33115 0.230582 9.65892C-0.232441 11.9867 0.00519943 14.3995 0.913451 16.5922C1.8217 18.7849 3.35977 20.6591 5.33316 21.9776C7.30655 23.2962 9.62663 24 12 24C13.5759 24 15.1363 23.6896 16.5922 23.0866C18.0481 22.4835 19.371 21.5996 20.4853 20.4853C21.5996 19.371 22.4835 18.0481 23.0866 16.5922C23.6896 15.1363 24 13.5759 24 12C24 9.62663 23.2962 7.30655 21.9776 5.33316C20.6591 3.35977 18.7849 1.8217 16.5922 0.913451ZM10.0491 2.19215C11.9889 1.8063 13.9996 2.00433 15.8268 2.76121C17.6541 3.51809 19.2159 4.79981 20.3147 6.4443C21.2274 7.81025 21.7866 9.37552 21.9499 11H12C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12V21.9499C9.37552 21.7866 7.81025 21.2274 6.4443 20.3147C4.79981 19.2159 3.51809 17.6541 2.76121 15.8268C2.00433 13.9996 1.8063 11.9889 2.19215 10.0491C2.578 8.10929 3.53041 6.32746 4.92894 4.92894C6.32746 3.53041 8.10929 2.57801 10.0491 2.19215Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "c3a30c8019e8c5c43cc3d2ad08a8984e",
                        link: {
                          to: "/platform/spend-limits",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Spend limits",
                        subtitle: "Custom limits with built-in controls",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11 7C11 9.20914 9.20914 11 7 11C4.79086 11 3 9.20914 3 7C3 4.79086 4.79086 3 7 3L7 6C7 6.55228 7.44772 7 8 7H11ZM7 1C8.6454 1 10.1361 1.66232 11.2201 2.7349L11.2426 2.75736L11.2651 2.77994C11.665 3.18408 12.0079 3.64476 12.2806 4.14892C14.1484 3.82292 16.0722 4.03441 17.8268 4.76121C19.6541 5.51808 21.2159 6.79981 22.3147 8.4443C23.4135 10.0888 24 12.0222 24 14C24 15.3132 23.7413 16.6136 23.2388 17.8268C22.7362 19.0401 21.9997 20.1425 21.0711 21.0711C20.1425 21.9997 19.0401 22.7362 17.8268 23.2388C16.6145 23.7409 15.3153 23.9996 14.0031 24C14.0021 24 14.001 24 14 24C12.0222 24 10.0888 23.4135 8.4443 22.3147C6.79981 21.2159 5.51808 19.6541 4.76121 17.8268C4.0344 16.0722 3.82292 14.1484 4.14892 12.2806C2.27371 11.2661 1 9.28178 1 7C1 3.68629 3.68629 1 7 1ZM6.07206 12.9287C5.88315 14.3266 6.06691 15.7528 6.60897 17.0615C7.21447 18.5233 8.23985 19.7727 9.55544 20.6518C10.592 21.3444 11.7721 21.7826 13 21.9373V14C13 13.7348 13.1054 13.4804 13.2929 13.2929C13.4804 13.1054 13.7348 13 14 13H21.9373C21.7826 11.7721 21.3444 10.592 20.6518 9.55544C19.7727 8.23985 18.5233 7.21447 17.0615 6.60897C15.7528 6.06691 14.3266 5.88315 12.9287 6.07206C12.9756 6.3745 13 6.6844 13 7C13 10.3137 10.3137 13 7 13C6.6844 13 6.3745 12.9756 6.07206 12.9287Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "5c9a8a4197a57f715fe90402fab034ea",
                        link: {
                          to: "/product/integrations",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Native integrations",
                        subtitle: "ERP, HRIS, productivity, security",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12.168 5.33337C12.7601 3.03307 14.8482 1.33337 17.3333 1.33337C19.8185 1.33337 21.9066 3.03307 22.4986 5.33337H29.3333V14.6667H28C26.5272 14.6667 25.3333 15.8606 25.3333 17.3334C25.3333 18.8061 26.5272 20 28 20H29.3333V29.3334H5.33333V22.4987C3.03303 21.9066 1.33333 19.8185 1.33333 17.3334C1.33333 14.8483 3.03303 12.7601 5.33333 12.1681V5.33337H12.168ZM17.3333 4.00004C15.8606 4.00004 14.6667 5.19395 14.6667 6.66671V8.00004H8V14.6667H6.66667C5.19391 14.6667 4 15.8606 4 17.3334C4 18.8061 5.19391 20 6.66667 20H8V26.6667H26.6667V22.4987C24.3664 21.9066 22.6667 19.8185 22.6667 17.3334C22.6667 14.8483 24.3664 12.7601 26.6667 12.1681V8.00004H20V6.66671C20 5.19395 18.8061 4.00004 17.3333 4.00004Z" fill="#currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "25420cfd0b03a9254f9b94701064cdb7",
                        link: {
                          to: "/product/mobile",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Mobile",
                        subtitle: "Available on iOS and Android",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M7 0C5.34315 0 4 1.34314 4 3V21C4 22.6569 5.34315 24 7 24H17C18.6569 24 20 22.6569 20 21V3C20 1.34315 18.6569 0 17 0H7ZM6 3C6 2.44772 6.44771 2 7 2H17C17.5523 2 18 2.44772 18 3V21C18 21.5523 17.5523 22 17 22H7C6.44772 22 6 21.5523 6 21V3ZM12 20C13.1046 20 14 19.1046 14 18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18C10 19.1046 10.8954 20 12 20Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "1e2b0492bcc1",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryGray",
            title: {
              text: "New release",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: { to: "", toExternal: null, noFollow: null, hash: null },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "5860dde6ed0e",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "b3536b8af5b0",
                    _type: "linkHeroNavModule",
                    title: "Make every dollar count",
                    subtitle:
                      "Maximize the value you get from Brex with an all-new Impact Dashboard, smart search, global bill pay, and much more. Check it out!",
                    subtitleV2Raw: null,
                    link: {
                      to: "/release",
                      toExternal: null,
                      noFollow: null,
                      hash: null,
                    },
                    icon: null,
                    media: {
                      media: {
                        type: "IMAGE",
                        datUrl:
                          "https://brand.brex.com/transform/3645f6cc-90e6-46d2-8042-c89a031adc2a/Fall-release_nav",
                        description: null,
                        aspectRatio: 0.6125,
                        videoUrl: null,
                      },
                      mediaStyle: {
                        borderRadius: "6px",
                        customBorderRadius: null,
                      },
                      disableVideoLoop: false,
                    },
                    modifier: null,
                    mediaPosition: "top",
                    showMediaOnMobile: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _key: "53ce45644bd9",
        _type: "navMenu",
        text: "Solutions",
        description: null,
        submenu: [
          {
            _key: "7c4cb829ab72",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "By company size",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: { to: "", toExternal: null, noFollow: null, hash: null },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "aba2aba1f772",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "27f22e08ffc1",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "57d88210c49c",
                        link: {
                          to: "/solutions/startups",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Startups",
                        subtitle: "Get the #1 financial stack for startups",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M0 6C0 4.34315 1.34315 3 3 3H21C22.6569 3 24 4.34315 24 6V18C24 19.6569 22.6569 21 21 21H3C1.34314 21 0 19.6569 0 18V6ZM3 5C2.44772 5 2 5.44772 2 6V16H11.1415C11.8311 16 12.472 15.6448 12.8375 15.06L14.1625 12.94C14.528 12.3552 15.1689 12 15.8585 12H22V6C22 5.44771 21.5523 5 21 5H3Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "72d93b76bb04",
                        link: {
                          to: "/solutions/mid-size-companies",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Mid-sized companies",
                        subtitle: "Scale faster with smart cards & controls",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M13.5629 4.89329C11.6112 4.24273 9.46846 4.52968 7.75671 5.67085L5.92707 6.89061L4.26297 8.00001L5.92707 9.10941L10.263 12L8.51064 13.1682L5.82852 12.0954L5.37504 11.914L4.9117 12.0684L2.95837 12.7195C1.07774 13.3464 0.514287 15.7332 1.91602 17.135L4.64044 19.8594C7.27459 22.4935 11.3783 22.9609 14.5373 20.9865L29.8507 11.4157C31.3672 10.4678 31.5393 8.32517 30.1933 7.14748L29.5796 6.61049C27.1349 4.47137 23.6394 4.02293 20.7339 5.47569L18.5644 6.56045L13.5629 4.89329ZM9.23591 7.88965C10.263 7.20495 11.5486 7.03277 12.7196 7.42311L18.245 9.26492L18.769 9.43957L19.263 9.19258L21.9265 7.86083C23.8635 6.89232 26.1938 7.19128 27.8236 8.61736L28.4373 9.15435L13.124 18.7252C11.018 20.0415 8.28216 19.7299 6.52606 17.9738L3.80164 15.2494L5.29162 14.7527L8.17148 15.9046L8.82269 16.1651L9.40627 15.7761L13.4063 13.1094L15.0704 12L13.4063 10.8906L9.07037 8.00001L9.23591 7.88965ZM2.66667 28H21.3333V25.3333H2.66667V28Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                      {
                        _key: "751c09fb19d7",
                        link: {
                          to: "/solutions/enterprise",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Enterprise",
                        subtitle: "Spend smart across entities, currencies",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="33" height="32" viewBox="0 0 33 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 0C6.29086 0 4.5 1.79086 4.5 4V30V31.924L6.3015 31.2484L8.42376 30.4526L10.5704 31.5259L11.1667 31.824L11.763 31.5259L13.8333 30.4907L15.9037 31.5259L16.5 31.824L17.0963 31.5259L19.1667 30.4907L21.237 31.5259L21.8333 31.824L22.4296 31.5259L24.5762 30.4526L26.6985 31.2484L28.5 31.924V30V4C28.5 1.79086 26.7091 0 24.5 0H8.5ZM7.16667 4C7.16667 3.26362 7.76362 2.66667 8.5 2.66667H24.5C25.2364 2.66667 25.8333 3.26362 25.8333 4V28.076L24.9682 27.7516L24.4238 27.5474L23.9037 27.8074L21.8333 28.8426L19.763 27.8074L19.1667 27.5093L18.5704 27.8074L16.5 28.8426L14.4296 27.8074L13.8333 27.5093L13.237 27.8074L11.1667 28.8426L9.09628 27.8074L8.57624 27.5474L8.03184 27.7516L7.16667 28.076V4ZM19.1667 8H13.8333V5.33333H19.1667V8ZM21.8333 13.3333H11.1667V10.6667H21.8333V13.3333ZM11.1667 18.6667H21.8333V16H11.1667V18.6667ZM16.5 24V21.3333H21.8333V24H16.5Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "b6f631dcf896",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "For partners",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: {
                  to: null,
                  toExternal: null,
                  noFollow: false,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: false,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "32731f9ee7ac",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "3362e675a734",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "d5fde9919472",
                        link: {
                          to: "/partners/accounting",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Accounting firms",
                        subtitle: "Simplify close and earn rewards",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M10.6667 4C7.35296 4 4.66667 6.68629 4.66667 10C4.66667 13.3137 7.35296 16 10.6667 16C13.9804 16 16.6667 13.3137 16.6667 10C16.6667 6.68629 13.9804 4 10.6667 4ZM7.33334 10C7.33334 8.15905 8.82572 6.66667 10.6667 6.66667C12.5076 6.66667 14 8.15905 14 10C14 11.8409 12.5076 13.3333 10.6667 13.3333C8.82572 13.3333 7.33334 11.8409 7.33334 10Z" fill="currentColor"/>\n<path d="M18.3334 10C18.3334 11.6533 17.7863 13.1788 16.8632 14.4054C17.8308 15.3896 19.1774 16 20.6667 16C23.6122 16 26 13.6122 26 10.6667C26 7.72115 23.6122 5.33333 20.6667 5.33333C19.4418 5.33333 18.3134 5.74623 17.4131 6.44042C17.9994 7.49451 18.3334 8.70825 18.3334 10Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M21.3333 21.4744V28H5.54861C4.84575 28 4.23939 28 3.73997 27.9592C3.21284 27.9162 2.68855 27.8211 2.18404 27.564C1.43139 27.1805 0.81947 26.5686 0.435976 25.816C0.178918 25.3115 0.0838297 24.7872 0.0407617 24.26C-4.33574e-05 23.7606 -2.2695e-05 23.1543 1.14681e-06 22.4514V20.7201C0.865588 19.9782 0.310448 20.4539 0.466628 20.3201L0.467715 20.3192C0.489714 20.3005 0.51208 20.2821 0.534606 20.264C0.570185 20.2355 0.618371 20.1977 0.679169 20.1521C0.800747 20.0609 0.972894 19.9383 1.19566 19.7951C1.64114 19.5087 2.28971 19.1395 3.14144 18.7745C4.84824 18.043 7.35963 17.3333 10.6667 17.3333C14.0255 17.3333 16.5734 18.2351 18.2963 19.158C19.1553 19.6182 19.807 20.0823 20.2519 20.4398C20.4744 20.6187 20.6458 20.7713 20.7661 20.8841C20.8263 20.9405 20.8737 20.987 20.9084 21.0219C20.9258 21.0393 20.94 21.0539 20.9511 21.0653L20.9706 21.0858L20.9728 21.0882L20.9738 21.0893C21.1327 21.2595 20.6069 20.6962 21.3333 21.4744ZM2.66667 22.0197V22.4C2.66667 23.1687 2.66771 23.6651 2.69857 24.0429C2.72817 24.4051 2.7784 24.5394 2.81199 24.6053C2.93982 24.8562 3.1438 25.0602 3.39468 25.188C3.46061 25.2216 3.5949 25.2718 3.95712 25.3014C4.3349 25.3323 4.83126 25.3333 5.6 25.3333H18.6667V22.588C18.6398 22.5657 18.6114 22.5425 18.5815 22.5185C18.2486 22.251 17.7336 21.8818 17.037 21.5086C15.6488 20.7649 13.53 20 10.6667 20C7.75149 20 5.59621 20.6237 4.19189 21.2255C3.50822 21.5185 2.99978 21.8076 2.66667 22.0197Z" fill="currentColor"/>\n<path d="M22.6667 21.2174V28H27.7333C29.2268 28 29.9736 28 30.544 27.7094C31.0458 27.4537 31.4537 27.0457 31.7094 26.544C32 25.9735 32 25.2268 32 23.7333V20.6667C32 20.6667 27.5556 17.3333 21.3333 17.3333C20.0653 17.3333 18.9264 17.4441 17.9168 17.6205C21.0834 19.1522 22.6667 21.2174 22.6667 21.2174Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "102d59011244",
                        link: {
                          to: "/product/embedded-finance",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "B2B software",
                        subtitle: "Embed Brex cards in your products",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.00004 5.3335C4.00004 3.12436 5.7909 1.3335 8.00004 1.3335H24C26.2092 1.3335 28 3.12436 28 5.3335V6.35202C28.8184 7.08445 29.3334 8.14883 29.3334 9.3335V10.352C30.1517 11.0844 30.6667 12.1488 30.6667 13.3335V26.6668C30.6667 28.876 28.8758 30.6668 26.6667 30.6668H5.33337C3.12424 30.6668 1.33337 28.876 1.33337 26.6668V13.3335C1.33337 12.1488 1.84837 11.0844 2.66671 10.352V9.3335C2.66671 8.14883 3.18171 7.08445 4.00004 6.35202V5.3335ZM24 4.00016C24.7364 4.00016 25.3334 4.59712 25.3334 5.3335H6.66671C6.66671 4.59712 7.26366 4.00016 8.00004 4.00016H24ZM25.3334 8.00016H6.66671C5.93033 8.00016 5.33337 8.59712 5.33337 9.3335H26.6667C26.6667 8.59712 26.0698 8.00016 25.3334 8.00016ZM5.33337 12.0002C4.59699 12.0002 4.00004 12.5971 4.00004 13.3335V24.0002H15.0844C15.8758 24.0002 16.6263 23.6486 17.133 23.0407L18.8671 20.9597C19.3738 20.3517 20.1243 20.0002 20.9157 20.0002H28V13.3335C28 12.5971 27.4031 12.0002 26.6667 12.0002H5.33337Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _key: "3adc58d91a4b",
        _type: "navMenu",
        text: "Resources",
        description: null,
        submenu: [
          {
            _key: "79d0fdf35784",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "Customer Hub",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: "/customer-hub",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "86ec301ad222",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "/support",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Help Center",
                        subtitle: "Find answers to common questions.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M10.5 17.5C10.5 16.6716 11.1716 16 12 16C12.8284 16 13.5 16.6716 13.5 17.5C13.5 18.3284 12.8284 19 12 19C11.1716 19 10.5 18.3284 10.5 17.5Z" fill="currentColor"/>\n<path d="M12 5C9.79086 5 8 6.79086 8 9H10C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9V9.39445C14 10.0632 13.6658 10.6876 13.1094 11.0585L12.7812 11.2774C11.6684 12.0192 11 13.2681 11 14.6056V15H13V14.6056C13 13.9368 13.3342 13.3124 13.8906 12.9415L14.2188 12.7226C15.3316 11.9808 16 10.7319 16 9.39445V9C16 6.79086 14.2091 5 12 5Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/implementation",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Implementation guides",
                        subtitle: "Learn how to set up key features.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_5399_39609)">\n<path d="M9 12V10H13V16H15V18H9V16H11V12H9Z" fill="currentColor"/>\n<path d="M12 9C12.8284 9 13.5 8.32843 13.5 7.5C13.5 6.67157 12.8284 6 12 6C11.1716 6 10.5 6.67157 10.5 7.5C10.5 8.32843 11.1716 9 12 9Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor"/>\n</g>\n<defs>\n<clipPath id="clip0_5399_39609">\n<rect width="24" height="24" fill="currentColor"/>\n</clipPath>\n</defs>\n</svg>\n',
                        },
                      },
                      {
                        _key: "78c4db945bb1",
                        link: {
                          to: "/release",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Product releases",
                        subtitle: "See what’s new at Brex",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m26.6667 2.66675v4 3.99995c1.4145 0 2.771.562 3.7712 1.5621 1.0002 1.0002 1.5621 2.3568 1.5621 3.7713s-.5619 2.771-1.5621 3.7712-2.3567 1.5621-3.7712 1.5621v4 4h-2.6667v-2.8705l-9.4081-1.568c-.4256 2.5195-2.618 4.4386-5.25857 4.4386-2.94551 0-5.33333-2.3879-5.33333-5.3334 0-.292.02359-.579.06902-.859l-.72662-.1211c-1.92875-.3215-3.3424-1.9902-3.3424-3.9456v-6.1486c0-1.9554 1.41365-3.62416 3.3424-3.94562l20.6576-3.44293v-2.8705zm-19.96724 20.91275 5.26164.8769c-.2165 1.2554-1.3106 2.2104-2.62777 2.2104-1.47276 0-2.66666-1.1939-2.66666-2.6667 0-.1435.01122-.2839.03279-.4206zm17.30054-15.3388-20.2192 3.3699c-.64292.1071-1.11413.6634-1.11413 1.3152v6.1486c0 .6518.47121 1.208 1.11413 1.3152l20.2192 3.3699z" fill="currentColor" fill-rule="evenodd"/></svg>',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "4ce7782d1713ef14f57e6d62fb24e62e",
            _type: "navGroup",
            span: 2,
            theme: "PrimaryWhite",
            title: {
              text: "Resource Center",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: "/resources",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "86ec301ad222",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/resources/ebooks",
                          noFollow: null,
                          hash: null,
                        },
                        text: "White papers and e-books",
                        subtitle: "Access exclusive research and reports.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="33" height="32" viewBox="0 0 33 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M21.8333 18.6667V16H11.1667V18.6667H21.8333Z" fill="currentColor"/>\n<path d="M11.1667 24V21.3333H21.8333V24H11.1667Z" fill="currentColor"/>\n<path d="M16.5 6.66667H11.1667V9.33333H16.5V6.66667Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 4C4.5 1.79086 6.29086 0 8.5 0H21.0523L28.5 7.44772V28C28.5 30.2091 26.7091 32 24.5 32H8.5C6.29086 32 4.5 30.2091 4.5 28V4ZM8.5 2.66667C7.76362 2.66667 7.16667 3.26362 7.16667 4V28C7.16667 28.7364 7.76362 29.3333 8.5 29.3333H24.5C25.2364 29.3333 25.8333 28.7364 25.8333 28V9.33333H19.1667V2.66667H8.5Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: null,
                          toExternal: "https://www.brex.com/resources/webinars",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Webinars",
                        subtitle: "Tune in for actionable insights.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="21" viewBox="0 0 24 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M2.47117 16.9754C1.70016 16.9754 1.0939 16.758 0.652389 16.3231C0.217463 15.8815 0 15.272 0 14.4944V2.59324C0 1.81565 0.217463 1.20938 0.652389 0.774459C1.0939 0.339533 1.70016 0.12207 2.47117 0.12207H21.5288C22.2998 0.12207 22.9028 0.339533 23.3377 0.774459C23.7792 1.20938 24 1.81565 24 2.59324V14.4944C24 15.272 23.7792 15.8815 23.3377 16.3231C22.9028 16.758 22.2998 16.9754 21.5288 16.9754H2.47117ZM2.31301 12.3988H21.6771C21.9605 12.3988 22.1021 12.2605 22.1021 11.9837V2.71186C22.1021 2.49439 22.0395 2.32635 21.9143 2.20774C21.7891 2.08253 21.6244 2.01993 21.4201 2.01993H2.5799C2.37562 2.01993 2.21087 2.08253 2.08567 2.20774C1.96046 2.32635 1.89786 2.49439 1.89786 2.71186V11.9837C1.89786 12.2605 2.03624 12.3988 2.31301 12.3988ZM9 19V15.8792H15V19.0117L9 19ZM8.72817 20.5537C8.47776 20.5537 8.26359 20.4647 8.08567 20.2868C7.91433 20.1089 7.82867 19.898 7.82867 19.6542C7.82867 19.4038 7.91433 19.1896 8.08567 19.0117C8.26359 18.8404 8.47776 18.7547 8.72817 18.7547H15.2718C15.5222 18.7547 15.7331 18.8404 15.9044 19.0117C16.0758 19.1896 16.1614 19.4038 16.1614 19.6542C16.1614 19.898 16.0758 20.1089 15.9044 20.2868C15.7331 20.4647 15.5222 20.5537 15.2718 20.5537H8.72817Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "78c4db945bb1",
                        link: {
                          to: "",
                          toExternal:
                            "https://www.brex.com/resources/case-studies",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Customer stories",
                        subtitle: "See how top companies use Brex.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M16.0002 2.66663C12.3551 2.66663 9.40016 5.65139 9.40016 9.33329C9.40016 13.0152 12.3551 16 16.0002 16C19.6452 16 22.6002 13.0152 22.6002 9.33329C22.6002 5.65139 19.6452 2.66663 16.0002 2.66663ZM12.3335 9.33329C12.3335 7.28779 13.9751 5.62959 16.0002 5.62959C18.0252 5.62959 19.6668 7.28779 19.6668 9.33329C19.6668 11.3788 18.0252 13.037 16.0002 13.037C13.9751 13.037 12.3335 11.3788 12.3335 9.33329Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M29.9331 21.3834L29.9296 21.3814L29.9238 21.378L29.9052 21.3673L29.8407 21.3307C29.7858 21.2998 29.7072 21.2562 29.6063 21.2016C29.4046 21.0924 29.1135 20.9394 28.7446 20.7571C28.0076 20.393 26.9557 19.9101 25.6818 19.4276C23.1502 18.4687 19.6654 17.4814 16.0002 17.4814C12.3836 17.4814 8.93303 18.2615 6.41205 19.0254C5.14551 19.4092 4.09913 19.7934 3.36571 20.0833C2.99871 20.2284 2.70925 20.3501 2.50888 20.4369C2.40867 20.4803 2.33066 20.5149 2.27631 20.5394L2.21268 20.5682L2.19448 20.5766L2.18885 20.5792L2.18691 20.5801C2.17992 20.5834 2.18555 20.5808 2.18555 20.5808L1.3335 20.978V23.1682C1.33347 23.9491 1.33345 24.6229 1.37834 25.1778C1.42571 25.7635 1.53031 26.346 1.81307 26.9066C2.23491 27.7429 2.90803 28.4228 3.73594 28.8489C4.2909 29.1345 4.86762 29.2402 5.44746 29.288C5.99683 29.3333 6.66382 29.3333 7.43697 29.3333H24.5634C25.3365 29.3333 26.0035 29.3333 26.5529 29.288C27.1327 29.2402 27.7094 29.1345 28.2644 28.8489C29.0923 28.4228 29.7654 27.7429 30.1873 26.9066C30.47 26.346 30.5746 25.7635 30.622 25.1778C30.6669 24.6229 30.6669 23.9492 30.6668 23.1682V21.811C30.6668 21.811 30.2196 21.5504 29.9331 21.3834ZM4.26683 23.1111V22.9094C4.32046 22.8879 4.37641 22.8655 4.43462 22.8425C5.10676 22.5769 6.07704 22.2203 7.25494 21.8634C9.62285 21.1459 12.7722 20.4444 16.0002 20.4444C19.1794 20.4444 22.2946 21.309 24.6518 22.2019C25.8224 22.6453 26.7872 23.0884 27.4557 23.4187C27.5549 23.4677 27.6475 23.5142 27.7332 23.5578C27.7319 24.166 27.726 24.5949 27.6984 24.9365C27.6658 25.339 27.6106 25.4882 27.5736 25.5614C27.433 25.8402 27.2087 26.0668 26.9327 26.2089C26.8602 26.2462 26.7124 26.302 26.314 26.3349C25.8984 26.3692 25.3524 26.3703 24.5068 26.3703H7.4935C6.64789 26.3703 6.10189 26.3692 5.68632 26.3349C5.28789 26.302 5.14016 26.2462 5.06765 26.2089C4.79168 26.0668 4.5673 25.8402 4.42669 25.5614C4.38974 25.4882 4.33448 25.339 4.30193 24.9365C4.26797 24.5167 4.26683 23.9652 4.26683 23.1111Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
              {
                _key: "0b003d0fba89c554ca29eddff812e579",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "/journal",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Blog",
                        subtitle: "Get insights, tips, news, and advice.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M18 0.585815L2 16.5858V22H7.41421L23.4142 6.00003L18 0.585815ZM4 20V17.4142L14.7071 6.70714L17.2929 9.29292L6.58579 20H4Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: null,
                          toExternal: "https://www.brex.com/resources/events",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Events",
                        subtitle: "Connect with us at an event near you.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M3 4C1.34315 4 0 5.34315 0 7V9V10H1C2.10457 10 3 10.8954 3 12C3 13.1046 2.10457 14 1 14H0V15V17C0 18.6569 1.34314 20 3 20H21C22.6569 20 24 18.6569 24 17V15V14H23C21.8954 14 21 13.1046 21 12C21 10.8954 21.8954 10 23 10H24V9V7C24 5.34315 22.6569 4 21 4H3ZM2 7C2 6.44772 2.44772 6 3 6H21C21.5523 6 22 6.44772 22 7V8.12602C20.2748 8.57006 19 10.1362 19 12C19 13.8638 20.2748 15.4299 22 15.874V17C22 17.5523 21.5523 18 21 18H3C2.44772 18 2 17.5523 2 17V15.874C3.72523 15.4299 5 13.8638 5 12C5 10.1362 3.72523 8.57006 2 8.12602V7ZM13.1226 10.4549L12 7L10.8774 10.4549H7.24472L10.1836 12.5902L9.06107 16.0451L12 13.9098L14.9389 16.0451L13.8164 12.5902L16.7553 10.4549H13.1226Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "41c298baca51",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryGray",
            title: {
              text: "The latest",
              linkOnlyOnMobile: true,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: null,
                  toExternal: "https://www.brex.com/resources",
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "b77a81746138",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "4ef1a870102e",
                    _type: "articleListNavModule",
                    articles: [
                      {
                        _type: "articleListNavModuleArticle",
                        _key: "28a79935d2a9",
                        page: {
                          _id: "f523bb6f-0963-42f5-b78c-b81c1c061761",
                          _type: "contentHubArticle",
                          contentHubArticleContent: {
                            articleGroup: { parent: "journal" },
                            articleImage: {
                              image: {
                                datUrl:
                                  "https://brand.brex.com/transform/dd3014e9-285b-434d-a9a6-dbf7a84e87a3/Momentum-article",
                                description: null,
                              },
                            },
                          },
                          meta: {
                            title:
                              "How Brex is doing, 10 months into founder mode",
                            slug: { current: "brex-in-founder-mode" },
                          },
                        },
                        titleOverride:
                          "How Brex is doing, 10 months into founder mode",
                        imageOverride: {
                          datUrl:
                            "https://brand.brex.com/transform/dd3014e9-285b-434d-a9a6-dbf7a84e87a3/Momentum-article",
                          description: null,
                        },
                      },
                      {
                        _type: "articleListNavModuleArticle",
                        _key: "d0704f4dffcc",
                        page: {
                          _id: "e0d5dfb7-261c-477d-b3ab-5bb7f87b8790",
                          _type: "contentHubArticle",
                          contentHubArticleContent: {
                            articleGroup: { parent: "journal" },
                            articleImage: {
                              image: {
                                datUrl:
                                  "https://brand.brex.com/transform/36d253e4-28a1-463f-be25-71b90ff2ca47/BB_navan_announcement_preview",
                                description: null,
                              },
                            },
                          },
                          meta: {
                            title:
                              "Reimagining global cards and travel management for the enterprise",
                            slug: { current: "brex-navan-partnership" },
                          },
                        },
                        titleOverride:
                          "A message from Brex and Navan’s CEOs on our new partnership",
                        imageOverride: {
                          datUrl:
                            "https://brand.brex.com/transform/554212bc-7fd2-49de-b051-8014a9f58f8a/Brex-navan-square",
                          description: null,
                        },
                      },
                      {
                        _type: "articleListNavModuleArticle",
                        _key: "1e1c801e098c",
                        page: {
                          _id: "1f69c98c-805c-4496-aa25-c43cc110b2b2",
                          _type: "corePage",
                          corePageContent: {
                            image: {
                              image: {
                                datUrl:
                                  "https://brand.brex.com/transform/3645f6cc-90e6-46d2-8042-c89a031adc2a/Fall-release_nav",
                                description: null,
                              },
                            },
                          },
                          meta: {
                            title: "Fall Release 2024: Make every dollar count",
                            slug: { current: "fall-2024" },
                          },
                        },
                        titleOverride:
                          "See what's new in Brex with Fall Release '24",
                        imageOverride: {
                          datUrl:
                            "https://brand.brex.com/transform/336e3bba-f82e-48a3-9493-8376ff6793fe/Fall-release_nav-preview",
                          description: null,
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _key: "94381d8efb96",
        _type: "navLink",
        text: "Customers",
        link: {
          to: "/customers",
          toExternal: null,
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "852f2e01f2ec39bc74c89ce6050293fc",
        _type: "navLink",
        text: "Pricing",
        link: {
          to: "",
          toExternal: "https://www.brex.com/pricing",
          noFollow: null,
          hash: null,
        },
      },
    ],
    right: [
      {
        _key: "7140f7b3727f",
        _type: "navLink",
        text: "Sign in",
        link: {
          to: null,
          toExternal: "https://dashboard.brex.com/",
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "31052062d8c7",
        _type: "navLink",
        text: "See a demo",
        link: {
          to: "/book-a-demo",
          toExternal: null,
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "55593003b8b9",
        _type: "navLink",
        text: "Get started",
        link: { to: "/signup", toExternal: null, noFollow: null, hash: null },
      },
    ],
    cta: {
      text: "Control all your spend before it happens, all in one place.",
      link: {
        _key: null,
        _type: "navLink",
        text: "Get started",
        link: { to: "/sales", toExternal: null, noFollow: null, hash: null },
      },
    },
  },
  "924cab25-d091-461c-9c4d-987676bc1139": {
    _type: "navigation",
    _id: "924cab25-d091-461c-9c4d-987676bc1139",
    _updatedAt: "2025-02-27T18:22:02Z",
    title: "2/27 Navigation",
    mobileBreakpoint: null,
    left: [
      {
        _key: "4c3ddc93ebdc",
        _type: "navMenu",
        text: "Products",
        description: null,
        submenu: [
          {
            _key: "79e9582c4b49",
            _type: "navGroup",
            span: 2,
            theme: "PrimaryWhite",
            title: {
              text: "Products",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: null,
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "7e342c9182fa",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8b14c557e5f9",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "055b248ba3d7",
                        link: {
                          to: "/product/credit-card",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Corporate card",
                        subtitle: "Get up to 10-20x higher limits",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M0 6C0 4.34315 1.34315 3 3 3H21C22.6569 3 24 4.34315 24 6V18C24 19.6569 22.6569 21 21 21H3C1.34314 21 0 19.6569 0 18V6ZM3 5C2.44772 5 2 5.44772 2 6V16H11.1415C11.8311 16 12.472 15.6448 12.8375 15.06L14.1625 12.94C14.528 12.3552 15.1689 12 15.8585 12H22V6C22 5.44771 21.5523 5 21 5H3Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "ed0c78f23112",
                        link: {
                          to: "/product/business-account",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Business banking",
                        subtitle: "Earn yield and move money fast",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 0.922852L21.1142 4.56852C22.2531 5.02411 23 6.12724 23 7.35395V9.99988H20V15.9999H23V18.9999C23 20.6567 21.6569 21.9999 20 21.9999H4C2.34315 21.9999 1 20.6567 1 18.9999V15.9999H4V9.99988H1V7.35395C1 6.12724 1.74685 5.02411 2.88583 4.56852L12 0.922852ZM6 15.9999H11V9.99988H6V15.9999ZM13 15.9999H18V9.99988H13V15.9999ZM12 3.07692L3.62861 6.42547C3.24895 6.57734 3 6.94505 3 7.35395V7.99988H15V4.27692L12 3.07692ZM3 18.9999V17.9999H15V19.9999H4C3.44772 19.9999 3 19.5522 3 18.9999Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "0d30fe481533",
                        link: {
                          to: "/product/spend-management",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Spend management",
                        subtitle: "Eliminate manual expense work",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '    <svg\n      width="24"\n      height="24"\n      viewBox="0 0 24 24"\n      fill="none"\n      xmlns="http://www.w3.org/2000/svg"\n    >\n      <path\n        fill-rule="evenodd"\n        clip-rule="evenodd"\n        d="M23.8162 14.1036C23.937 13.4206 24 12.7177 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C12.7177 24 13.4206 23.937 14.1036 23.8162C13.3793 23.3301 12.7509 22.7122 12.2525 21.9969C12.1686 21.999 12.0844 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.0844 21.999 12.1686 21.9969 12.2525C22.7122 12.7509 23.3301 13.3793 23.8162 14.1036ZM18 24C21.3137 24 24 21.3137 24 18C24 14.6863 21.3137 12 18 12C14.6863 12 12 14.6863 12 18C12 21.3137 14.6863 24 18 24ZM19 14L15 19H17.5L17 22L21 17H18.5L19 14ZM14.9332 11.7058C14.4111 11.2654 13.7365 11 13 11H11C10.4477 11 10 10.5523 10 10C10 9.44771 10.4477 9 11 9H14V10H16V7H13V4H11V7C9.34315 7 8 8.34315 8 10C8 11.6569 9.34315 13 11 13H13C13.0325 13 13.0646 13.0016 13.0963 13.0046C13.6318 12.4789 14.2515 12.0386 14.9332 11.7058ZM11.4616 15.5338C11.5462 15.3303 11.6235 15.1443 11.6736 15H10V14H8V17H11C11 16.6443 11.253 16.0356 11.4616 15.5338L11.4616 15.5338Z"\n        fill="currentColor"\n      />\n    </svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
              {
                _key: "381f7b96912b",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "3a4115508c0b",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "b4bd1183c3f0",
                        link: {
                          to: "/product/bill-pay",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Bill pay",
                        subtitle: "Pay vendors faster and easier",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C4.34315 0 3 1.34314 3 3V21C3 22.6569 4.34315 24 6 24H18C19.6569 24 21 22.6569 21 21H19C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44771 2 6 2H14V7H19V11H21V5.58579L15.4142 0H6ZM8 11H16V13H8V11ZM12 15H8V17H12V15ZM23.6715 16L20.6914 12.4238L19.3086 13.5762L20.5785 15.1H16V16.9H20.5785L19.3086 18.4238L20.6914 19.5762L23.6715 16Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "f60fe03cd936",
                        link: {
                          to: "/product/travel-expense-management",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Travel",
                        subtitle: "Book and manage global travel",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M9 0C7.89543 0 7 0.89543 7 2V7H4H3V8V19C3 20.8819 4.2996 22.4603 6.05029 22.8866C6.2208 23.5277 6.80523 24 7.5 24C8.15311 24 8.70873 23.5826 8.91465 23H15.0854C15.2913 23.5826 15.8469 24 16.5 24C17.1948 24 17.7792 23.5277 17.9497 22.8866C19.7004 22.4603 21 20.8819 21 19V8V7H20H17V2C17 0.895431 16.1046 0 15 0H9ZM17 21C18.1046 21 19 20.1046 19 19V9H17H16H8H7H5V19C5 20.1046 5.89543 21 7 21H9H15H17ZM15 7V2L9 2V7H15ZM17 14H7V12H17V14ZM7 18H17V16H7V18Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "569a75fd4e4d",
                        link: {
                          to: "/platform/accounting-automation",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Accounting automation",
                        subtitle: "Close your books in minutes",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="fill=currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M3 2C1.89543 2 1 2.89543 1 4V17C1 18.1046 1.89543 19 3 19H9C9.53043 19 10.0391 19.2107 10.4142 19.5858C10.7893 19.9609 11 20.4696 11 21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21C13 20.4696 13.2107 19.9609 13.5858 19.5858C13.9609 19.2107 14.4696 19 15 19H21C22.1046 19 23 18.1046 23 17V4C23 2.89543 22.1046 2 21 2H16C14.6739 2 13.4021 2.52678 12.4645 3.46447C12.2962 3.63275 12.1411 3.81178 12 3.99997C11.8589 3.81178 11.7038 3.63275 11.5355 3.46447C10.5979 2.52678 9.32608 2 8 2H3ZM13 17.5359C13.6029 17.1878 14.2918 17 15 17H21V4H16C15.2044 4 14.4413 4.31607 13.8787 4.87868C13.3161 5.44129 13 6.20435 13 7V17.5359ZM11 17.5359V7C11 6.20435 10.6839 5.44129 10.1213 4.87868C9.55871 4.31607 8.79565 4 8 4H3V17H9C9.70823 17 10.3971 17.1878 11 17.5359Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "af0469f4ab57062d2d3adc5443bdfee5",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "Platform",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: null,
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "7e342c9182fa",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8b14c557e5f9",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "25420cfd0b03a9254f9b94701064cdb7",
                        link: {
                          to: "/product/embedded-finance",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Brex Embedded",
                        subtitle: "API-driven global payments",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.00004 5.3335C4.00004 3.12436 5.7909 1.3335 8.00004 1.3335H24C26.2092 1.3335 28 3.12436 28 5.3335V6.35202C28.8184 7.08445 29.3334 8.14883 29.3334 9.3335V10.352C30.1517 11.0844 30.6667 12.1488 30.6667 13.3335V26.6668C30.6667 28.876 28.8758 30.6668 26.6667 30.6668H5.33337C3.12424 30.6668 1.33337 28.876 1.33337 26.6668V13.3335C1.33337 12.1488 1.84837 11.0844 2.66671 10.352V9.3335C2.66671 8.14883 3.18171 7.08445 4.00004 6.35202V5.3335ZM24 4.00016C24.7364 4.00016 25.3334 4.59712 25.3334 5.3335H6.66671C6.66671 4.59712 7.26366 4.00016 8.00004 4.00016H24ZM25.3334 8.00016H6.66671C5.93033 8.00016 5.33337 8.59712 5.33337 9.3335H26.6667C26.6667 8.59712 26.0698 8.00016 25.3334 8.00016ZM5.33337 12.0002C4.59699 12.0002 4.00004 12.5971 4.00004 13.3335V24.0002H15.0844C15.8758 24.0002 16.6263 23.6486 17.133 23.0407L18.8671 20.9597C19.3738 20.3517 20.1243 20.0002 20.9157 20.0002H28V13.3335C28 12.5971 27.4031 12.0002 26.6667 12.0002H5.33337Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "5c9a8a4197a57f715fe90402fab034ea",
                        link: {
                          to: "/product/integrations",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Native integrations",
                        subtitle: "ERP, HRIS, productivity, security",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12.168 5.33337C12.7601 3.03307 14.8482 1.33337 17.3333 1.33337C19.8185 1.33337 21.9066 3.03307 22.4986 5.33337H29.3333V14.6667H28C26.5272 14.6667 25.3333 15.8606 25.3333 17.3334C25.3333 18.8061 26.5272 20 28 20H29.3333V29.3334H5.33333V22.4987C3.03303 21.9066 1.33333 19.8185 1.33333 17.3334C1.33333 14.8483 3.03303 12.7601 5.33333 12.1681V5.33337H12.168ZM17.3333 4.00004C15.8606 4.00004 14.6667 5.19395 14.6667 6.66671V8.00004H8V14.6667H6.66667C5.19391 14.6667 4 15.8606 4 17.3334C4 18.8061 5.19391 20 6.66667 20H8V26.6667H26.6667V22.4987C24.3664 21.9066 22.6667 19.8185 22.6667 17.3334C22.6667 14.8483 24.3664 12.7601 26.6667 12.1681V8.00004H20V6.66671C20 5.19395 18.8061 4.00004 17.3333 4.00004Z" fill="#currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "055b248ba3d7",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/platform/brex-ai",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Brex AI",
                        subtitle: "AI-powered assistant & analytics",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill=currentColor xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_6620_871)">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.97183 10.4917C5 10.8023 5.21127 11 5.50704 11C5.78873 11 6 10.8023 6.02817 10.5199C6.52016 6.78525 6.63336 6.76387 10.4983 6.03383L10.5211 6.02952C10.8028 5.98716 11 5.78947 11 5.50706C11 5.21053 10.7887 4.99872 10.5211 4.97047C6.64789 4.43389 6.52113 4.3068 6.02817 0.494223C6 0.197689 5.78873 0 5.50704 0C5.21127 0 5 0.197689 4.97183 0.508344C4.51102 4.21832 4.34094 4.25005 0.577071 4.95215L0.478873 4.97047C0.197183 5.01284 0 5.21053 0 5.50706C0 5.80359 0.197183 5.98716 0.535211 6.02952C4.35211 6.63671 4.50704 6.74968 4.97183 10.4917ZM14.5 24C14.1424 24 13.8563 23.7376 13.7967 23.3559C12.8789 16.8914 12.0088 16.0565 5.6675 15.2097C5.27415 15.162 5 14.8638 5 14.494C5 14.1243 5.27415 13.838 5.67942 13.7903C12.0326 13.0866 12.9385 12.1086 13.7967 5.64407C13.8563 5.2624 14.1305 5 14.5 5C14.8695 5 15.1437 5.2624 15.2033 5.64407C16.0972 12.1086 16.9793 13.0508 23.3325 13.7903C23.7258 13.838 24 14.1243 24 14.494C24 14.8757 23.7258 15.162 23.3325 15.2097C16.9674 15.9134 16.0615 16.8914 15.2033 23.3559C15.1437 23.7376 14.8695 24 14.5 24Z" fill=currentColor/>\n</g>\n<defs>\n<clipPath id="clip0_6620_871">\n<rect width="24" height="24" fill="white"/>\n</clipPath>\n</defs>\n</svg>',
                        },
                      },
                      {
                        _key: "0d30fe481533",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/product/global",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Global ready",
                        subtitle: "Multi-currency and multi-entity",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12 22C12.7474 22 13.7509 21.2878 14.6252 19.3644C14.9377 18.6767 15.2093 17.8808 15.4265 17H8.57345C8.79074 17.8808 9.06226 18.6767 9.37483 19.3644C10.2491 21.2878 11.2526 22 12 22ZM8.19682 15H15.8032C15.9306 14.0553 16 13.0485 16 12C16 10.9515 15.9306 9.94466 15.8032 9H8.19682C8.06943 9.94466 8 10.9515 8 12C8 13.0485 8.06943 14.0553 8.19682 15ZM8.57345 7C8.79074 6.11921 9.06226 5.32328 9.37483 4.63563C10.2491 2.71217 11.2526 2 12 2C12.7474 2 13.7509 2.71217 14.6252 4.63563C14.9377 5.32328 15.2093 6.11921 15.4265 7H8.57345ZM17.8196 9C17.9378 9.96135 18 10.9672 18 12C18 13.0328 17.9378 14.0387 17.8196 15H21.5422C21.8396 14.053 22 13.0452 22 12C22 10.9548 21.8396 9.94704 21.5422 9H17.8196ZM20.6622 7H17.48C17.2208 5.8214 16.8712 4.74364 16.4459 3.80802C16.2881 3.4608 16.1143 3.12233 15.9247 2.79955C17.9212 3.65232 19.5839 5.13598 20.6622 7ZM6.51996 7H3.33782C4.4161 5.13598 6.07877 3.65232 8.07531 2.79955C7.88574 3.12233 7.71193 3.4608 7.5541 3.80802C7.12882 4.74364 6.77917 5.8214 6.51996 7ZM2.4578 9H6.18036C6.06223 9.96135 6 10.9672 6 12C6 13.0328 6.06223 14.0387 6.18036 15H2.4578C2.16035 14.053 2 13.0452 2 12C2 10.9548 2.16035 9.94704 2.4578 9ZM16.4459 20.192C16.8712 19.2564 17.2208 18.1786 17.48 17H20.6622C19.5839 18.864 17.9212 20.3477 15.9247 21.2005C16.1143 20.8777 16.2881 20.5392 16.4459 20.192ZM8.07532 21.2005C6.07877 20.3477 4.4161 18.864 3.33782 17H6.51996C6.77917 18.1786 7.12882 19.2564 7.5541 20.192C7.71193 20.5392 7.88574 20.8777 8.07532 21.2005Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "1e2b0492bcc1",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryGray",
            title: {
              text: "New release",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: { to: "", toExternal: null, noFollow: null, hash: null },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "5860dde6ed0e",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "b3536b8af5b0",
                    _type: "linkHeroNavModule",
                    title: "Make every dollar count",
                    subtitle:
                      "Maximize the value you get from Brex with an all-new Impact Dashboard, smart search, global bill pay, and much more. Check it out!",
                    subtitleV2Raw: null,
                    link: {
                      to: "/release",
                      toExternal: null,
                      noFollow: null,
                      hash: null,
                    },
                    icon: null,
                    media: {
                      media: {
                        type: "IMAGE",
                        datUrl:
                          "https://brand.brex.com/transform/3645f6cc-90e6-46d2-8042-c89a031adc2a/Fall-release_nav",
                        description: null,
                        aspectRatio: 0.6125,
                        videoUrl: null,
                      },
                      mediaStyle: {
                        borderRadius: "6px",
                        customBorderRadius: null,
                      },
                      disableVideoLoop: false,
                    },
                    modifier: null,
                    mediaPosition: "top",
                    showMediaOnMobile: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _key: "53ce45644bd9",
        _type: "navMenu",
        text: "Solutions",
        description: null,
        submenu: [
          {
            _key: "7c4cb829ab72",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "By company size",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: { to: "", toExternal: null, noFollow: null, hash: null },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "aba2aba1f772",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "27f22e08ffc1",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "57d88210c49c",
                        link: {
                          to: "/solutions/startups",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Startups",
                        subtitle: "Get the #1 financial stack for startups",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M0 6C0 4.34315 1.34315 3 3 3H21C22.6569 3 24 4.34315 24 6V18C24 19.6569 22.6569 21 21 21H3C1.34314 21 0 19.6569 0 18V6ZM3 5C2.44772 5 2 5.44772 2 6V16H11.1415C11.8311 16 12.472 15.6448 12.8375 15.06L14.1625 12.94C14.528 12.3552 15.1689 12 15.8585 12H22V6C22 5.44771 21.5523 5 21 5H3Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "72d93b76bb04",
                        link: {
                          to: "/solutions/mid-size-companies",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Mid-sized companies",
                        subtitle: "Scale faster with smart cards & controls",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M13.5629 4.89329C11.6112 4.24273 9.46846 4.52968 7.75671 5.67085L5.92707 6.89061L4.26297 8.00001L5.92707 9.10941L10.263 12L8.51064 13.1682L5.82852 12.0954L5.37504 11.914L4.9117 12.0684L2.95837 12.7195C1.07774 13.3464 0.514287 15.7332 1.91602 17.135L4.64044 19.8594C7.27459 22.4935 11.3783 22.9609 14.5373 20.9865L29.8507 11.4157C31.3672 10.4678 31.5393 8.32517 30.1933 7.14748L29.5796 6.61049C27.1349 4.47137 23.6394 4.02293 20.7339 5.47569L18.5644 6.56045L13.5629 4.89329ZM9.23591 7.88965C10.263 7.20495 11.5486 7.03277 12.7196 7.42311L18.245 9.26492L18.769 9.43957L19.263 9.19258L21.9265 7.86083C23.8635 6.89232 26.1938 7.19128 27.8236 8.61736L28.4373 9.15435L13.124 18.7252C11.018 20.0415 8.28216 19.7299 6.52606 17.9738L3.80164 15.2494L5.29162 14.7527L8.17148 15.9046L8.82269 16.1651L9.40627 15.7761L13.4063 13.1094L15.0704 12L13.4063 10.8906L9.07037 8.00001L9.23591 7.88965ZM2.66667 28H21.3333V25.3333H2.66667V28Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                      {
                        _key: "751c09fb19d7",
                        link: {
                          to: "/solutions/enterprise",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Enterprise",
                        subtitle: "Spend smart across entities, currencies",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="33" height="32" viewBox="0 0 33 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 0C6.29086 0 4.5 1.79086 4.5 4V30V31.924L6.3015 31.2484L8.42376 30.4526L10.5704 31.5259L11.1667 31.824L11.763 31.5259L13.8333 30.4907L15.9037 31.5259L16.5 31.824L17.0963 31.5259L19.1667 30.4907L21.237 31.5259L21.8333 31.824L22.4296 31.5259L24.5762 30.4526L26.6985 31.2484L28.5 31.924V30V4C28.5 1.79086 26.7091 0 24.5 0H8.5ZM7.16667 4C7.16667 3.26362 7.76362 2.66667 8.5 2.66667H24.5C25.2364 2.66667 25.8333 3.26362 25.8333 4V28.076L24.9682 27.7516L24.4238 27.5474L23.9037 27.8074L21.8333 28.8426L19.763 27.8074L19.1667 27.5093L18.5704 27.8074L16.5 28.8426L14.4296 27.8074L13.8333 27.5093L13.237 27.8074L11.1667 28.8426L9.09628 27.8074L8.57624 27.5474L8.03184 27.7516L7.16667 28.076V4ZM19.1667 8H13.8333V5.33333H19.1667V8ZM21.8333 13.3333H11.1667V10.6667H21.8333V13.3333ZM11.1667 18.6667H21.8333V16H11.1667V18.6667ZM16.5 24V21.3333H21.8333V24H16.5Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "b6f631dcf896",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "For partners",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: {
                  to: null,
                  toExternal: null,
                  noFollow: false,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: false,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "32731f9ee7ac",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "3362e675a734",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "d5fde9919472",
                        link: {
                          to: "/partners/accounting",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Accounting firms",
                        subtitle: "Simplify close and earn rewards",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M10.6667 4C7.35296 4 4.66667 6.68629 4.66667 10C4.66667 13.3137 7.35296 16 10.6667 16C13.9804 16 16.6667 13.3137 16.6667 10C16.6667 6.68629 13.9804 4 10.6667 4ZM7.33334 10C7.33334 8.15905 8.82572 6.66667 10.6667 6.66667C12.5076 6.66667 14 8.15905 14 10C14 11.8409 12.5076 13.3333 10.6667 13.3333C8.82572 13.3333 7.33334 11.8409 7.33334 10Z" fill="currentColor"/>\n<path d="M18.3334 10C18.3334 11.6533 17.7863 13.1788 16.8632 14.4054C17.8308 15.3896 19.1774 16 20.6667 16C23.6122 16 26 13.6122 26 10.6667C26 7.72115 23.6122 5.33333 20.6667 5.33333C19.4418 5.33333 18.3134 5.74623 17.4131 6.44042C17.9994 7.49451 18.3334 8.70825 18.3334 10Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M21.3333 21.4744V28H5.54861C4.84575 28 4.23939 28 3.73997 27.9592C3.21284 27.9162 2.68855 27.8211 2.18404 27.564C1.43139 27.1805 0.81947 26.5686 0.435976 25.816C0.178918 25.3115 0.0838297 24.7872 0.0407617 24.26C-4.33574e-05 23.7606 -2.2695e-05 23.1543 1.14681e-06 22.4514V20.7201C0.865588 19.9782 0.310448 20.4539 0.466628 20.3201L0.467715 20.3192C0.489714 20.3005 0.51208 20.2821 0.534606 20.264C0.570185 20.2355 0.618371 20.1977 0.679169 20.1521C0.800747 20.0609 0.972894 19.9383 1.19566 19.7951C1.64114 19.5087 2.28971 19.1395 3.14144 18.7745C4.84824 18.043 7.35963 17.3333 10.6667 17.3333C14.0255 17.3333 16.5734 18.2351 18.2963 19.158C19.1553 19.6182 19.807 20.0823 20.2519 20.4398C20.4744 20.6187 20.6458 20.7713 20.7661 20.8841C20.8263 20.9405 20.8737 20.987 20.9084 21.0219C20.9258 21.0393 20.94 21.0539 20.9511 21.0653L20.9706 21.0858L20.9728 21.0882L20.9738 21.0893C21.1327 21.2595 20.6069 20.6962 21.3333 21.4744ZM2.66667 22.0197V22.4C2.66667 23.1687 2.66771 23.6651 2.69857 24.0429C2.72817 24.4051 2.7784 24.5394 2.81199 24.6053C2.93982 24.8562 3.1438 25.0602 3.39468 25.188C3.46061 25.2216 3.5949 25.2718 3.95712 25.3014C4.3349 25.3323 4.83126 25.3333 5.6 25.3333H18.6667V22.588C18.6398 22.5657 18.6114 22.5425 18.5815 22.5185C18.2486 22.251 17.7336 21.8818 17.037 21.5086C15.6488 20.7649 13.53 20 10.6667 20C7.75149 20 5.59621 20.6237 4.19189 21.2255C3.50822 21.5185 2.99978 21.8076 2.66667 22.0197Z" fill="currentColor"/>\n<path d="M22.6667 21.2174V28H27.7333C29.2268 28 29.9736 28 30.544 27.7094C31.0458 27.4537 31.4537 27.0457 31.7094 26.544C32 25.9735 32 25.2268 32 23.7333V20.6667C32 20.6667 27.5556 17.3333 21.3333 17.3333C20.0653 17.3333 18.9264 17.4441 17.9168 17.6205C21.0834 19.1522 22.6667 21.2174 22.6667 21.2174Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "102d59011244",
                        link: {
                          to: "/product/embedded-finance",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "B2B software",
                        subtitle: "Embed Brex cards in your products",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.00004 5.3335C4.00004 3.12436 5.7909 1.3335 8.00004 1.3335H24C26.2092 1.3335 28 3.12436 28 5.3335V6.35202C28.8184 7.08445 29.3334 8.14883 29.3334 9.3335V10.352C30.1517 11.0844 30.6667 12.1488 30.6667 13.3335V26.6668C30.6667 28.876 28.8758 30.6668 26.6667 30.6668H5.33337C3.12424 30.6668 1.33337 28.876 1.33337 26.6668V13.3335C1.33337 12.1488 1.84837 11.0844 2.66671 10.352V9.3335C2.66671 8.14883 3.18171 7.08445 4.00004 6.35202V5.3335ZM24 4.00016C24.7364 4.00016 25.3334 4.59712 25.3334 5.3335H6.66671C6.66671 4.59712 7.26366 4.00016 8.00004 4.00016H24ZM25.3334 8.00016H6.66671C5.93033 8.00016 5.33337 8.59712 5.33337 9.3335H26.6667C26.6667 8.59712 26.0698 8.00016 25.3334 8.00016ZM5.33337 12.0002C4.59699 12.0002 4.00004 12.5971 4.00004 13.3335V24.0002H15.0844C15.8758 24.0002 16.6263 23.6486 17.133 23.0407L18.8671 20.9597C19.3738 20.3517 20.1243 20.0002 20.9157 20.0002H28V13.3335C28 12.5971 27.4031 12.0002 26.6667 12.0002H5.33337Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _key: "3adc58d91a4b",
        _type: "navMenu",
        text: "Resources",
        description: null,
        submenu: [
          {
            _key: "79d0fdf35784",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "Customer Hub",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: "/customer-hub",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "86ec301ad222",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "/support",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Help Center",
                        subtitle: "Find answers to common questions.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M10.5 17.5C10.5 16.6716 11.1716 16 12 16C12.8284 16 13.5 16.6716 13.5 17.5C13.5 18.3284 12.8284 19 12 19C11.1716 19 10.5 18.3284 10.5 17.5Z" fill="currentColor"/>\n<path d="M12 5C9.79086 5 8 6.79086 8 9H10C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9V9.39445C14 10.0632 13.6658 10.6876 13.1094 11.0585L12.7812 11.2774C11.6684 12.0192 11 13.2681 11 14.6056V15H13V14.6056C13 13.9368 13.3342 13.3124 13.8906 12.9415L14.2188 12.7226C15.3316 11.9808 16 10.7319 16 9.39445V9C16 6.79086 14.2091 5 12 5Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/implementation",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Implementation guides",
                        subtitle: "Learn how to set up key features.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_5399_39609)">\n<path d="M9 12V10H13V16H15V18H9V16H11V12H9Z" fill="currentColor"/>\n<path d="M12 9C12.8284 9 13.5 8.32843 13.5 7.5C13.5 6.67157 12.8284 6 12 6C11.1716 6 10.5 6.67157 10.5 7.5C10.5 8.32843 11.1716 9 12 9Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor"/>\n</g>\n<defs>\n<clipPath id="clip0_5399_39609">\n<rect width="24" height="24" fill="currentColor"/>\n</clipPath>\n</defs>\n</svg>\n',
                        },
                      },
                      {
                        _key: "78c4db945bb1",
                        link: {
                          to: "/release",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Product releases",
                        subtitle: "See what’s new at Brex",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m26.6667 2.66675v4 3.99995c1.4145 0 2.771.562 3.7712 1.5621 1.0002 1.0002 1.5621 2.3568 1.5621 3.7713s-.5619 2.771-1.5621 3.7712-2.3567 1.5621-3.7712 1.5621v4 4h-2.6667v-2.8705l-9.4081-1.568c-.4256 2.5195-2.618 4.4386-5.25857 4.4386-2.94551 0-5.33333-2.3879-5.33333-5.3334 0-.292.02359-.579.06902-.859l-.72662-.1211c-1.92875-.3215-3.3424-1.9902-3.3424-3.9456v-6.1486c0-1.9554 1.41365-3.62416 3.3424-3.94562l20.6576-3.44293v-2.8705zm-19.96724 20.91275 5.26164.8769c-.2165 1.2554-1.3106 2.2104-2.62777 2.2104-1.47276 0-2.66666-1.1939-2.66666-2.6667 0-.1435.01122-.2839.03279-.4206zm17.30054-15.3388-20.2192 3.3699c-.64292.1071-1.11413.6634-1.11413 1.3152v6.1486c0 .6518.47121 1.208 1.11413 1.3152l20.2192 3.3699z" fill="currentColor" fill-rule="evenodd"/></svg>',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "4ce7782d1713ef14f57e6d62fb24e62e",
            _type: "navGroup",
            span: 2,
            theme: "PrimaryWhite",
            title: {
              text: "Resource Center",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: "/resources",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "86ec301ad222",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/resources/ebooks",
                          noFollow: null,
                          hash: null,
                        },
                        text: "White papers and e-books",
                        subtitle: "Access exclusive research and reports.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="33" height="32" viewBox="0 0 33 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M21.8333 18.6667V16H11.1667V18.6667H21.8333Z" fill="currentColor"/>\n<path d="M11.1667 24V21.3333H21.8333V24H11.1667Z" fill="currentColor"/>\n<path d="M16.5 6.66667H11.1667V9.33333H16.5V6.66667Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 4C4.5 1.79086 6.29086 0 8.5 0H21.0523L28.5 7.44772V28C28.5 30.2091 26.7091 32 24.5 32H8.5C6.29086 32 4.5 30.2091 4.5 28V4ZM8.5 2.66667C7.76362 2.66667 7.16667 3.26362 7.16667 4V28C7.16667 28.7364 7.76362 29.3333 8.5 29.3333H24.5C25.2364 29.3333 25.8333 28.7364 25.8333 28V9.33333H19.1667V2.66667H8.5Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: null,
                          toExternal: "https://www.brex.com/resources/webinars",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Webinars",
                        subtitle: "Tune in for actionable insights.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="21" viewBox="0 0 24 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M2.47117 16.9754C1.70016 16.9754 1.0939 16.758 0.652389 16.3231C0.217463 15.8815 0 15.272 0 14.4944V2.59324C0 1.81565 0.217463 1.20938 0.652389 0.774459C1.0939 0.339533 1.70016 0.12207 2.47117 0.12207H21.5288C22.2998 0.12207 22.9028 0.339533 23.3377 0.774459C23.7792 1.20938 24 1.81565 24 2.59324V14.4944C24 15.272 23.7792 15.8815 23.3377 16.3231C22.9028 16.758 22.2998 16.9754 21.5288 16.9754H2.47117ZM2.31301 12.3988H21.6771C21.9605 12.3988 22.1021 12.2605 22.1021 11.9837V2.71186C22.1021 2.49439 22.0395 2.32635 21.9143 2.20774C21.7891 2.08253 21.6244 2.01993 21.4201 2.01993H2.5799C2.37562 2.01993 2.21087 2.08253 2.08567 2.20774C1.96046 2.32635 1.89786 2.49439 1.89786 2.71186V11.9837C1.89786 12.2605 2.03624 12.3988 2.31301 12.3988ZM9 19V15.8792H15V19.0117L9 19ZM8.72817 20.5537C8.47776 20.5537 8.26359 20.4647 8.08567 20.2868C7.91433 20.1089 7.82867 19.898 7.82867 19.6542C7.82867 19.4038 7.91433 19.1896 8.08567 19.0117C8.26359 18.8404 8.47776 18.7547 8.72817 18.7547H15.2718C15.5222 18.7547 15.7331 18.8404 15.9044 19.0117C16.0758 19.1896 16.1614 19.4038 16.1614 19.6542C16.1614 19.898 16.0758 20.1089 15.9044 20.2868C15.7331 20.4647 15.5222 20.5537 15.2718 20.5537H8.72817Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "78c4db945bb1",
                        link: {
                          to: "",
                          toExternal:
                            "https://www.brex.com/resources/case-studies",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Customer stories",
                        subtitle: "See how top companies use Brex.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M16.0002 2.66663C12.3551 2.66663 9.40016 5.65139 9.40016 9.33329C9.40016 13.0152 12.3551 16 16.0002 16C19.6452 16 22.6002 13.0152 22.6002 9.33329C22.6002 5.65139 19.6452 2.66663 16.0002 2.66663ZM12.3335 9.33329C12.3335 7.28779 13.9751 5.62959 16.0002 5.62959C18.0252 5.62959 19.6668 7.28779 19.6668 9.33329C19.6668 11.3788 18.0252 13.037 16.0002 13.037C13.9751 13.037 12.3335 11.3788 12.3335 9.33329Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M29.9331 21.3834L29.9296 21.3814L29.9238 21.378L29.9052 21.3673L29.8407 21.3307C29.7858 21.2998 29.7072 21.2562 29.6063 21.2016C29.4046 21.0924 29.1135 20.9394 28.7446 20.7571C28.0076 20.393 26.9557 19.9101 25.6818 19.4276C23.1502 18.4687 19.6654 17.4814 16.0002 17.4814C12.3836 17.4814 8.93303 18.2615 6.41205 19.0254C5.14551 19.4092 4.09913 19.7934 3.36571 20.0833C2.99871 20.2284 2.70925 20.3501 2.50888 20.4369C2.40867 20.4803 2.33066 20.5149 2.27631 20.5394L2.21268 20.5682L2.19448 20.5766L2.18885 20.5792L2.18691 20.5801C2.17992 20.5834 2.18555 20.5808 2.18555 20.5808L1.3335 20.978V23.1682C1.33347 23.9491 1.33345 24.6229 1.37834 25.1778C1.42571 25.7635 1.53031 26.346 1.81307 26.9066C2.23491 27.7429 2.90803 28.4228 3.73594 28.8489C4.2909 29.1345 4.86762 29.2402 5.44746 29.288C5.99683 29.3333 6.66382 29.3333 7.43697 29.3333H24.5634C25.3365 29.3333 26.0035 29.3333 26.5529 29.288C27.1327 29.2402 27.7094 29.1345 28.2644 28.8489C29.0923 28.4228 29.7654 27.7429 30.1873 26.9066C30.47 26.346 30.5746 25.7635 30.622 25.1778C30.6669 24.6229 30.6669 23.9492 30.6668 23.1682V21.811C30.6668 21.811 30.2196 21.5504 29.9331 21.3834ZM4.26683 23.1111V22.9094C4.32046 22.8879 4.37641 22.8655 4.43462 22.8425C5.10676 22.5769 6.07704 22.2203 7.25494 21.8634C9.62285 21.1459 12.7722 20.4444 16.0002 20.4444C19.1794 20.4444 22.2946 21.309 24.6518 22.2019C25.8224 22.6453 26.7872 23.0884 27.4557 23.4187C27.5549 23.4677 27.6475 23.5142 27.7332 23.5578C27.7319 24.166 27.726 24.5949 27.6984 24.9365C27.6658 25.339 27.6106 25.4882 27.5736 25.5614C27.433 25.8402 27.2087 26.0668 26.9327 26.2089C26.8602 26.2462 26.7124 26.302 26.314 26.3349C25.8984 26.3692 25.3524 26.3703 24.5068 26.3703H7.4935C6.64789 26.3703 6.10189 26.3692 5.68632 26.3349C5.28789 26.302 5.14016 26.2462 5.06765 26.2089C4.79168 26.0668 4.5673 25.8402 4.42669 25.5614C4.38974 25.4882 4.33448 25.339 4.30193 24.9365C4.26797 24.5167 4.26683 23.9652 4.26683 23.1111Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
              {
                _key: "0b003d0fba89c554ca29eddff812e579",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "/journal",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Blog",
                        subtitle: "Get insights, tips, news, and advice.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M18 0.585815L2 16.5858V22H7.41421L23.4142 6.00003L18 0.585815ZM4 20V17.4142L14.7071 6.70714L17.2929 9.29292L6.58579 20H4Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: null,
                          toExternal: "https://www.brex.com/resources/events",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Events",
                        subtitle: "Connect with us at an event near you.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M3 4C1.34315 4 0 5.34315 0 7V9V10H1C2.10457 10 3 10.8954 3 12C3 13.1046 2.10457 14 1 14H0V15V17C0 18.6569 1.34314 20 3 20H21C22.6569 20 24 18.6569 24 17V15V14H23C21.8954 14 21 13.1046 21 12C21 10.8954 21.8954 10 23 10H24V9V7C24 5.34315 22.6569 4 21 4H3ZM2 7C2 6.44772 2.44772 6 3 6H21C21.5523 6 22 6.44772 22 7V8.12602C20.2748 8.57006 19 10.1362 19 12C19 13.8638 20.2748 15.4299 22 15.874V17C22 17.5523 21.5523 18 21 18H3C2.44772 18 2 17.5523 2 17V15.874C3.72523 15.4299 5 13.8638 5 12C5 10.1362 3.72523 8.57006 2 8.12602V7ZM13.1226 10.4549L12 7L10.8774 10.4549H7.24472L10.1836 12.5902L9.06107 16.0451L12 13.9098L14.9389 16.0451L13.8164 12.5902L16.7553 10.4549H13.1226Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "41c298baca51",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryGray",
            title: {
              text: "The latest",
              linkOnlyOnMobile: true,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: null,
                  toExternal: "https://www.brex.com/resources",
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "b77a81746138",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "4ef1a870102e",
                    _type: "articleListNavModule",
                    articles: [
                      {
                        _type: "articleListNavModuleArticle",
                        _key: "28a79935d2a9",
                        page: {
                          _id: "f523bb6f-0963-42f5-b78c-b81c1c061761",
                          _type: "contentHubArticle",
                          contentHubArticleContent: {
                            articleGroup: { parent: "journal" },
                            articleImage: {
                              image: {
                                datUrl:
                                  "https://brand.brex.com/transform/dd3014e9-285b-434d-a9a6-dbf7a84e87a3/Momentum-article",
                                description: null,
                              },
                            },
                          },
                          meta: {
                            title:
                              "How Brex is doing, 10 months into founder mode",
                            slug: { current: "brex-in-founder-mode" },
                          },
                        },
                        titleOverride:
                          "How Brex is doing, 10 months into founder mode",
                        imageOverride: {
                          datUrl:
                            "https://brand.brex.com/transform/dd3014e9-285b-434d-a9a6-dbf7a84e87a3/Momentum-article",
                          description: null,
                        },
                      },
                      {
                        _type: "articleListNavModuleArticle",
                        _key: "d0704f4dffcc",
                        page: {
                          _id: "e0d5dfb7-261c-477d-b3ab-5bb7f87b8790",
                          _type: "contentHubArticle",
                          contentHubArticleContent: {
                            articleGroup: { parent: "journal" },
                            articleImage: {
                              image: {
                                datUrl:
                                  "https://brand.brex.com/transform/36d253e4-28a1-463f-be25-71b90ff2ca47/BB_navan_announcement_preview",
                                description: null,
                              },
                            },
                          },
                          meta: {
                            title:
                              "Reimagining global cards and travel management for the enterprise",
                            slug: { current: "brex-navan-partnership" },
                          },
                        },
                        titleOverride:
                          "A message from Brex and Navan’s CEOs on our new partnership",
                        imageOverride: {
                          datUrl:
                            "https://brand.brex.com/transform/554212bc-7fd2-49de-b051-8014a9f58f8a/Brex-navan-square",
                          description: null,
                        },
                      },
                      {
                        _type: "articleListNavModuleArticle",
                        _key: "1e1c801e098c",
                        page: {
                          _id: "1f69c98c-805c-4496-aa25-c43cc110b2b2",
                          _type: "corePage",
                          corePageContent: {
                            image: {
                              image: {
                                datUrl:
                                  "https://brand.brex.com/transform/3645f6cc-90e6-46d2-8042-c89a031adc2a/Fall-release_nav",
                                description: null,
                              },
                            },
                          },
                          meta: {
                            title: "Fall Release 2024: Make every dollar count",
                            slug: { current: "fall-2024" },
                          },
                        },
                        titleOverride:
                          "See what's new in Brex with Fall Release '24",
                        imageOverride: {
                          datUrl:
                            "https://brand.brex.com/transform/336e3bba-f82e-48a3-9493-8376ff6793fe/Fall-release_nav-preview",
                          description: null,
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _key: "94381d8efb96",
        _type: "navLink",
        text: "Customers",
        link: {
          to: "/customers",
          toExternal: null,
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "852f2e01f2ec39bc74c89ce6050293fc",
        _type: "navLink",
        text: "Pricing",
        link: {
          to: "",
          toExternal: "https://www.brex.com/pricing",
          noFollow: null,
          hash: null,
        },
      },
    ],
    right: [
      {
        _key: "7140f7b3727f",
        _type: "navLink",
        text: "Sign in",
        link: {
          to: null,
          toExternal: "https://dashboard.brex.com/",
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "31052062d8c7",
        _type: "navLink",
        text: "See a demo",
        link: {
          to: "/book-a-demo",
          toExternal: null,
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "55593003b8b9",
        _type: "navLink",
        text: "Get started",
        link: { to: "/signup", toExternal: null, noFollow: null, hash: null },
      },
    ],
    cta: {
      text: "Control all your spend before it happens, all in one place.",
      link: {
        _key: null,
        _type: "navLink",
        text: "Get started",
        link: { to: "/sales", toExternal: null, noFollow: null, hash: null },
      },
    },
  },
  "cf2e2628-6641-4345-90a9-e15c5b6074b6": {
    _type: "navigation",
    _id: "cf2e2628-6641-4345-90a9-e15c5b6074b6",
    _updatedAt: "2025-08-28T20:57:35Z",
    title: "7/8/25 Navigation - Summer Release",
    mobileBreakpoint: null,
    left: [
      {
        _key: "4c3ddc93ebdc",
        _type: "navMenu",
        text: "Products",
        description: null,
        submenu: [
          {
            _key: "79e9582c4b49",
            _type: "navGroup",
            span: 2,
            theme: "PrimaryWhite",
            title: {
              text: "Products",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: null,
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "7e342c9182fa",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8b14c557e5f9",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "055b248ba3d7",
                        link: {
                          to: "/product/credit-card",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Corporate card",
                        subtitle: "Get up to 10-20x higher limits",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M0 6C0 4.34315 1.34315 3 3 3H21C22.6569 3 24 4.34315 24 6V18C24 19.6569 22.6569 21 21 21H3C1.34314 21 0 19.6569 0 18V6ZM3 5C2.44772 5 2 5.44772 2 6V16H11.1415C11.8311 16 12.472 15.6448 12.8375 15.06L14.1625 12.94C14.528 12.3552 15.1689 12 15.8585 12H22V6C22 5.44771 21.5523 5 21 5H3Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "ed0c78f23112",
                        link: {
                          to: "/product/business-account",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Business banking",
                        subtitle: null,
                        subtitleV2Raw: [
                          {
                            _key: "b81354501156",
                            markDefs: [],
                            children: [
                              {
                                text: "Bank smarter with up to ",
                                _key: "d284664147150",
                                _type: "span",
                                marks: [],
                              },
                              {
                                copyLibraryItem: {
                                  _type: "reference",
                                  _ref: "yieldRateTier5",
                                  _id: "yieldRateTier5",
                                  text: "4.36%",
                                  type: "number",
                                  date: null,
                                  number: {
                                    value: 4.2,
                                    prefix: null,
                                    suffix: "%†",
                                  },
                                },
                                _type: "copyLibraryReference",
                                _key: "d0b2c9d01257",
                              },
                              {
                                marks: [],
                                text: "",
                                _key: "ef01d103eea6",
                                _type: "span",
                              },
                            ],
                            _type: "block",
                            style: "normal",
                          },
                        ],
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 0.922852L21.1142 4.56852C22.2531 5.02411 23 6.12724 23 7.35395V9.99988H20V15.9999H23V18.9999C23 20.6567 21.6569 21.9999 20 21.9999H4C2.34315 21.9999 1 20.6567 1 18.9999V15.9999H4V9.99988H1V7.35395C1 6.12724 1.74685 5.02411 2.88583 4.56852L12 0.922852ZM6 15.9999H11V9.99988H6V15.9999ZM13 15.9999H18V9.99988H13V15.9999ZM12 3.07692L3.62861 6.42547C3.24895 6.57734 3 6.94505 3 7.35395V7.99988H15V4.27692L12 3.07692ZM3 18.9999V17.9999H15V19.9999H4C3.44772 19.9999 3 19.5522 3 18.9999Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "0d30fe481533",
                        link: {
                          to: "/product/spend-management",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Spend management",
                        subtitle: "Eliminate manual expense work",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '    <svg\n      width="24"\n      height="24"\n      viewBox="0 0 24 24"\n      fill="none"\n      xmlns="http://www.w3.org/2000/svg"\n    >\n      <path\n        fill-rule="evenodd"\n        clip-rule="evenodd"\n        d="M23.8162 14.1036C23.937 13.4206 24 12.7177 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C12.7177 24 13.4206 23.937 14.1036 23.8162C13.3793 23.3301 12.7509 22.7122 12.2525 21.9969C12.1686 21.999 12.0844 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.0844 21.999 12.1686 21.9969 12.2525C22.7122 12.7509 23.3301 13.3793 23.8162 14.1036ZM18 24C21.3137 24 24 21.3137 24 18C24 14.6863 21.3137 12 18 12C14.6863 12 12 14.6863 12 18C12 21.3137 14.6863 24 18 24ZM19 14L15 19H17.5L17 22L21 17H18.5L19 14ZM14.9332 11.7058C14.4111 11.2654 13.7365 11 13 11H11C10.4477 11 10 10.5523 10 10C10 9.44771 10.4477 9 11 9H14V10H16V7H13V4H11V7C9.34315 7 8 8.34315 8 10C8 11.6569 9.34315 13 11 13H13C13.0325 13 13.0646 13.0016 13.0963 13.0046C13.6318 12.4789 14.2515 12.0386 14.9332 11.7058ZM11.4616 15.5338C11.5462 15.3303 11.6235 15.1443 11.6736 15H10V14H8V17H11C11 16.6443 11.253 16.0356 11.4616 15.5338L11.4616 15.5338Z"\n        fill="currentColor"\n      />\n    </svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
              {
                _key: "381f7b96912b",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "3a4115508c0b",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "b4bd1183c3f0",
                        link: {
                          to: "/product/bill-pay",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Bill pay",
                        subtitle: "Pay vendors faster and easier",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C4.34315 0 3 1.34314 3 3V21C3 22.6569 4.34315 24 6 24H18C19.6569 24 21 22.6569 21 21H19C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44771 2 6 2H14V7H19V11H21V5.58579L15.4142 0H6ZM8 11H16V13H8V11ZM12 15H8V17H12V15ZM23.6715 16L20.6914 12.4238L19.3086 13.5762L20.5785 15.1H16V16.9H20.5785L19.3086 18.4238L20.6914 19.5762L23.6715 16Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "f60fe03cd936",
                        link: {
                          to: "/product/travel-expense-management",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Travel",
                        subtitle: "Book and manage global travel",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M9 0C7.89543 0 7 0.89543 7 2V7H4H3V8V19C3 20.8819 4.2996 22.4603 6.05029 22.8866C6.2208 23.5277 6.80523 24 7.5 24C8.15311 24 8.70873 23.5826 8.91465 23H15.0854C15.2913 23.5826 15.8469 24 16.5 24C17.1948 24 17.7792 23.5277 17.9497 22.8866C19.7004 22.4603 21 20.8819 21 19V8V7H20H17V2C17 0.895431 16.1046 0 15 0H9ZM17 21C18.1046 21 19 20.1046 19 19V9H17H16H8H7H5V19C5 20.1046 5.89543 21 7 21H9H15H17ZM15 7V2L9 2V7H15ZM17 14H7V12H17V14ZM7 18H17V16H7V18Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "569a75fd4e4d",
                        link: {
                          to: "/platform/accounting-automation",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Accounting automation",
                        subtitle: "Close your books in minutes",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="fill=currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M3 2C1.89543 2 1 2.89543 1 4V17C1 18.1046 1.89543 19 3 19H9C9.53043 19 10.0391 19.2107 10.4142 19.5858C10.7893 19.9609 11 20.4696 11 21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21C13 20.4696 13.2107 19.9609 13.5858 19.5858C13.9609 19.2107 14.4696 19 15 19H21C22.1046 19 23 18.1046 23 17V4C23 2.89543 22.1046 2 21 2H16C14.6739 2 13.4021 2.52678 12.4645 3.46447C12.2962 3.63275 12.1411 3.81178 12 3.99997C11.8589 3.81178 11.7038 3.63275 11.5355 3.46447C10.5979 2.52678 9.32608 2 8 2H3ZM13 17.5359C13.6029 17.1878 14.2918 17 15 17H21V4H16C15.2044 4 14.4413 4.31607 13.8787 4.87868C13.3161 5.44129 13 6.20435 13 7V17.5359ZM11 17.5359V7C11 6.20435 10.6839 5.44129 10.1213 4.87868C9.55871 4.31607 8.79565 4 8 4H3V17H9C9.70823 17 10.3971 17.1878 11 17.5359Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "af0469f4ab57062d2d3adc5443bdfee5",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "Platform",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: null,
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "7e342c9182fa",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8b14c557e5f9",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "25420cfd0b03a9254f9b94701064cdb7",
                        link: {
                          to: "/product/embedded-finance",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Brex Embedded",
                        subtitle: "API-driven global payments",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.00004 5.3335C4.00004 3.12436 5.7909 1.3335 8.00004 1.3335H24C26.2092 1.3335 28 3.12436 28 5.3335V6.35202C28.8184 7.08445 29.3334 8.14883 29.3334 9.3335V10.352C30.1517 11.0844 30.6667 12.1488 30.6667 13.3335V26.6668C30.6667 28.876 28.8758 30.6668 26.6667 30.6668H5.33337C3.12424 30.6668 1.33337 28.876 1.33337 26.6668V13.3335C1.33337 12.1488 1.84837 11.0844 2.66671 10.352V9.3335C2.66671 8.14883 3.18171 7.08445 4.00004 6.35202V5.3335ZM24 4.00016C24.7364 4.00016 25.3334 4.59712 25.3334 5.3335H6.66671C6.66671 4.59712 7.26366 4.00016 8.00004 4.00016H24ZM25.3334 8.00016H6.66671C5.93033 8.00016 5.33337 8.59712 5.33337 9.3335H26.6667C26.6667 8.59712 26.0698 8.00016 25.3334 8.00016ZM5.33337 12.0002C4.59699 12.0002 4.00004 12.5971 4.00004 13.3335V24.0002H15.0844C15.8758 24.0002 16.6263 23.6486 17.133 23.0407L18.8671 20.9597C19.3738 20.3517 20.1243 20.0002 20.9157 20.0002H28V13.3335C28 12.5971 27.4031 12.0002 26.6667 12.0002H5.33337Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "5c9a8a4197a57f715fe90402fab034ea",
                        link: {
                          to: "/product/integrations",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Native integrations",
                        subtitle: "ERP, HRIS, productivity, security",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12.168 5.33337C12.7601 3.03307 14.8482 1.33337 17.3333 1.33337C19.8185 1.33337 21.9066 3.03307 22.4986 5.33337H29.3333V14.6667H28C26.5272 14.6667 25.3333 15.8606 25.3333 17.3334C25.3333 18.8061 26.5272 20 28 20H29.3333V29.3334H5.33333V22.4987C3.03303 21.9066 1.33333 19.8185 1.33333 17.3334C1.33333 14.8483 3.03303 12.7601 5.33333 12.1681V5.33337H12.168ZM17.3333 4.00004C15.8606 4.00004 14.6667 5.19395 14.6667 6.66671V8.00004H8V14.6667H6.66667C5.19391 14.6667 4 15.8606 4 17.3334C4 18.8061 5.19391 20 6.66667 20H8V26.6667H26.6667V22.4987C24.3664 21.9066 22.6667 19.8185 22.6667 17.3334C22.6667 14.8483 24.3664 12.7601 26.6667 12.1681V8.00004H20V6.66671C20 5.19395 18.8061 4.00004 17.3333 4.00004Z" fill="#currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "055b248ba3d7",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/platform/brex-ai",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Brex AI",
                        subtitle: "AI-powered assistant & analytics",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill=currentColor xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_6620_871)">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.97183 10.4917C5 10.8023 5.21127 11 5.50704 11C5.78873 11 6 10.8023 6.02817 10.5199C6.52016 6.78525 6.63336 6.76387 10.4983 6.03383L10.5211 6.02952C10.8028 5.98716 11 5.78947 11 5.50706C11 5.21053 10.7887 4.99872 10.5211 4.97047C6.64789 4.43389 6.52113 4.3068 6.02817 0.494223C6 0.197689 5.78873 0 5.50704 0C5.21127 0 5 0.197689 4.97183 0.508344C4.51102 4.21832 4.34094 4.25005 0.577071 4.95215L0.478873 4.97047C0.197183 5.01284 0 5.21053 0 5.50706C0 5.80359 0.197183 5.98716 0.535211 6.02952C4.35211 6.63671 4.50704 6.74968 4.97183 10.4917ZM14.5 24C14.1424 24 13.8563 23.7376 13.7967 23.3559C12.8789 16.8914 12.0088 16.0565 5.6675 15.2097C5.27415 15.162 5 14.8638 5 14.494C5 14.1243 5.27415 13.838 5.67942 13.7903C12.0326 13.0866 12.9385 12.1086 13.7967 5.64407C13.8563 5.2624 14.1305 5 14.5 5C14.8695 5 15.1437 5.2624 15.2033 5.64407C16.0972 12.1086 16.9793 13.0508 23.3325 13.7903C23.7258 13.838 24 14.1243 24 14.494C24 14.8757 23.7258 15.162 23.3325 15.2097C16.9674 15.9134 16.0615 16.8914 15.2033 23.3559C15.1437 23.7376 14.8695 24 14.5 24Z" fill=currentColor/>\n</g>\n<defs>\n<clipPath id="clip0_6620_871">\n<rect width="24" height="24" fill="white"/>\n</clipPath>\n</defs>\n</svg>',
                        },
                      },
                      {
                        _key: "0d30fe481533",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/product/global",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Global ready",
                        subtitle: "Multi-currency and multi-entity",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12 22C12.7474 22 13.7509 21.2878 14.6252 19.3644C14.9377 18.6767 15.2093 17.8808 15.4265 17H8.57345C8.79074 17.8808 9.06226 18.6767 9.37483 19.3644C10.2491 21.2878 11.2526 22 12 22ZM8.19682 15H15.8032C15.9306 14.0553 16 13.0485 16 12C16 10.9515 15.9306 9.94466 15.8032 9H8.19682C8.06943 9.94466 8 10.9515 8 12C8 13.0485 8.06943 14.0553 8.19682 15ZM8.57345 7C8.79074 6.11921 9.06226 5.32328 9.37483 4.63563C10.2491 2.71217 11.2526 2 12 2C12.7474 2 13.7509 2.71217 14.6252 4.63563C14.9377 5.32328 15.2093 6.11921 15.4265 7H8.57345ZM17.8196 9C17.9378 9.96135 18 10.9672 18 12C18 13.0328 17.9378 14.0387 17.8196 15H21.5422C21.8396 14.053 22 13.0452 22 12C22 10.9548 21.8396 9.94704 21.5422 9H17.8196ZM20.6622 7H17.48C17.2208 5.8214 16.8712 4.74364 16.4459 3.80802C16.2881 3.4608 16.1143 3.12233 15.9247 2.79955C17.9212 3.65232 19.5839 5.13598 20.6622 7ZM6.51996 7H3.33782C4.4161 5.13598 6.07877 3.65232 8.07531 2.79955C7.88574 3.12233 7.71193 3.4608 7.5541 3.80802C7.12882 4.74364 6.77917 5.8214 6.51996 7ZM2.4578 9H6.18036C6.06223 9.96135 6 10.9672 6 12C6 13.0328 6.06223 14.0387 6.18036 15H2.4578C2.16035 14.053 2 13.0452 2 12C2 10.9548 2.16035 9.94704 2.4578 9ZM16.4459 20.192C16.8712 19.2564 17.2208 18.1786 17.48 17H20.6622C19.5839 18.864 17.9212 20.3477 15.9247 21.2005C16.1143 20.8777 16.2881 20.5392 16.4459 20.192ZM8.07532 21.2005C6.07877 20.3477 4.4161 18.864 3.33782 17H6.51996C6.77917 18.1786 7.12882 19.2564 7.5541 20.192C7.71193 20.5392 7.88574 20.8777 8.07532 21.2005Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "1e2b0492bcc1",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryGray",
            title: {
              text: "New release",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: { to: "", toExternal: null, noFollow: null, hash: null },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "5860dde6ed0e",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "b3536b8af5b0",
                    _type: "linkHeroNavModule",
                    title: "Speed meets control ",
                    subtitle: null,
                    subtitleV2Raw: [
                      {
                        _key: "9f5bdc781614",
                        markDefs: [],
                        children: [
                          {
                            _type: "span",
                            marks: [],
                            text: "Gain speed and control with powerful upgrades to Brex AI, purchasing, policies, and roles.",
                            _key: "b146f23d6acd0",
                          },
                        ],
                        _type: "block",
                        style: "normal",
                      },
                    ],
                    link: {
                      to: "/summer-2025",
                      toExternal: null,
                      noFollow: null,
                      hash: null,
                    },
                    icon: null,
                    media: {
                      media: {
                        type: "IMAGE",
                        datUrl:
                          "https://brand.brex.com/transform/baba5930-18d8-4d6f-8eea-645bc054be75/summe-release-2025-nav",
                        description: null,
                        aspectRatio: 0.6325,
                        videoUrl: null,
                      },
                      mediaStyle: {
                        borderRadius: "6px",
                        customBorderRadius: null,
                      },
                      disableVideoLoop: false,
                    },
                    modifier: null,
                    mediaPosition: "top",
                    showMediaOnMobile: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _key: "53ce45644bd9",
        _type: "navMenu",
        text: "Solutions",
        description: null,
        submenu: [
          {
            _key: "7c4cb829ab72",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "By company size",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: { to: "", toExternal: null, noFollow: null, hash: null },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "aba2aba1f772",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "27f22e08ffc1",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "57d88210c49c",
                        link: {
                          to: "/solutions/startups",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Startups",
                        subtitle: "Get the #1 financial stack for startups",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M0 6C0 4.34315 1.34315 3 3 3H21C22.6569 3 24 4.34315 24 6V18C24 19.6569 22.6569 21 21 21H3C1.34314 21 0 19.6569 0 18V6ZM3 5C2.44772 5 2 5.44772 2 6V16H11.1415C11.8311 16 12.472 15.6448 12.8375 15.06L14.1625 12.94C14.528 12.3552 15.1689 12 15.8585 12H22V6C22 5.44771 21.5523 5 21 5H3Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "72d93b76bb04",
                        link: {
                          to: "/solutions/mid-size-companies",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Mid-sized companies",
                        subtitle: "Scale faster with smart cards & controls",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M13.5629 4.89329C11.6112 4.24273 9.46846 4.52968 7.75671 5.67085L5.92707 6.89061L4.26297 8.00001L5.92707 9.10941L10.263 12L8.51064 13.1682L5.82852 12.0954L5.37504 11.914L4.9117 12.0684L2.95837 12.7195C1.07774 13.3464 0.514287 15.7332 1.91602 17.135L4.64044 19.8594C7.27459 22.4935 11.3783 22.9609 14.5373 20.9865L29.8507 11.4157C31.3672 10.4678 31.5393 8.32517 30.1933 7.14748L29.5796 6.61049C27.1349 4.47137 23.6394 4.02293 20.7339 5.47569L18.5644 6.56045L13.5629 4.89329ZM9.23591 7.88965C10.263 7.20495 11.5486 7.03277 12.7196 7.42311L18.245 9.26492L18.769 9.43957L19.263 9.19258L21.9265 7.86083C23.8635 6.89232 26.1938 7.19128 27.8236 8.61736L28.4373 9.15435L13.124 18.7252C11.018 20.0415 8.28216 19.7299 6.52606 17.9738L3.80164 15.2494L5.29162 14.7527L8.17148 15.9046L8.82269 16.1651L9.40627 15.7761L13.4063 13.1094L15.0704 12L13.4063 10.8906L9.07037 8.00001L9.23591 7.88965ZM2.66667 28H21.3333V25.3333H2.66667V28Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                      {
                        _key: "751c09fb19d7",
                        link: {
                          to: "/solutions/enterprise",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Enterprise",
                        subtitle: "Spend smart across entities, currencies",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="33" height="32" viewBox="0 0 33 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 0C6.29086 0 4.5 1.79086 4.5 4V30V31.924L6.3015 31.2484L8.42376 30.4526L10.5704 31.5259L11.1667 31.824L11.763 31.5259L13.8333 30.4907L15.9037 31.5259L16.5 31.824L17.0963 31.5259L19.1667 30.4907L21.237 31.5259L21.8333 31.824L22.4296 31.5259L24.5762 30.4526L26.6985 31.2484L28.5 31.924V30V4C28.5 1.79086 26.7091 0 24.5 0H8.5ZM7.16667 4C7.16667 3.26362 7.76362 2.66667 8.5 2.66667H24.5C25.2364 2.66667 25.8333 3.26362 25.8333 4V28.076L24.9682 27.7516L24.4238 27.5474L23.9037 27.8074L21.8333 28.8426L19.763 27.8074L19.1667 27.5093L18.5704 27.8074L16.5 28.8426L14.4296 27.8074L13.8333 27.5093L13.237 27.8074L11.1667 28.8426L9.09628 27.8074L8.57624 27.5474L8.03184 27.7516L7.16667 28.076V4ZM19.1667 8H13.8333V5.33333H19.1667V8ZM21.8333 13.3333H11.1667V10.6667H21.8333V13.3333ZM11.1667 18.6667H21.8333V16H11.1667V18.6667ZM16.5 24V21.3333H21.8333V24H16.5Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "b6f631dcf896",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "For partners",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: {
                  to: null,
                  toExternal: null,
                  noFollow: false,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: false,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "32731f9ee7ac",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "3362e675a734",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "d5fde9919472",
                        link: {
                          to: "/partners/accounting",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Accounting firms",
                        subtitle: "Simplify close and earn rewards",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M10.6667 4C7.35296 4 4.66667 6.68629 4.66667 10C4.66667 13.3137 7.35296 16 10.6667 16C13.9804 16 16.6667 13.3137 16.6667 10C16.6667 6.68629 13.9804 4 10.6667 4ZM7.33334 10C7.33334 8.15905 8.82572 6.66667 10.6667 6.66667C12.5076 6.66667 14 8.15905 14 10C14 11.8409 12.5076 13.3333 10.6667 13.3333C8.82572 13.3333 7.33334 11.8409 7.33334 10Z" fill="currentColor"/>\n<path d="M18.3334 10C18.3334 11.6533 17.7863 13.1788 16.8632 14.4054C17.8308 15.3896 19.1774 16 20.6667 16C23.6122 16 26 13.6122 26 10.6667C26 7.72115 23.6122 5.33333 20.6667 5.33333C19.4418 5.33333 18.3134 5.74623 17.4131 6.44042C17.9994 7.49451 18.3334 8.70825 18.3334 10Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M21.3333 21.4744V28H5.54861C4.84575 28 4.23939 28 3.73997 27.9592C3.21284 27.9162 2.68855 27.8211 2.18404 27.564C1.43139 27.1805 0.81947 26.5686 0.435976 25.816C0.178918 25.3115 0.0838297 24.7872 0.0407617 24.26C-4.33574e-05 23.7606 -2.2695e-05 23.1543 1.14681e-06 22.4514V20.7201C0.865588 19.9782 0.310448 20.4539 0.466628 20.3201L0.467715 20.3192C0.489714 20.3005 0.51208 20.2821 0.534606 20.264C0.570185 20.2355 0.618371 20.1977 0.679169 20.1521C0.800747 20.0609 0.972894 19.9383 1.19566 19.7951C1.64114 19.5087 2.28971 19.1395 3.14144 18.7745C4.84824 18.043 7.35963 17.3333 10.6667 17.3333C14.0255 17.3333 16.5734 18.2351 18.2963 19.158C19.1553 19.6182 19.807 20.0823 20.2519 20.4398C20.4744 20.6187 20.6458 20.7713 20.7661 20.8841C20.8263 20.9405 20.8737 20.987 20.9084 21.0219C20.9258 21.0393 20.94 21.0539 20.9511 21.0653L20.9706 21.0858L20.9728 21.0882L20.9738 21.0893C21.1327 21.2595 20.6069 20.6962 21.3333 21.4744ZM2.66667 22.0197V22.4C2.66667 23.1687 2.66771 23.6651 2.69857 24.0429C2.72817 24.4051 2.7784 24.5394 2.81199 24.6053C2.93982 24.8562 3.1438 25.0602 3.39468 25.188C3.46061 25.2216 3.5949 25.2718 3.95712 25.3014C4.3349 25.3323 4.83126 25.3333 5.6 25.3333H18.6667V22.588C18.6398 22.5657 18.6114 22.5425 18.5815 22.5185C18.2486 22.251 17.7336 21.8818 17.037 21.5086C15.6488 20.7649 13.53 20 10.6667 20C7.75149 20 5.59621 20.6237 4.19189 21.2255C3.50822 21.5185 2.99978 21.8076 2.66667 22.0197Z" fill="currentColor"/>\n<path d="M22.6667 21.2174V28H27.7333C29.2268 28 29.9736 28 30.544 27.7094C31.0458 27.4537 31.4537 27.0457 31.7094 26.544C32 25.9735 32 25.2268 32 23.7333V20.6667C32 20.6667 27.5556 17.3333 21.3333 17.3333C20.0653 17.3333 18.9264 17.4441 17.9168 17.6205C21.0834 19.1522 22.6667 21.2174 22.6667 21.2174Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "102d59011244",
                        link: {
                          to: "/product/embedded-finance",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "B2B software",
                        subtitle: "Embed Brex cards in your products",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.00004 5.3335C4.00004 3.12436 5.7909 1.3335 8.00004 1.3335H24C26.2092 1.3335 28 3.12436 28 5.3335V6.35202C28.8184 7.08445 29.3334 8.14883 29.3334 9.3335V10.352C30.1517 11.0844 30.6667 12.1488 30.6667 13.3335V26.6668C30.6667 28.876 28.8758 30.6668 26.6667 30.6668H5.33337C3.12424 30.6668 1.33337 28.876 1.33337 26.6668V13.3335C1.33337 12.1488 1.84837 11.0844 2.66671 10.352V9.3335C2.66671 8.14883 3.18171 7.08445 4.00004 6.35202V5.3335ZM24 4.00016C24.7364 4.00016 25.3334 4.59712 25.3334 5.3335H6.66671C6.66671 4.59712 7.26366 4.00016 8.00004 4.00016H24ZM25.3334 8.00016H6.66671C5.93033 8.00016 5.33337 8.59712 5.33337 9.3335H26.6667C26.6667 8.59712 26.0698 8.00016 25.3334 8.00016ZM5.33337 12.0002C4.59699 12.0002 4.00004 12.5971 4.00004 13.3335V24.0002H15.0844C15.8758 24.0002 16.6263 23.6486 17.133 23.0407L18.8671 20.9597C19.3738 20.3517 20.1243 20.0002 20.9157 20.0002H28V13.3335C28 12.5971 27.4031 12.0002 26.6667 12.0002H5.33337Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "61e299c9bbb1d90316237b8db7700aec",
                        link: {
                          to: "/solutions/private-equity",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Private equity",
                        subtitle: "Arm your portfolio with the tools to win",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor." xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M23.8162 14.1036C23.937 13.4206 24 12.7177 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C12.7177 24 13.4206 23.937 14.1036 23.8162C13.3793 23.3301 12.7509 22.7122 12.2525 21.9969C12.1686 21.999 12.0844 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.0844 21.999 12.1686 21.9969 12.2525C22.7122 12.7509 23.3301 13.3793 23.8162 14.1036ZM11 17C11 16.5 11.5 15.5 11.6736 15H10V14H8V17H11ZM14.9332 11.7058C14.4111 11.2654 13.7365 11 13 11H11C10.4477 11 10 10.5523 10 10C10 9.44771 10.4477 9 11 9H14V10H16V7H13V4H11V7C9.34315 7 8 8.34315 8 10C8 11.6569 9.34315 13 11 13H13C13.0325 13 13.0646 13.0016 13.0963 13.0046C13.6318 12.4789 14.2515 12.0386 14.9332 11.7058Z" fill="currentColor."/>\n<path d="M19 16V17H17V16C17 15.4477 17.4477 15 18 15C18.5523 15 19 15.4477 19 16Z" fill="currentColor."/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M18 24C21.3137 24 24 21.3137 24 18C24 14.6863 21.3137 12 18 12C14.6863 12 12 14.6863 12 18C12 21.3137 14.6863 24 18 24ZM16 16C16 14.8954 16.8954 14 18 14C19.1046 14 20 14.8954 20 16V17H21V21H15V17H16V16Z" fill="currentColor."/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "9f4ba3f252376c1f4e27749ba7682cec",
                        link: {
                          to: "/solutions/venture-capital",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Venture capital",
                        subtitle: "Manage spend for your firm & portfolio",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '    <svg\n      width="24"\n      height="24"\n      viewBox="0 0 24 24"\n      fill="none"\n      xmlns="http://www.w3.org/2000/svg"\n    >\n      <path\n        fill-rule="evenodd"\n        clip-rule="evenodd"\n        d="M23.8162 14.1036C23.937 13.4206 24 12.7177 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C12.7177 24 13.4206 23.937 14.1036 23.8162C13.3793 23.3301 12.7509 22.7122 12.2525 21.9969C12.1686 21.999 12.0844 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.0844 21.999 12.1686 21.9969 12.2525C22.7122 12.7509 23.3301 13.3793 23.8162 14.1036ZM18 24C21.3137 24 24 21.3137 24 18C24 14.6863 21.3137 12 18 12C14.6863 12 12 14.6863 12 18C12 21.3137 14.6863 24 18 24ZM19 14L15 19H17.5L17 22L21 17H18.5L19 14ZM14.9332 11.7058C14.4111 11.2654 13.7365 11 13 11H11C10.4477 11 10 10.5523 10 10C10 9.44771 10.4477 9 11 9H14V10H16V7H13V4H11V7C9.34315 7 8 8.34315 8 10C8 11.6569 9.34315 13 11 13H13C13.0325 13 13.0646 13.0016 13.0963 13.0046C13.6318 12.4789 14.2515 12.0386 14.9332 11.7058ZM11.4616 15.5338C11.5462 15.3303 11.6235 15.1443 11.6736 15H10V14H8V17H11C11 16.6443 11.253 16.0356 11.4616 15.5338L11.4616 15.5338Z"\n        fill="currentColor"\n      />\n    </svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _key: "3adc58d91a4b",
        _type: "navMenu",
        text: "Resources",
        description: null,
        submenu: [
          {
            _key: "79d0fdf35784",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "Customer Hub",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: { to: "", toExternal: null, noFollow: null, hash: null },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "86ec301ad222",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "/support",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Help Center",
                        subtitle: "FAQs and best practices",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M10.5 17.5C10.5 16.6716 11.1716 16 12 16C12.8284 16 13.5 16.6716 13.5 17.5C13.5 18.3284 12.8284 19 12 19C11.1716 19 10.5 18.3284 10.5 17.5Z" fill="currentColor"/>\n<path d="M12 5C9.79086 5 8 6.79086 8 9H10C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9V9.39445C14 10.0632 13.6658 10.6876 13.1094 11.0585L12.7812 11.2774C11.6684 12.0192 11 13.2681 11 14.6056V15H13V14.6056C13 13.9368 13.3342 13.3124 13.8906 12.9415L14.2188 12.7226C15.3316 11.9808 16 10.7319 16 9.39445V9C16 6.79086 14.2091 5 12 5Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "78c4db945bb1",
                        link: {
                          to: "/training",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Live training",
                        subtitle: "Live training and guides",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="21" viewBox="0 0 24 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M2.47117 16.9754C1.70016 16.9754 1.0939 16.758 0.652389 16.3231C0.217463 15.8815 0 15.272 0 14.4944V2.59324C0 1.81565 0.217463 1.20938 0.652389 0.774459C1.0939 0.339533 1.70016 0.12207 2.47117 0.12207H21.5288C22.2998 0.12207 22.9028 0.339533 23.3377 0.774459C23.7792 1.20938 24 1.81565 24 2.59324V14.4944C24 15.272 23.7792 15.8815 23.3377 16.3231C22.9028 16.758 22.2998 16.9754 21.5288 16.9754H2.47117ZM2.31301 12.3988H21.6771C21.9605 12.3988 22.1021 12.2605 22.1021 11.9837V2.71186C22.1021 2.49439 22.0395 2.32635 21.9143 2.20774C21.7891 2.08253 21.6244 2.01993 21.4201 2.01993H2.5799C2.37562 2.01993 2.21087 2.08253 2.08567 2.20774C1.96046 2.32635 1.89786 2.49439 1.89786 2.71186V11.9837C1.89786 12.2605 2.03624 12.3988 2.31301 12.3988ZM9 19V15.8792H15V19.0117L9 19ZM8.72817 20.5537C8.47776 20.5537 8.26359 20.4647 8.08567 20.2868C7.91433 20.1089 7.82867 19.898 7.82867 19.6542C7.82867 19.4038 7.91433 19.1896 8.08567 19.0117C8.26359 18.8404 8.47776 18.7547 8.72817 18.7547H15.2718C15.5222 18.7547 15.7331 18.8404 15.9044 19.0117C16.0758 19.1896 16.1614 19.4038 16.1614 19.6542C16.1614 19.898 16.0758 20.1089 15.9044 20.2868C15.7331 20.4647 15.5222 20.5537 15.2718 20.5537H8.72817Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: "",
                          toExternal:
                            "https://www.brex.com/product-announcements",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Product releases",
                        subtitle: "See what's new",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="fill=currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M3 2C1.89543 2 1 2.89543 1 4V17C1 18.1046 1.89543 19 3 19H9C9.53043 19 10.0391 19.2107 10.4142 19.5858C10.7893 19.9609 11 20.4696 11 21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21C13 20.4696 13.2107 19.9609 13.5858 19.5858C13.9609 19.2107 14.4696 19 15 19H21C22.1046 19 23 18.1046 23 17V4C23 2.89543 22.1046 2 21 2H16C14.6739 2 13.4021 2.52678 12.4645 3.46447C12.2962 3.63275 12.1411 3.81178 12 3.99997C11.8589 3.81178 11.7038 3.63275 11.5355 3.46447C10.5979 2.52678 9.32608 2 8 2H3ZM13 17.5359C13.6029 17.1878 14.2918 17 15 17H21V4H16C15.2044 4 14.4413 4.31607 13.8787 4.87868C13.3161 5.44129 13 6.20435 13 7V17.5359ZM11 17.5359V7C11 6.20435 10.6839 5.44129 10.1213 4.87868C9.55871 4.31607 8.79565 4 8 4H3V17H9C9.70823 17 10.3971 17.1878 11 17.5359Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "4ce7782d1713ef14f57e6d62fb24e62e",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "Connect with Brex",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: { to: "", toExternal: null, noFollow: null, hash: null },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "86ec301ad222",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: null,
                          toExternal: "https://www.brex.com/resources/webinars",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Webinars",
                        subtitle: "Watch and learn",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="21" viewBox="0 0 24 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M2.47117 16.9754C1.70016 16.9754 1.0939 16.758 0.652389 16.3231C0.217463 15.8815 0 15.272 0 14.4944V2.59324C0 1.81565 0.217463 1.20938 0.652389 0.774459C1.0939 0.339533 1.70016 0.12207 2.47117 0.12207H21.5288C22.2998 0.12207 22.9028 0.339533 23.3377 0.774459C23.7792 1.20938 24 1.81565 24 2.59324V14.4944C24 15.272 23.7792 15.8815 23.3377 16.3231C22.9028 16.758 22.2998 16.9754 21.5288 16.9754H2.47117ZM2.31301 12.3988H21.6771C21.9605 12.3988 22.1021 12.2605 22.1021 11.9837V2.71186C22.1021 2.49439 22.0395 2.32635 21.9143 2.20774C21.7891 2.08253 21.6244 2.01993 21.4201 2.01993H2.5799C2.37562 2.01993 2.21087 2.08253 2.08567 2.20774C1.96046 2.32635 1.89786 2.49439 1.89786 2.71186V11.9837C1.89786 12.2605 2.03624 12.3988 2.31301 12.3988ZM9 19V15.8792H15V19.0117L9 19ZM8.72817 20.5537C8.47776 20.5537 8.26359 20.4647 8.08567 20.2868C7.91433 20.1089 7.82867 19.898 7.82867 19.6542C7.82867 19.4038 7.91433 19.1896 8.08567 19.0117C8.26359 18.8404 8.47776 18.7547 8.72817 18.7547H15.2718C15.5222 18.7547 15.7331 18.8404 15.9044 19.0117C16.0758 19.1896 16.1614 19.4038 16.1614 19.6542C16.1614 19.898 16.0758 20.1089 15.9044 20.2868C15.7331 20.4647 15.5222 20.5537 15.2718 20.5537H8.72817Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "78c4db945bb1",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/resources/events",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Events",
                        subtitle: "Connect in person",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M9 10H11V12H9V10Z" fill="currentColor"/>\n<path d="M15 10H13V12H15V10Z" fill="currentColor"/>\n<path d="M17 10H19V12H17V10Z" fill="currentColor"/>\n<path d="M15 14H13V16H15V14Z" fill="currentColor"/>\n<path d="M9 14H11V16H9V14Z" fill="currentColor"/>\n<path d="M7 14H5V16H7V14Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.75374 1.32398C4.43407 1.80348 4.20873 2.3784 4.09199 3H3C1.34315 3 0 4.34315 0 6V18C0 19.6569 1.34314 21 3 21H21C22.6569 21 24 19.6569 24 18V6C24 4.34315 22.6569 3 21 3H19.908C19.7913 2.3784 19.5659 1.80348 19.2463 1.32398C18.7651 0.602302 17.9907 0 17 0C16.0093 0 15.2349 0.602302 14.7537 1.32398C14.4341 1.80348 14.2087 2.3784 14.092 3H9.90801C9.79127 2.3784 9.56593 1.80348 9.24626 1.32398C8.76515 0.602302 7.99067 0 7 0C6.00933 0 5.23485 0.602302 4.75374 1.32398ZM6.41784 2.43338C6.31464 2.58818 6.2224 2.77939 6.15101 3H7.84899C7.7776 2.77939 7.68536 2.58818 7.58216 2.43338C7.33942 2.06927 7.1139 2 7 2C6.8861 2 6.66058 2.06927 6.41784 2.43338ZM17.849 3C17.7776 2.77939 17.6854 2.58818 17.5822 2.43338C17.3394 2.06927 17.1139 2 17 2C16.8861 2 16.6606 2.06927 16.4178 2.43338C16.3146 2.58818 16.2224 2.77939 16.151 3H17.849ZM17.849 5H9.90801C9.79127 5.6216 9.56593 6.19652 9.24626 6.67602C8.76515 7.3977 7.99067 8 7 8V6C7.1139 6 7.33942 5.93073 7.58216 5.56662C7.68536 5.41182 7.7776 5.22061 7.84899 5H3C2.44772 5 2 5.44771 2 6V18C2 18.5523 2.44772 19 3 19H21C21.5523 19 22 18.5523 22 18V6C22 5.44771 21.5523 5 21 5H19.908C19.7913 5.6216 19.5659 6.19652 19.2463 6.67602C18.7651 7.3977 17.9907 8 17 8V6C17.1139 6 17.3394 5.93073 17.5822 5.56662C17.6854 5.41182 17.7776 5.22061 17.849 5Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/careers",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Careers",
                        subtitle: "Join us – we're hiring",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M16 2.66675C12.355 2.66675 9.40004 5.65152 9.40004 9.33342C9.40004 13.0153 12.355 16.0001 16 16.0001C19.6451 16.0001 22.6 13.0153 22.6 9.33342C22.6 5.65152 19.6451 2.66675 16 2.66675ZM12.3334 9.33342C12.3334 7.28792 13.975 5.62971 16 5.62971C18.0251 5.62971 19.6667 7.28792 19.6667 9.33342C19.6667 11.3789 18.0251 13.0371 16 13.0371C13.975 13.0371 12.3334 11.3789 12.3334 9.33342ZM16 17.4816C16.4303 17.4816 16.8581 17.4952 17.2822 17.5207C16.4707 18.3619 15.8157 19.3551 15.3642 20.4534C12.3611 20.5369 9.46695 21.1932 7.25482 21.8635C6.07692 22.2205 5.10664 22.577 4.4345 22.8427C4.37629 22.8657 4.32034 22.888 4.26671 22.9096V23.1112C4.26671 23.9653 4.26785 24.5169 4.3018 24.9366C4.33436 25.3391 4.38962 25.4883 4.42657 25.5616C4.56718 25.8403 4.79155 26.0669 5.06753 26.209C5.14004 26.2463 5.28776 26.3021 5.6862 26.335C6.10177 26.3693 6.64777 26.3705 7.49338 26.3705H14.9704C15.252 27.4461 15.7207 28.4461 16.3396 29.3334H7.43685H7.43678C6.66366 29.3334 5.99669 29.3335 5.44734 29.2881C4.8675 29.2403 4.29078 29.1346 3.73582 28.849C2.90791 28.4229 2.23479 27.743 1.81295 26.9067C1.53019 26.3461 1.42559 25.7636 1.37821 25.1779C1.33333 24.623 1.33335 23.9493 1.33338 23.1683V23.1683V20.9781L2.18543 20.5809C2.18543 20.5809 2.1798 20.5835 2.18678 20.5803L2.18873 20.5793L2.19436 20.5767L2.21256 20.5684L2.27619 20.5395C2.33054 20.515 2.40854 20.4804 2.50876 20.437C2.70913 20.3503 2.99859 20.2285 3.36559 20.0834C4.09901 19.7935 5.14539 19.4093 6.41193 19.0255C8.93291 18.2616 12.3835 17.4816 16 17.4816ZM24 32.0001C28.4183 32.0001 32 28.4184 32 24.0001C32 19.5818 28.4183 16.0001 24 16.0001C19.5818 16.0001 16 19.5818 16 24.0001C16 28.4184 19.5818 32.0001 24 32.0001ZM22.6667 20.0001V22.6667H20V25.3334H22.6667V28.0001H25.3334V25.3334H28V22.6667H25.3334V20.0001H22.6667Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "52ad2aa9a6dac50077eafbfec3134452",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "Resource Center",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: "/resources",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "86ec301ad222",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: null,
                          toExternal: "https://www.brex.com/journal",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Blog",
                        subtitle: "Get news and insights",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M18 0.585815L2 16.5858V22H7.41421L23.4142 6.00003L18 0.585815ZM4 20V17.4142L14.7071 6.70714L17.2929 9.29292L6.58579 20H4Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/resources/ebooks",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Exclusive reports",
                        subtitle: "Unlock research and guides",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="33" height="32" viewBox="0 0 33 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M21.8333 18.6667V16H11.1667V18.6667H21.8333Z" fill="currentColor"/>\n<path d="M11.1667 24V21.3333H21.8333V24H11.1667Z" fill="currentColor"/>\n<path d="M16.5 6.66667H11.1667V9.33333H16.5V6.66667Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 4C4.5 1.79086 6.29086 0 8.5 0H21.0523L28.5 7.44772V28C28.5 30.2091 26.7091 32 24.5 32H8.5C6.29086 32 4.5 30.2091 4.5 28V4ZM8.5 2.66667C7.76362 2.66667 7.16667 3.26362 7.16667 4V28C7.16667 28.7364 7.76362 29.3333 8.5 29.3333H24.5C25.2364 29.3333 25.8333 28.7364 25.8333 28V9.33333H19.1667V2.66667H8.5Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "78c4db945bb1",
                        link: {
                          to: "",
                          toExternal:
                            "https://www.brex.com/resources/case-studies",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Customer stories",
                        subtitle: "Learn from the best",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M16.0002 2.66663C12.3551 2.66663 9.40016 5.65139 9.40016 9.33329C9.40016 13.0152 12.3551 16 16.0002 16C19.6452 16 22.6002 13.0152 22.6002 9.33329C22.6002 5.65139 19.6452 2.66663 16.0002 2.66663ZM12.3335 9.33329C12.3335 7.28779 13.9751 5.62959 16.0002 5.62959C18.0252 5.62959 19.6668 7.28779 19.6668 9.33329C19.6668 11.3788 18.0252 13.037 16.0002 13.037C13.9751 13.037 12.3335 11.3788 12.3335 9.33329Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M29.9331 21.3834L29.9296 21.3814L29.9238 21.378L29.9052 21.3673L29.8407 21.3307C29.7858 21.2998 29.7072 21.2562 29.6063 21.2016C29.4046 21.0924 29.1135 20.9394 28.7446 20.7571C28.0076 20.393 26.9557 19.9101 25.6818 19.4276C23.1502 18.4687 19.6654 17.4814 16.0002 17.4814C12.3836 17.4814 8.93303 18.2615 6.41205 19.0254C5.14551 19.4092 4.09913 19.7934 3.36571 20.0833C2.99871 20.2284 2.70925 20.3501 2.50888 20.4369C2.40867 20.4803 2.33066 20.5149 2.27631 20.5394L2.21268 20.5682L2.19448 20.5766L2.18885 20.5792L2.18691 20.5801C2.17992 20.5834 2.18555 20.5808 2.18555 20.5808L1.3335 20.978V23.1682C1.33347 23.9491 1.33345 24.6229 1.37834 25.1778C1.42571 25.7635 1.53031 26.346 1.81307 26.9066C2.23491 27.7429 2.90803 28.4228 3.73594 28.8489C4.2909 29.1345 4.86762 29.2402 5.44746 29.288C5.99683 29.3333 6.66382 29.3333 7.43697 29.3333H24.5634C25.3365 29.3333 26.0035 29.3333 26.5529 29.288C27.1327 29.2402 27.7094 29.1345 28.2644 28.8489C29.0923 28.4228 29.7654 27.7429 30.1873 26.9066C30.47 26.346 30.5746 25.7635 30.622 25.1778C30.6669 24.6229 30.6669 23.9492 30.6668 23.1682V21.811C30.6668 21.811 30.2196 21.5504 29.9331 21.3834ZM4.26683 23.1111V22.9094C4.32046 22.8879 4.37641 22.8655 4.43462 22.8425C5.10676 22.5769 6.07704 22.2203 7.25494 21.8634C9.62285 21.1459 12.7722 20.4444 16.0002 20.4444C19.1794 20.4444 22.2946 21.309 24.6518 22.2019C25.8224 22.6453 26.7872 23.0884 27.4557 23.4187C27.5549 23.4677 27.6475 23.5142 27.7332 23.5578C27.7319 24.166 27.726 24.5949 27.6984 24.9365C27.6658 25.339 27.6106 25.4882 27.5736 25.5614C27.433 25.8402 27.2087 26.0668 26.9327 26.2089C26.8602 26.2462 26.7124 26.302 26.314 26.3349C25.8984 26.3692 25.3524 26.3703 24.5068 26.3703H7.4935C6.64789 26.3703 6.10189 26.3692 5.68632 26.3349C5.28789 26.302 5.14016 26.2462 5.06765 26.2089C4.79168 26.0668 4.5673 25.8402 4.42669 25.5614C4.38974 25.4882 4.33448 25.339 4.30193 24.9365C4.26797 24.5167 4.26683 23.9652 4.26683 23.1111Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "41c298baca51",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryGray",
            title: {
              text: "The latest",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: null,
                  toExternal: "https://www.brex.com/resources",
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "24bcb773c1dd",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "d14d2a279104",
                    _type: "linkHeroNavModule",
                    title: "A new chapter: Brex comes to the EU",
                    subtitle: null,
                    subtitleV2Raw: [
                      {
                        markDefs: [],
                        children: [
                          {
                            _type: "span",
                            marks: [],
                            text: "Learn how Brex's new EU license unlocks intelligent finance for over 200,000 European companies.",
                            _key: "4bc17f1e4ff80",
                          },
                        ],
                        _type: "block",
                        style: "normal",
                        _key: "5fc6e0130960",
                      },
                    ],
                    link: {
                      to: "/journal/eu-license",
                      toExternal: null,
                      noFollow: false,
                      hash: null,
                    },
                    icon: null,
                    media: {
                      media: {
                        type: "IMAGE",
                        datUrl:
                          "https://brand.brex.com/transform/deba553d-9c29-48e0-8154-d6fa596b7fff/1232FINAL-EU-blog-image",
                        description: null,
                        aspectRatio: 0.5275,
                        videoUrl: null,
                      },
                      mediaStyle: {
                        borderRadius: "6px",
                        customBorderRadius: null,
                      },
                      disableVideoLoop: false,
                    },
                    modifier: null,
                    mediaPosition: "top",
                    showMediaOnMobile: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _key: "94381d8efb96",
        _type: "navLink",
        text: "Customers",
        link: {
          to: "/customers",
          toExternal: null,
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "852f2e01f2ec39bc74c89ce6050293fc",
        _type: "navLink",
        text: "Pricing",
        link: {
          to: "",
          toExternal: "https://www.brex.com/pricing",
          noFollow: null,
          hash: null,
        },
      },
    ],
    right: [
      {
        _key: "7140f7b3727f",
        _type: "navLink",
        text: "Sign in",
        link: {
          to: null,
          toExternal: "https://dashboard.brex.com/",
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "31052062d8c7",
        _type: "navLink",
        text: "See a demo",
        link: {
          to: "/book-a-demo",
          toExternal: null,
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "55593003b8b9",
        _type: "navLink",
        text: "Get started",
        link: { to: "/signup", toExternal: null, noFollow: null, hash: null },
      },
    ],
    cta: {
      text: "Control all your spend before it happens, all in one place.",
      link: {
        _key: null,
        _type: "navLink",
        text: "Get started",
        link: { to: "/sales", toExternal: null, noFollow: null, hash: null },
      },
    },
  },
  "da4ca819-d6f7-4b61-aab1-e036be7dc86e": {
    _type: "navigation",
    _id: "da4ca819-d6f7-4b61-aab1-e036be7dc86e",
    _updatedAt: "2024-02-29T16:19:34Z",
    title: "10/20 Navigation",
    mobileBreakpoint: null,
    left: [
      {
        _key: "4c3ddc93ebdc",
        _type: "navMenu",
        text: "Products",
        description: null,
        submenu: [
          {
            _key: "79e9582c4b49",
            _type: "navGroup",
            span: 2,
            theme: "PrimaryWhite",
            title: {
              text: "Products",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: null,
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "7e342c9182fa",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8b14c557e5f9",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "055b248ba3d7",
                        link: {
                          to: "/product/credit-card",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Corporate card",
                        subtitle: "Smart T&E, purchase, and vendor cards",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M0 6C0 4.34315 1.34315 3 3 3H21C22.6569 3 24 4.34315 24 6V18C24 19.6569 22.6569 21 21 21H3C1.34314 21 0 19.6569 0 18V6ZM3 5C2.44772 5 2 5.44772 2 6V16H11.1415C11.8311 16 12.472 15.6448 12.8375 15.06L14.1625 12.94C14.528 12.3552 15.1689 12 15.8585 12H22V6C22 5.44771 21.5523 5 21 5H3Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "0d30fe481533",
                        link: {
                          to: "/product/spend-management",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Expense management",
                        subtitle: "Compliant expenses & reimbursements",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '    <svg\n      width="24"\n      height="24"\n      viewBox="0 0 24 24"\n      fill="none"\n      xmlns="http://www.w3.org/2000/svg"\n    >\n      <path\n        fill-rule="evenodd"\n        clip-rule="evenodd"\n        d="M23.8162 14.1036C23.937 13.4206 24 12.7177 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C12.7177 24 13.4206 23.937 14.1036 23.8162C13.3793 23.3301 12.7509 22.7122 12.2525 21.9969C12.1686 21.999 12.0844 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.0844 21.999 12.1686 21.9969 12.2525C22.7122 12.7509 23.3301 13.3793 23.8162 14.1036ZM18 24C21.3137 24 24 21.3137 24 18C24 14.6863 21.3137 12 18 12C14.6863 12 12 14.6863 12 18C12 21.3137 14.6863 24 18 24ZM19 14L15 19H17.5L17 22L21 17H18.5L19 14ZM14.9332 11.7058C14.4111 11.2654 13.7365 11 13 11H11C10.4477 11 10 10.5523 10 10C10 9.44771 10.4477 9 11 9H14V10H16V7H13V4H11V7C9.34315 7 8 8.34315 8 10C8 11.6569 9.34315 13 11 13H13C13.0325 13 13.0646 13.0016 13.0963 13.0046C13.6318 12.4789 14.2515 12.0386 14.9332 11.7058ZM11.4616 15.5338C11.5462 15.3303 11.6235 15.1443 11.6736 15H10V14H8V17H11C11 16.6443 11.253 16.0356 11.4616 15.5338L11.4616 15.5338Z"\n        fill="currentColor"\n      />\n    </svg>\n',
                        },
                      },
                      {
                        _key: "23bc46b3797f",
                        link: {
                          to: "/product/travel",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Travel",
                        subtitle: "End-to-end travel and group events",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M9 0C7.89543 0 7 0.89543 7 2V7H4H3V8V19C3 20.8819 4.2996 22.4603 6.05029 22.8866C6.2208 23.5277 6.80523 24 7.5 24C8.15311 24 8.70873 23.5826 8.91465 23H15.0854C15.2913 23.5826 15.8469 24 16.5 24C17.1948 24 17.7792 23.5277 17.9497 22.8866C19.7004 22.4603 21 20.8819 21 19V8V7H20H17V2C17 0.895431 16.1046 0 15 0H9ZM17 21C18.1046 21 19 20.1046 19 19V9H17H16H8H7H5V19C5 20.1046 5.89543 21 7 21H9H15H17ZM15 7V2L9 2V7H15ZM17 14H7V12H17V14ZM7 18H17V16H7V18Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
              {
                _key: "381f7b96912b",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "3a4115508c0b",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "3d317164b630",
                        link: {
                          to: "/product/bill-pay",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Bill pay",
                        subtitle: "Automated AP workflows and invoices",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C4.34315 0 3 1.34314 3 3V21C3 22.6569 4.34315 24 6 24H18C19.6569 24 21 22.6569 21 21H19C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44771 2 6 2H14V7H19V11H21V5.58579L15.4142 0H6ZM8 11H16V13H8V11ZM12 15H8V17H12V15ZM23.6715 16L20.6914 12.4238L19.3086 13.5762L20.5785 15.1H16V16.9H20.5785L19.3086 18.4238L20.6914 19.5762L23.6715 16Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "281139e29ac8126e3af310b3c7bb3be5",
                        link: {
                          to: "/product/business-account",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Business account",
                        subtitle: "ACH, wires, same-day liquidity & yield",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 0.922852L21.1142 4.56852C22.2531 5.02411 23 6.12724 23 7.35395V9.99988H20V15.9999H23V18.9999C23 20.6567 21.6569 21.9999 20 21.9999H4C2.34315 21.9999 1 20.6567 1 18.9999V15.9999H4V9.99988H1V7.35395C1 6.12724 1.74685 5.02411 2.88583 4.56852L12 0.922852ZM6 15.9999H11V9.99988H6V15.9999ZM13 15.9999H18V9.99988H13V15.9999ZM12 3.07692L3.62861 6.42547C3.24895 6.57734 3 6.94505 3 7.35395V7.99988H15V4.27692L12 3.07692ZM3 18.9999V17.9999H15V19.9999H4C3.44772 19.9999 3 19.5522 3 18.9999Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "b4bd1183c3f0",
                        link: {
                          to: null,
                          toExternal:
                            "https://www.brex.com/product/financial-modeling",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Financial modeling",
                        subtitle: "Runway forecasting & scenario planning",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M5.33335 23.2189V26.6666H29.3334V29.3333H2.66669V2.66663H5.33335V19.4477L13.3334 11.4477L17.3334 15.4477L27.0572 5.72382L28.9428 7.60944L17.3334 19.2189L13.3334 15.2189L5.33335 23.2189Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "af0469f4ab57062d2d3adc5443bdfee5",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "Platform",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: null,
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "7e342c9182fa",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8b14c557e5f9",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "055b248ba3d7",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/platform/brex-ai",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Brex AI",
                        subtitle: "AI-powered automations and assistants",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill=currentColor xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_6620_871)">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.97183 10.4917C5 10.8023 5.21127 11 5.50704 11C5.78873 11 6 10.8023 6.02817 10.5199C6.52016 6.78525 6.63336 6.76387 10.4983 6.03383L10.5211 6.02952C10.8028 5.98716 11 5.78947 11 5.50706C11 5.21053 10.7887 4.99872 10.5211 4.97047C6.64789 4.43389 6.52113 4.3068 6.02817 0.494223C6 0.197689 5.78873 0 5.50704 0C5.21127 0 5 0.197689 4.97183 0.508344C4.51102 4.21832 4.34094 4.25005 0.577071 4.95215L0.478873 4.97047C0.197183 5.01284 0 5.21053 0 5.50706C0 5.80359 0.197183 5.98716 0.535211 6.02952C4.35211 6.63671 4.50704 6.74968 4.97183 10.4917ZM14.5 24C14.1424 24 13.8563 23.7376 13.7967 23.3559C12.8789 16.8914 12.0088 16.0565 5.6675 15.2097C5.27415 15.162 5 14.8638 5 14.494C5 14.1243 5.27415 13.838 5.67942 13.7903C12.0326 13.0866 12.9385 12.1086 13.7967 5.64407C13.8563 5.2624 14.1305 5 14.5 5C14.8695 5 15.1437 5.2624 15.2033 5.64407C16.0972 12.1086 16.9793 13.0508 23.3325 13.7903C23.7258 13.838 24 14.1243 24 14.494C24 14.8757 23.7258 15.162 23.3325 15.2097C16.9674 15.9134 16.0615 16.8914 15.2033 23.3559C15.1437 23.7376 14.8695 24 14.5 24Z" fill=currentColor/>\n</g>\n<defs>\n<clipPath id="clip0_6620_871">\n<rect width="24" height="24" fill="white"/>\n</clipPath>\n</defs>\n</svg>',
                        },
                      },
                      {
                        _key: "0d30fe481533",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/product/global",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Global ready",
                        subtitle: "Multi-currency & multi-entity operations",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12 22C12.7474 22 13.7509 21.2878 14.6252 19.3644C14.9377 18.6767 15.2093 17.8808 15.4265 17H8.57345C8.79074 17.8808 9.06226 18.6767 9.37483 19.3644C10.2491 21.2878 11.2526 22 12 22ZM8.19682 15H15.8032C15.9306 14.0553 16 13.0485 16 12C16 10.9515 15.9306 9.94466 15.8032 9H8.19682C8.06943 9.94466 8 10.9515 8 12C8 13.0485 8.06943 14.0553 8.19682 15ZM8.57345 7C8.79074 6.11921 9.06226 5.32328 9.37483 4.63563C10.2491 2.71217 11.2526 2 12 2C12.7474 2 13.7509 2.71217 14.6252 4.63563C14.9377 5.32328 15.2093 6.11921 15.4265 7H8.57345ZM17.8196 9C17.9378 9.96135 18 10.9672 18 12C18 13.0328 17.9378 14.0387 17.8196 15H21.5422C21.8396 14.053 22 13.0452 22 12C22 10.9548 21.8396 9.94704 21.5422 9H17.8196ZM20.6622 7H17.48C17.2208 5.8214 16.8712 4.74364 16.4459 3.80802C16.2881 3.4608 16.1143 3.12233 15.9247 2.79955C17.9212 3.65232 19.5839 5.13598 20.6622 7ZM6.51996 7H3.33782C4.4161 5.13598 6.07877 3.65232 8.07531 2.79955C7.88574 3.12233 7.71193 3.4608 7.5541 3.80802C7.12882 4.74364 6.77917 5.8214 6.51996 7ZM2.4578 9H6.18036C6.06223 9.96135 6 10.9672 6 12C6 13.0328 6.06223 14.0387 6.18036 15H2.4578C2.16035 14.053 2 13.0452 2 12C2 10.9548 2.16035 9.94704 2.4578 9ZM16.4459 20.192C16.8712 19.2564 17.2208 18.1786 17.48 17H20.6622C19.5839 18.864 17.9212 20.3477 15.9247 21.2005C16.1143 20.8777 16.2881 20.5392 16.4459 20.192ZM8.07532 21.2005C6.07877 20.3477 4.4161 18.864 3.33782 17H6.51996C6.77917 18.1786 7.12882 19.2564 7.5541 20.192C7.71193 20.5392 7.88574 20.8777 8.07532 21.2005Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                      {
                        _key: "23bc46b3797f",
                        link: {
                          to: "/budgets",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Live Budgets",
                        subtitle: "Spend limits with real-time tracking",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M16.5922 0.913451C14.3995 0.00519943 11.9867 -0.232441 9.65892 0.230582C7.33115 0.693605 5.19295 1.83649 3.51472 3.51472C1.83649 5.19295 0.693605 7.33115 0.230582 9.65892C-0.232441 11.9867 0.00519943 14.3995 0.913451 16.5922C1.8217 18.7849 3.35977 20.6591 5.33316 21.9776C7.30655 23.2962 9.62663 24 12 24C13.5759 24 15.1363 23.6896 16.5922 23.0866C18.0481 22.4835 19.371 21.5996 20.4853 20.4853C21.5996 19.371 22.4835 18.0481 23.0866 16.5922C23.6896 15.1363 24 13.5759 24 12C24 9.62663 23.2962 7.30655 21.9776 5.33316C20.6591 3.35977 18.7849 1.8217 16.5922 0.913451ZM10.0491 2.19215C11.9889 1.8063 13.9996 2.00433 15.8268 2.76121C17.6541 3.51809 19.2159 4.79981 20.3147 6.4443C21.2274 7.81025 21.7866 9.37552 21.9499 11H12C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12V21.9499C9.37552 21.7866 7.81025 21.2274 6.4443 20.3147C4.79981 19.2159 3.51809 17.6541 2.76121 15.8268C2.00433 13.9996 1.8063 11.9889 2.19215 10.0491C2.578 8.10929 3.53041 6.32746 4.92894 4.92894C6.32746 3.53041 8.10929 2.57801 10.0491 2.19215Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "5c9a8a4197a57f715fe90402fab034ea",
                        link: {
                          to: "/product/integrations",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Native integrations",
                        subtitle: "ERP, HRIS, productivity, security",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12.168 5.33337C12.7601 3.03307 14.8482 1.33337 17.3333 1.33337C19.8185 1.33337 21.9066 3.03307 22.4986 5.33337H29.3333V14.6667H28C26.5272 14.6667 25.3333 15.8606 25.3333 17.3334C25.3333 18.8061 26.5272 20 28 20H29.3333V29.3334H5.33333V22.4987C3.03303 21.9066 1.33333 19.8185 1.33333 17.3334C1.33333 14.8483 3.03303 12.7601 5.33333 12.1681V5.33337H12.168ZM17.3333 4.00004C15.8606 4.00004 14.6667 5.19395 14.6667 6.66671V8.00004H8V14.6667H6.66667C5.19391 14.6667 4 15.8606 4 17.3334C4 18.8061 5.19391 20 6.66667 20H8V26.6667H26.6667V22.4987C24.3664 21.9066 22.6667 19.8185 22.6667 17.3334C22.6667 14.8483 24.3664 12.7601 26.6667 12.1681V8.00004H20V6.66671C20 5.19395 18.8061 4.00004 17.3333 4.00004Z" fill="#currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "25420cfd0b03a9254f9b94701064cdb7",
                        link: {
                          to: "/product/mobile",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Mobile",
                        subtitle: "Available on iOS and Android",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M7 0C5.34315 0 4 1.34314 4 3V21C4 22.6569 5.34315 24 7 24H17C18.6569 24 20 22.6569 20 21V3C20 1.34315 18.6569 0 17 0H7ZM6 3C6 2.44772 6.44771 2 7 2H17C17.5523 2 18 2.44772 18 3V21C18 21.5523 17.5523 22 17 22H7C6.44772 22 6 21.5523 6 21V3ZM12 20C13.1046 20 14 19.1046 14 18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18C10 19.1046 10.8954 20 12 20Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "1e2b0492bcc1",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryGray",
            title: {
              text: "Announcements",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: "",
                  toExternal: "https://www.brex.com/product-announcements",
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "5860dde6ed0e",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "b3536b8af5b0",
                    _type: "linkHeroNavModule",
                    title: "Meet Brex AI",
                    subtitle:
                      "AI embedded in every product for unrivaled efficiency and compliance.",
                    subtitleV2Raw: null,
                    link: {
                      to: "",
                      toExternal: "https://www.brex.com/platform/brex-ai",
                      noFollow: null,
                      hash: null,
                    },
                    icon: null,
                    media: {
                      media: {
                        type: "IMAGE",
                        datUrl:
                          "https://brand.brex.com/transform/1b1ca225-4a18-458d-b889-d95e4a499007/AI-page-preview-image",
                        description: null,
                        aspectRatio: 0.5625,
                        videoUrl: null,
                      },
                      mediaStyle: {
                        borderRadius: "6px",
                        customBorderRadius: null,
                      },
                      disableVideoLoop: false,
                    },
                    modifier: null,
                    mediaPosition: "top",
                    showMediaOnMobile: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _key: "852f2e01f2ec39bc74c89ce6050293fc",
        _type: "navLink",
        text: "Startups",
        link: {
          to: "",
          toExternal: "https://www.brex.com/solutions/startups",
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "3adc58d91a4b",
        _type: "navMenu",
        text: "Resources",
        description: null,
        submenu: [
          {
            _key: "79d0fdf35784",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "Customer Hub",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: "/customer-hub",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "86ec301ad222",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "/support",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Help Center",
                        subtitle:
                          "Find answers to common questions with step-by-step instructions.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M10.5 17.5C10.5 16.6716 11.1716 16 12 16C12.8284 16 13.5 16.6716 13.5 17.5C13.5 18.3284 12.8284 19 12 19C11.1716 19 10.5 18.3284 10.5 17.5Z" fill="currentColor"/>\n<path d="M12 5C9.79086 5 8 6.79086 8 9H10C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9V9.39445C14 10.0632 13.6658 10.6876 13.1094 11.0585L12.7812 11.2774C11.6684 12.0192 11 13.2681 11 14.6056V15H13V14.6056C13 13.9368 13.3342 13.3124 13.8906 12.9415L14.2188 12.7226C15.3316 11.9808 16 10.7319 16 9.39445V9C16 6.79086 14.2091 5 12 5Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/implementation",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Implementation guides",
                        subtitle:
                          "Access technical guides, tutorials, and webinars to set up key features. ",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_5399_39609)">\n<path d="M9 12V10H13V16H15V18H9V16H11V12H9Z" fill="currentColor"/>\n<path d="M12 9C12.8284 9 13.5 8.32843 13.5 7.5C13.5 6.67157 12.8284 6 12 6C11.1716 6 10.5 6.67157 10.5 7.5C10.5 8.32843 11.1716 9 12 9Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor"/>\n</g>\n<defs>\n<clipPath id="clip0_5399_39609">\n<rect width="24" height="24" fill="currentColor"/>\n</clipPath>\n</defs>\n</svg>\n',
                        },
                      },
                      {
                        _key: "78c4db945bb1",
                        link: {
                          to: "/product-announcements",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Product announcements",
                        subtitle:
                          "Learn about the latest innovations and new releases from Brex. ",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m26.6667 2.66675v4 3.99995c1.4145 0 2.771.562 3.7712 1.5621 1.0002 1.0002 1.5621 2.3568 1.5621 3.7713s-.5619 2.771-1.5621 3.7712-2.3567 1.5621-3.7712 1.5621v4 4h-2.6667v-2.8705l-9.4081-1.568c-.4256 2.5195-2.618 4.4386-5.25857 4.4386-2.94551 0-5.33333-2.3879-5.33333-5.3334 0-.292.02359-.579.06902-.859l-.72662-.1211c-1.92875-.3215-3.3424-1.9902-3.3424-3.9456v-6.1486c0-1.9554 1.41365-3.62416 3.3424-3.94562l20.6576-3.44293v-2.8705zm-19.96724 20.91275 5.26164.8769c-.2165 1.2554-1.3106 2.2104-2.62777 2.2104-1.47276 0-2.66666-1.1939-2.66666-2.6667 0-.1435.01122-.2839.03279-.4206zm17.30054-15.3388-20.2192 3.3699c-.64292.1071-1.11413.6634-1.11413 1.3152v6.1486c0 .6518.47121 1.208 1.11413 1.3152l20.2192 3.3699z" fill="currentColor" fill-rule="evenodd"/></svg>',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "4ce7782d1713ef14f57e6d62fb24e62e",
            _type: "navGroup",
            span: 2,
            theme: "PrimaryWhite",
            title: {
              text: "Resource Center",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: "/resources",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "86ec301ad222",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/resources/ebooks",
                          noFollow: null,
                          hash: null,
                        },
                        text: "White papers and e-books",
                        subtitle:
                          "Get ahead with research, reports, and guides for finance leaders.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="33" height="32" viewBox="0 0 33 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M21.8333 18.6667V16H11.1667V18.6667H21.8333Z" fill="currentColor"/>\n<path d="M11.1667 24V21.3333H21.8333V24H11.1667Z" fill="currentColor"/>\n<path d="M16.5 6.66667H11.1667V9.33333H16.5V6.66667Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 4C4.5 1.79086 6.29086 0 8.5 0H21.0523L28.5 7.44772V28C28.5 30.2091 26.7091 32 24.5 32H8.5C6.29086 32 4.5 30.2091 4.5 28V4ZM8.5 2.66667C7.76362 2.66667 7.16667 3.26362 7.16667 4V28C7.16667 28.7364 7.76362 29.3333 8.5 29.3333H24.5C25.2364 29.3333 25.8333 28.7364 25.8333 28V9.33333H19.1667V2.66667H8.5Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: null,
                          toExternal: "https://www.brex.com/resources/webinars",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Webinars",
                        subtitle:
                          "Tune in for actionable insights from Brex and industry experts. ",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="21" viewBox="0 0 24 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M2.47117 16.9754C1.70016 16.9754 1.0939 16.758 0.652389 16.3231C0.217463 15.8815 0 15.272 0 14.4944V2.59324C0 1.81565 0.217463 1.20938 0.652389 0.774459C1.0939 0.339533 1.70016 0.12207 2.47117 0.12207H21.5288C22.2998 0.12207 22.9028 0.339533 23.3377 0.774459C23.7792 1.20938 24 1.81565 24 2.59324V14.4944C24 15.272 23.7792 15.8815 23.3377 16.3231C22.9028 16.758 22.2998 16.9754 21.5288 16.9754H2.47117ZM2.31301 12.3988H21.6771C21.9605 12.3988 22.1021 12.2605 22.1021 11.9837V2.71186C22.1021 2.49439 22.0395 2.32635 21.9143 2.20774C21.7891 2.08253 21.6244 2.01993 21.4201 2.01993H2.5799C2.37562 2.01993 2.21087 2.08253 2.08567 2.20774C1.96046 2.32635 1.89786 2.49439 1.89786 2.71186V11.9837C1.89786 12.2605 2.03624 12.3988 2.31301 12.3988ZM9 19V15.8792H15V19.0117L9 19ZM8.72817 20.5537C8.47776 20.5537 8.26359 20.4647 8.08567 20.2868C7.91433 20.1089 7.82867 19.898 7.82867 19.6542C7.82867 19.4038 7.91433 19.1896 8.08567 19.0117C8.26359 18.8404 8.47776 18.7547 8.72817 18.7547H15.2718C15.5222 18.7547 15.7331 18.8404 15.9044 19.0117C16.0758 19.1896 16.1614 19.4038 16.1614 19.6542C16.1614 19.898 16.0758 20.1089 15.9044 20.2868C15.7331 20.4647 15.5222 20.5537 15.2718 20.5537H8.72817Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "78c4db945bb1",
                        link: {
                          to: "",
                          toExternal:
                            "https://www.brex.com/resources/case-studies",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Customer stories",
                        subtitle:
                          "Dive into real-world examples of how top companies are using Brex.",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M16.0002 2.66663C12.3551 2.66663 9.40016 5.65139 9.40016 9.33329C9.40016 13.0152 12.3551 16 16.0002 16C19.6452 16 22.6002 13.0152 22.6002 9.33329C22.6002 5.65139 19.6452 2.66663 16.0002 2.66663ZM12.3335 9.33329C12.3335 7.28779 13.9751 5.62959 16.0002 5.62959C18.0252 5.62959 19.6668 7.28779 19.6668 9.33329C19.6668 11.3788 18.0252 13.037 16.0002 13.037C13.9751 13.037 12.3335 11.3788 12.3335 9.33329Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M29.9331 21.3834L29.9296 21.3814L29.9238 21.378L29.9052 21.3673L29.8407 21.3307C29.7858 21.2998 29.7072 21.2562 29.6063 21.2016C29.4046 21.0924 29.1135 20.9394 28.7446 20.7571C28.0076 20.393 26.9557 19.9101 25.6818 19.4276C23.1502 18.4687 19.6654 17.4814 16.0002 17.4814C12.3836 17.4814 8.93303 18.2615 6.41205 19.0254C5.14551 19.4092 4.09913 19.7934 3.36571 20.0833C2.99871 20.2284 2.70925 20.3501 2.50888 20.4369C2.40867 20.4803 2.33066 20.5149 2.27631 20.5394L2.21268 20.5682L2.19448 20.5766L2.18885 20.5792L2.18691 20.5801C2.17992 20.5834 2.18555 20.5808 2.18555 20.5808L1.3335 20.978V23.1682C1.33347 23.9491 1.33345 24.6229 1.37834 25.1778C1.42571 25.7635 1.53031 26.346 1.81307 26.9066C2.23491 27.7429 2.90803 28.4228 3.73594 28.8489C4.2909 29.1345 4.86762 29.2402 5.44746 29.288C5.99683 29.3333 6.66382 29.3333 7.43697 29.3333H24.5634C25.3365 29.3333 26.0035 29.3333 26.5529 29.288C27.1327 29.2402 27.7094 29.1345 28.2644 28.8489C29.0923 28.4228 29.7654 27.7429 30.1873 26.9066C30.47 26.346 30.5746 25.7635 30.622 25.1778C30.6669 24.6229 30.6669 23.9492 30.6668 23.1682V21.811C30.6668 21.811 30.2196 21.5504 29.9331 21.3834ZM4.26683 23.1111V22.9094C4.32046 22.8879 4.37641 22.8655 4.43462 22.8425C5.10676 22.5769 6.07704 22.2203 7.25494 21.8634C9.62285 21.1459 12.7722 20.4444 16.0002 20.4444C19.1794 20.4444 22.2946 21.309 24.6518 22.2019C25.8224 22.6453 26.7872 23.0884 27.4557 23.4187C27.5549 23.4677 27.6475 23.5142 27.7332 23.5578C27.7319 24.166 27.726 24.5949 27.6984 24.9365C27.6658 25.339 27.6106 25.4882 27.5736 25.5614C27.433 25.8402 27.2087 26.0668 26.9327 26.2089C26.8602 26.2462 26.7124 26.302 26.314 26.3349C25.8984 26.3692 25.3524 26.3703 24.5068 26.3703H7.4935C6.64789 26.3703 6.10189 26.3692 5.68632 26.3349C5.28789 26.302 5.14016 26.2462 5.06765 26.2089C4.79168 26.0668 4.5673 25.8402 4.42669 25.5614C4.38974 25.4882 4.33448 25.339 4.30193 24.9365C4.26797 24.5167 4.26683 23.9652 4.26683 23.1111Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
              {
                _key: "0b003d0fba89c554ca29eddff812e579",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "/journal",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Blog",
                        subtitle:
                          "Read best practices and expert perspectives to make your work easier. ",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M18 0.585815L2 16.5858V22H7.41421L23.4142 6.00003L18 0.585815ZM4 20V17.4142L14.7071 6.70714L17.2929 9.29292L6.58579 20H4Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: null,
                          toExternal: "https://www.brex.com/resources/events",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Events",
                        subtitle:
                          "Join Brex at popular events and conferences near you. ",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M3 4C1.34315 4 0 5.34315 0 7V9V10H1C2.10457 10 3 10.8954 3 12C3 13.1046 2.10457 14 1 14H0V15V17C0 18.6569 1.34314 20 3 20H21C22.6569 20 24 18.6569 24 17V15V14H23C21.8954 14 21 13.1046 21 12C21 10.8954 21.8954 10 23 10H24V9V7C24 5.34315 22.6569 4 21 4H3ZM2 7C2 6.44772 2.44772 6 3 6H21C21.5523 6 22 6.44772 22 7V8.12602C20.2748 8.57006 19 10.1362 19 12C19 13.8638 20.2748 15.4299 22 15.874V17C22 17.5523 21.5523 18 21 18H3C2.44772 18 2 17.5523 2 17V15.874C3.72523 15.4299 5 13.8638 5 12C5 10.1362 3.72523 8.57006 2 8.12602V7ZM13.1226 10.4549L12 7L10.8774 10.4549H7.24472L10.1836 12.5902L9.06107 16.0451L12 13.9098L14.9389 16.0451L13.8164 12.5902L16.7553 10.4549H13.1226Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "41c298baca51",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryGray",
            title: {
              text: "The latest",
              linkOnlyOnMobile: true,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: null,
                  toExternal: "https://www.brex.com/resources",
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "b77a81746138",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "4ef1a870102e",
                    _type: "articleListNavModule",
                    articles: [
                      {
                        _type: "articleListNavModuleArticle",
                        _key: "ee9cbace042f",
                        page: {
                          _id: "ed725429-1def-4242-b82a-b55800c0c8ac",
                          _type: "contentHubArticle",
                          contentHubArticleContent: {
                            articleGroup: { parent: "resources" },
                            articleImage: {
                              image: {
                                datUrl:
                                  "https://brand.brex.com/transform/55e33568-855f-4ea5-a686-33ed8cee843f/AI-x-Finance-preivew",
                                description: null,
                              },
                            },
                          },
                          meta: {
                            title: "Brex AI x Finance",
                            slug: { current: "brex-ai-x-finance-register" },
                          },
                        },
                        titleOverride:
                          "Watch our AI x Finance event on demand for exclusive insights.",
                        imageOverride: {
                          datUrl:
                            "https://brand.brex.com/transform/fd6b091c-828f-409b-8fb5-b03ddfd855d1/aixfinance-nav",
                          description: null,
                        },
                      },
                      {
                        _type: "articleListNavModuleArticle",
                        _key: "1e1c801e098c",
                        page: {
                          _id: "97c23022-b6df-4b36-9d16-694c7fc7e011",
                          _type: "contentHubArticle",
                          contentHubArticleContent: {
                            articleGroup: { parent: "resources" },
                            articleImage: {
                              image: {
                                datUrl:
                                  "https://brand.brex.com/transform/5f155ef4-b8de-4bc9-b26b-9b4e0aff6caf/AI-in-finance_ebook_preview",
                                description: null,
                              },
                            },
                          },
                          meta: {
                            title:
                              "AI in finance: The human role in AI-powered spend management",
                            slug: {
                              current:
                                "ai-in-finance-the-human-role-in-ai-powered-spend-management-register",
                            },
                          },
                        },
                        titleOverride: null,
                        imageOverride: null,
                      },
                      {
                        _type: "articleListNavModuleArticle",
                        _key: "d7be033d82ed",
                        page: {
                          _id: "c114a44b-543c-42ad-9fad-04781dc000a4",
                          _type: "contentHubArticle",
                          contentHubArticleContent: {
                            articleGroup: { parent: "journal" },
                            articleImage: {
                              image: {
                                datUrl:
                                  "https://brand.brex.com/transform/39ee8971-3d98-449c-99df-0c67ebcf1b24/MT-Metadata",
                                description: null,
                              },
                            },
                          },
                          meta: {
                            title: "CFOs need an AI strategy",
                            slug: { current: "cfos-need-an-ai-strategy" },
                          },
                        },
                        titleOverride:
                          "Practical advice for CFOs on how to develop an AI strategy.",
                        imageOverride: null,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    right: [
      {
        _key: "ada5a78d6df9",
        _type: "navLink",
        text: "Open an account",
        link: {
          to: null,
          toExternal: "https://www.brex.com/signup",
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "7140f7b3727f",
        _type: "navLink",
        text: "Sign in",
        link: {
          to: null,
          toExternal: "https://dashboard.brex.com/",
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "55593003b8b9",
        _type: "navLink",
        text: "Contact sales",
        link: { to: "/sales", toExternal: null, noFollow: null, hash: null },
      },
    ],
    cta: {
      text: "Control all your spend before it happens, all in one place.",
      link: {
        _key: null,
        _type: "navLink",
        text: "Get started",
        link: { to: "/sales", toExternal: null, noFollow: null, hash: null },
      },
    },
  },
  "e785eb0c-1255-454e-9a47-4399c2f3aa40": {
    _type: "navigation",
    _id: "e785eb0c-1255-454e-9a47-4399c2f3aa40",
    _updatedAt: "2025-09-18T17:51:26Z",
    title: "9/16/25 Navigation - Industry",
    mobileBreakpoint: null,
    left: [
      {
        _key: "4c3ddc93ebdc",
        _type: "navMenu",
        text: "Products",
        description: null,
        submenu: [
          {
            _key: "79e9582c4b49",
            _type: "navGroup",
            span: 2,
            theme: "PrimaryWhite",
            title: {
              text: "Products",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: null,
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "7e342c9182fa",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8b14c557e5f9",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "055b248ba3d7",
                        link: {
                          to: "/product/credit-card",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Corporate card",
                        subtitle: "Get up to 10-20x higher limits",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M0 6C0 4.34315 1.34315 3 3 3H21C22.6569 3 24 4.34315 24 6V18C24 19.6569 22.6569 21 21 21H3C1.34314 21 0 19.6569 0 18V6ZM3 5C2.44772 5 2 5.44772 2 6V16H11.1415C11.8311 16 12.472 15.6448 12.8375 15.06L14.1625 12.94C14.528 12.3552 15.1689 12 15.8585 12H22V6C22 5.44771 21.5523 5 21 5H3Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "ed0c78f23112",
                        link: {
                          to: "/product/business-account",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Business banking",
                        subtitle: null,
                        subtitleV2Raw: [
                          {
                            _type: "block",
                            style: "normal",
                            _key: "b81354501156",
                            markDefs: [],
                            children: [
                              {
                                marks: [],
                                text: "Bank smarter with up to ",
                                _key: "d284664147150",
                                _type: "span",
                              },
                              {
                                _type: "copyLibraryReference",
                                _key: "d0b2c9d01257",
                                copyLibraryItem: {
                                  _ref: "yieldRateTier5",
                                  _type: "reference",
                                  _id: "yieldRateTier5",
                                  text: "4.36%",
                                  type: "number",
                                  date: null,
                                  number: {
                                    value: 4.2,
                                    prefix: null,
                                    suffix: "%†",
                                  },
                                },
                              },
                              {
                                text: "",
                                _key: "ef01d103eea6",
                                _type: "span",
                                marks: [],
                              },
                            ],
                          },
                        ],
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 0.922852L21.1142 4.56852C22.2531 5.02411 23 6.12724 23 7.35395V9.99988H20V15.9999H23V18.9999C23 20.6567 21.6569 21.9999 20 21.9999H4C2.34315 21.9999 1 20.6567 1 18.9999V15.9999H4V9.99988H1V7.35395C1 6.12724 1.74685 5.02411 2.88583 4.56852L12 0.922852ZM6 15.9999H11V9.99988H6V15.9999ZM13 15.9999H18V9.99988H13V15.9999ZM12 3.07692L3.62861 6.42547C3.24895 6.57734 3 6.94505 3 7.35395V7.99988H15V4.27692L12 3.07692ZM3 18.9999V17.9999H15V19.9999H4C3.44772 19.9999 3 19.5522 3 18.9999Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "0d30fe481533",
                        link: {
                          to: "/product/spend-management",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Spend management",
                        subtitle: "Eliminate manual expense work",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '    <svg\n      width="24"\n      height="24"\n      viewBox="0 0 24 24"\n      fill="none"\n      xmlns="http://www.w3.org/2000/svg"\n    >\n      <path\n        fill-rule="evenodd"\n        clip-rule="evenodd"\n        d="M23.8162 14.1036C23.937 13.4206 24 12.7177 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C12.7177 24 13.4206 23.937 14.1036 23.8162C13.3793 23.3301 12.7509 22.7122 12.2525 21.9969C12.1686 21.999 12.0844 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.0844 21.999 12.1686 21.9969 12.2525C22.7122 12.7509 23.3301 13.3793 23.8162 14.1036ZM18 24C21.3137 24 24 21.3137 24 18C24 14.6863 21.3137 12 18 12C14.6863 12 12 14.6863 12 18C12 21.3137 14.6863 24 18 24ZM19 14L15 19H17.5L17 22L21 17H18.5L19 14ZM14.9332 11.7058C14.4111 11.2654 13.7365 11 13 11H11C10.4477 11 10 10.5523 10 10C10 9.44771 10.4477 9 11 9H14V10H16V7H13V4H11V7C9.34315 7 8 8.34315 8 10C8 11.6569 9.34315 13 11 13H13C13.0325 13 13.0646 13.0016 13.0963 13.0046C13.6318 12.4789 14.2515 12.0386 14.9332 11.7058ZM11.4616 15.5338C11.5462 15.3303 11.6235 15.1443 11.6736 15H10V14H8V17H11C11 16.6443 11.253 16.0356 11.4616 15.5338L11.4616 15.5338Z"\n        fill="currentColor"\n      />\n    </svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
              {
                _key: "381f7b96912b",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "3a4115508c0b",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "b4bd1183c3f0",
                        link: {
                          to: "/product/bill-pay",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Bill pay",
                        subtitle: "Pay vendors faster and easier",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C4.34315 0 3 1.34314 3 3V21C3 22.6569 4.34315 24 6 24H18C19.6569 24 21 22.6569 21 21H19C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44771 2 6 2H14V7H19V11H21V5.58579L15.4142 0H6ZM8 11H16V13H8V11ZM12 15H8V17H12V15ZM23.6715 16L20.6914 12.4238L19.3086 13.5762L20.5785 15.1H16V16.9H20.5785L19.3086 18.4238L20.6914 19.5762L23.6715 16Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "f60fe03cd936",
                        link: {
                          to: "/product/travel-expense-management",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Travel",
                        subtitle: "Book and manage global travel",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M9 0C7.89543 0 7 0.89543 7 2V7H4H3V8V19C3 20.8819 4.2996 22.4603 6.05029 22.8866C6.2208 23.5277 6.80523 24 7.5 24C8.15311 24 8.70873 23.5826 8.91465 23H15.0854C15.2913 23.5826 15.8469 24 16.5 24C17.1948 24 17.7792 23.5277 17.9497 22.8866C19.7004 22.4603 21 20.8819 21 19V8V7H20H17V2C17 0.895431 16.1046 0 15 0H9ZM17 21C18.1046 21 19 20.1046 19 19V9H17H16H8H7H5V19C5 20.1046 5.89543 21 7 21H9H15H17ZM15 7V2L9 2V7H15ZM17 14H7V12H17V14ZM7 18H17V16H7V18Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "569a75fd4e4d",
                        link: {
                          to: "/platform/accounting-automation",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Accounting automation",
                        subtitle: "Close your books in minutes",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="fill=currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M3 2C1.89543 2 1 2.89543 1 4V17C1 18.1046 1.89543 19 3 19H9C9.53043 19 10.0391 19.2107 10.4142 19.5858C10.7893 19.9609 11 20.4696 11 21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21C13 20.4696 13.2107 19.9609 13.5858 19.5858C13.9609 19.2107 14.4696 19 15 19H21C22.1046 19 23 18.1046 23 17V4C23 2.89543 22.1046 2 21 2H16C14.6739 2 13.4021 2.52678 12.4645 3.46447C12.2962 3.63275 12.1411 3.81178 12 3.99997C11.8589 3.81178 11.7038 3.63275 11.5355 3.46447C10.5979 2.52678 9.32608 2 8 2H3ZM13 17.5359C13.6029 17.1878 14.2918 17 15 17H21V4H16C15.2044 4 14.4413 4.31607 13.8787 4.87868C13.3161 5.44129 13 6.20435 13 7V17.5359ZM11 17.5359V7C11 6.20435 10.6839 5.44129 10.1213 4.87868C9.55871 4.31607 8.79565 4 8 4H3V17H9C9.70823 17 10.3971 17.1878 11 17.5359Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "af0469f4ab57062d2d3adc5443bdfee5",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "Platform",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: null,
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "7e342c9182fa",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8b14c557e5f9",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "25420cfd0b03a9254f9b94701064cdb7",
                        link: {
                          to: "/product/embedded-finance",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Brex Embedded",
                        subtitle: "API-driven global payments",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.00004 5.3335C4.00004 3.12436 5.7909 1.3335 8.00004 1.3335H24C26.2092 1.3335 28 3.12436 28 5.3335V6.35202C28.8184 7.08445 29.3334 8.14883 29.3334 9.3335V10.352C30.1517 11.0844 30.6667 12.1488 30.6667 13.3335V26.6668C30.6667 28.876 28.8758 30.6668 26.6667 30.6668H5.33337C3.12424 30.6668 1.33337 28.876 1.33337 26.6668V13.3335C1.33337 12.1488 1.84837 11.0844 2.66671 10.352V9.3335C2.66671 8.14883 3.18171 7.08445 4.00004 6.35202V5.3335ZM24 4.00016C24.7364 4.00016 25.3334 4.59712 25.3334 5.3335H6.66671C6.66671 4.59712 7.26366 4.00016 8.00004 4.00016H24ZM25.3334 8.00016H6.66671C5.93033 8.00016 5.33337 8.59712 5.33337 9.3335H26.6667C26.6667 8.59712 26.0698 8.00016 25.3334 8.00016ZM5.33337 12.0002C4.59699 12.0002 4.00004 12.5971 4.00004 13.3335V24.0002H15.0844C15.8758 24.0002 16.6263 23.6486 17.133 23.0407L18.8671 20.9597C19.3738 20.3517 20.1243 20.0002 20.9157 20.0002H28V13.3335C28 12.5971 27.4031 12.0002 26.6667 12.0002H5.33337Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "5c9a8a4197a57f715fe90402fab034ea",
                        link: {
                          to: "/product/integrations",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Native integrations",
                        subtitle: "ERP, HRIS, productivity, security",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12.168 5.33337C12.7601 3.03307 14.8482 1.33337 17.3333 1.33337C19.8185 1.33337 21.9066 3.03307 22.4986 5.33337H29.3333V14.6667H28C26.5272 14.6667 25.3333 15.8606 25.3333 17.3334C25.3333 18.8061 26.5272 20 28 20H29.3333V29.3334H5.33333V22.4987C3.03303 21.9066 1.33333 19.8185 1.33333 17.3334C1.33333 14.8483 3.03303 12.7601 5.33333 12.1681V5.33337H12.168ZM17.3333 4.00004C15.8606 4.00004 14.6667 5.19395 14.6667 6.66671V8.00004H8V14.6667H6.66667C5.19391 14.6667 4 15.8606 4 17.3334C4 18.8061 5.19391 20 6.66667 20H8V26.6667H26.6667V22.4987C24.3664 21.9066 22.6667 19.8185 22.6667 17.3334C22.6667 14.8483 24.3664 12.7601 26.6667 12.1681V8.00004H20V6.66671C20 5.19395 18.8061 4.00004 17.3333 4.00004Z" fill="#currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "055b248ba3d7",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/platform/brex-ai",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Brex AI",
                        subtitle: "AI-powered assistant & analytics",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill=currentColor xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_6620_871)">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.97183 10.4917C5 10.8023 5.21127 11 5.50704 11C5.78873 11 6 10.8023 6.02817 10.5199C6.52016 6.78525 6.63336 6.76387 10.4983 6.03383L10.5211 6.02952C10.8028 5.98716 11 5.78947 11 5.50706C11 5.21053 10.7887 4.99872 10.5211 4.97047C6.64789 4.43389 6.52113 4.3068 6.02817 0.494223C6 0.197689 5.78873 0 5.50704 0C5.21127 0 5 0.197689 4.97183 0.508344C4.51102 4.21832 4.34094 4.25005 0.577071 4.95215L0.478873 4.97047C0.197183 5.01284 0 5.21053 0 5.50706C0 5.80359 0.197183 5.98716 0.535211 6.02952C4.35211 6.63671 4.50704 6.74968 4.97183 10.4917ZM14.5 24C14.1424 24 13.8563 23.7376 13.7967 23.3559C12.8789 16.8914 12.0088 16.0565 5.6675 15.2097C5.27415 15.162 5 14.8638 5 14.494C5 14.1243 5.27415 13.838 5.67942 13.7903C12.0326 13.0866 12.9385 12.1086 13.7967 5.64407C13.8563 5.2624 14.1305 5 14.5 5C14.8695 5 15.1437 5.2624 15.2033 5.64407C16.0972 12.1086 16.9793 13.0508 23.3325 13.7903C23.7258 13.838 24 14.1243 24 14.494C24 14.8757 23.7258 15.162 23.3325 15.2097C16.9674 15.9134 16.0615 16.8914 15.2033 23.3559C15.1437 23.7376 14.8695 24 14.5 24Z" fill=currentColor/>\n</g>\n<defs>\n<clipPath id="clip0_6620_871">\n<rect width="24" height="24" fill="white"/>\n</clipPath>\n</defs>\n</svg>',
                        },
                      },
                      {
                        _key: "0d30fe481533",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/product/global",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Global ready",
                        subtitle: "Multi-currency and multi-entity",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12 22C12.7474 22 13.7509 21.2878 14.6252 19.3644C14.9377 18.6767 15.2093 17.8808 15.4265 17H8.57345C8.79074 17.8808 9.06226 18.6767 9.37483 19.3644C10.2491 21.2878 11.2526 22 12 22ZM8.19682 15H15.8032C15.9306 14.0553 16 13.0485 16 12C16 10.9515 15.9306 9.94466 15.8032 9H8.19682C8.06943 9.94466 8 10.9515 8 12C8 13.0485 8.06943 14.0553 8.19682 15ZM8.57345 7C8.79074 6.11921 9.06226 5.32328 9.37483 4.63563C10.2491 2.71217 11.2526 2 12 2C12.7474 2 13.7509 2.71217 14.6252 4.63563C14.9377 5.32328 15.2093 6.11921 15.4265 7H8.57345ZM17.8196 9C17.9378 9.96135 18 10.9672 18 12C18 13.0328 17.9378 14.0387 17.8196 15H21.5422C21.8396 14.053 22 13.0452 22 12C22 10.9548 21.8396 9.94704 21.5422 9H17.8196ZM20.6622 7H17.48C17.2208 5.8214 16.8712 4.74364 16.4459 3.80802C16.2881 3.4608 16.1143 3.12233 15.9247 2.79955C17.9212 3.65232 19.5839 5.13598 20.6622 7ZM6.51996 7H3.33782C4.4161 5.13598 6.07877 3.65232 8.07531 2.79955C7.88574 3.12233 7.71193 3.4608 7.5541 3.80802C7.12882 4.74364 6.77917 5.8214 6.51996 7ZM2.4578 9H6.18036C6.06223 9.96135 6 10.9672 6 12C6 13.0328 6.06223 14.0387 6.18036 15H2.4578C2.16035 14.053 2 13.0452 2 12C2 10.9548 2.16035 9.94704 2.4578 9ZM16.4459 20.192C16.8712 19.2564 17.2208 18.1786 17.48 17H20.6622C19.5839 18.864 17.9212 20.3477 15.9247 21.2005C16.1143 20.8777 16.2881 20.5392 16.4459 20.192ZM8.07532 21.2005C6.07877 20.3477 4.4161 18.864 3.33782 17H6.51996C6.77917 18.1786 7.12882 19.2564 7.5541 20.192C7.71193 20.5392 7.88574 20.8777 8.07532 21.2005Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "1e2b0492bcc1",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryGray",
            title: {
              text: "New release",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: { to: "", toExternal: null, noFollow: null, hash: null },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "5860dde6ed0e",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "b3536b8af5b0",
                    _type: "linkHeroNavModule",
                    title: "Speed meets control ",
                    subtitle: null,
                    subtitleV2Raw: [
                      {
                        children: [
                          {
                            _type: "span",
                            marks: [],
                            text: "Gain speed and control with powerful upgrades to Brex AI, purchasing, policies, and roles.",
                            _key: "b146f23d6acd0",
                          },
                        ],
                        _type: "block",
                        style: "normal",
                        _key: "9f5bdc781614",
                        markDefs: [],
                      },
                    ],
                    link: {
                      to: "/summer-2025",
                      toExternal: null,
                      noFollow: null,
                      hash: null,
                    },
                    icon: null,
                    media: {
                      media: {
                        type: "IMAGE",
                        datUrl:
                          "https://brand.brex.com/transform/baba5930-18d8-4d6f-8eea-645bc054be75/summe-release-2025-nav",
                        description: null,
                        aspectRatio: 0.6325,
                        videoUrl: null,
                      },
                      mediaStyle: {
                        borderRadius: "6px",
                        customBorderRadius: null,
                      },
                      disableVideoLoop: false,
                    },
                    modifier: null,
                    mediaPosition: "top",
                    showMediaOnMobile: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _key: "53ce45644bd9",
        _type: "navMenu",
        text: "Solutions",
        description: null,
        submenu: [
          {
            _key: "7c4cb829ab72",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "By company size",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: { to: "", toExternal: null, noFollow: null, hash: null },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "aba2aba1f772",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "27f22e08ffc1",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "57d88210c49c",
                        link: {
                          to: "/solutions/startups",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Startups",
                        subtitle: "Get the #1 financial stack for startups",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M0 6C0 4.34315 1.34315 3 3 3H21C22.6569 3 24 4.34315 24 6V18C24 19.6569 22.6569 21 21 21H3C1.34314 21 0 19.6569 0 18V6ZM3 5C2.44772 5 2 5.44772 2 6V16H11.1415C11.8311 16 12.472 15.6448 12.8375 15.06L14.1625 12.94C14.528 12.3552 15.1689 12 15.8585 12H22V6C22 5.44771 21.5523 5 21 5H3Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "72d93b76bb04",
                        link: {
                          to: "/solutions/mid-size-companies",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Mid-sized companies",
                        subtitle: "Scale faster with smart cards & controls",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M13.5629 4.89329C11.6112 4.24273 9.46846 4.52968 7.75671 5.67085L5.92707 6.89061L4.26297 8.00001L5.92707 9.10941L10.263 12L8.51064 13.1682L5.82852 12.0954L5.37504 11.914L4.9117 12.0684L2.95837 12.7195C1.07774 13.3464 0.514287 15.7332 1.91602 17.135L4.64044 19.8594C7.27459 22.4935 11.3783 22.9609 14.5373 20.9865L29.8507 11.4157C31.3672 10.4678 31.5393 8.32517 30.1933 7.14748L29.5796 6.61049C27.1349 4.47137 23.6394 4.02293 20.7339 5.47569L18.5644 6.56045L13.5629 4.89329ZM9.23591 7.88965C10.263 7.20495 11.5486 7.03277 12.7196 7.42311L18.245 9.26492L18.769 9.43957L19.263 9.19258L21.9265 7.86083C23.8635 6.89232 26.1938 7.19128 27.8236 8.61736L28.4373 9.15435L13.124 18.7252C11.018 20.0415 8.28216 19.7299 6.52606 17.9738L3.80164 15.2494L5.29162 14.7527L8.17148 15.9046L8.82269 16.1651L9.40627 15.7761L13.4063 13.1094L15.0704 12L13.4063 10.8906L9.07037 8.00001L9.23591 7.88965ZM2.66667 28H21.3333V25.3333H2.66667V28Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                      {
                        _key: "751c09fb19d7",
                        link: {
                          to: "/solutions/enterprise",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Enterprise",
                        subtitle: "Spend smart across entities, currencies",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="33" height="32" viewBox="0 0 33 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 0C6.29086 0 4.5 1.79086 4.5 4V30V31.924L6.3015 31.2484L8.42376 30.4526L10.5704 31.5259L11.1667 31.824L11.763 31.5259L13.8333 30.4907L15.9037 31.5259L16.5 31.824L17.0963 31.5259L19.1667 30.4907L21.237 31.5259L21.8333 31.824L22.4296 31.5259L24.5762 30.4526L26.6985 31.2484L28.5 31.924V30V4C28.5 1.79086 26.7091 0 24.5 0H8.5ZM7.16667 4C7.16667 3.26362 7.76362 2.66667 8.5 2.66667H24.5C25.2364 2.66667 25.8333 3.26362 25.8333 4V28.076L24.9682 27.7516L24.4238 27.5474L23.9037 27.8074L21.8333 28.8426L19.763 27.8074L19.1667 27.5093L18.5704 27.8074L16.5 28.8426L14.4296 27.8074L13.8333 27.5093L13.237 27.8074L11.1667 28.8426L9.09628 27.8074L8.57624 27.5474L8.03184 27.7516L7.16667 28.076V4ZM19.1667 8H13.8333V5.33333H19.1667V8ZM21.8333 13.3333H11.1667V10.6667H21.8333V13.3333ZM11.1667 18.6667H21.8333V16H11.1667V18.6667ZM16.5 24V21.3333H21.8333V24H16.5Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "9618ae8f4f109273c119591ef0641378",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "By industry",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: { to: "", toExternal: null, noFollow: null, hash: null },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "aba2aba1f772",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "27f22e08ffc1",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "e013e38a84e6",
                        link: {
                          to: "/industry/marketing-advertising",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Advertising and marketing",
                        subtitle: null,
                        subtitleV2Raw: [
                          {
                            _type: "block",
                            style: "normal",
                            _key: "a3cfc3a516d1",
                            markDefs: [],
                            children: [
                              {
                                marks: [],
                                text: "Keep campaigns funded and clients happy",
                                _key: "58b87b8bf9a9",
                                _type: "span",
                              },
                            ],
                          },
                        ],
                        icon: {
                          mono: '<svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m26.6667 2.66675v4 3.99995c1.4145 0 2.771.562 3.7712 1.5621 1.0002 1.0002 1.5621 2.3568 1.5621 3.7713s-.5619 2.771-1.5621 3.7712-2.3567 1.5621-3.7712 1.5621v4 4h-2.6667v-2.8705l-9.4081-1.568c-.4256 2.5195-2.618 4.4386-5.25857 4.4386-2.94551 0-5.33333-2.3879-5.33333-5.3334 0-.292.02359-.579.06902-.859l-.72662-.1211c-1.92875-.3215-3.3424-1.9902-3.3424-3.9456v-6.1486c0-1.9554 1.41365-3.62416 3.3424-3.94562l20.6576-3.44293v-2.8705zm-19.96724 20.91275 5.26164.8769c-.2165 1.2554-1.3106 2.2104-2.62777 2.2104-1.47276 0-2.66666-1.1939-2.66666-2.6667 0-.1435.01122-.2839.03279-.4206zm17.30054-15.3388-20.2192 3.3699c-.64292.1071-1.11413.6634-1.11413 1.3152v6.1486c0 .6518.47121 1.208 1.11413 1.3152l20.2192 3.3699z" fill="currentColor" fill-rule="evenodd"/></svg>',
                        },
                      },
                      {
                        _key: "25b580f544c9",
                        link: {
                          to: "/industry/management-consulting",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Consulting",
                        subtitle: null,
                        subtitleV2Raw: [
                          {
                            _type: "block",
                            style: "normal",
                            _key: "f68b7776851e",
                            markDefs: [],
                            children: [
                              {
                                _key: "65d97d6fb1da",
                                _type: "span",
                                marks: [],
                                text: "Deliver more value with less overhead",
                              },
                            ],
                          },
                        ],
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M10.6667 4C7.35296 4 4.66667 6.68629 4.66667 10C4.66667 13.3137 7.35296 16 10.6667 16C13.9804 16 16.6667 13.3137 16.6667 10C16.6667 6.68629 13.9804 4 10.6667 4ZM7.33334 10C7.33334 8.15905 8.82572 6.66667 10.6667 6.66667C12.5076 6.66667 14 8.15905 14 10C14 11.8409 12.5076 13.3333 10.6667 13.3333C8.82572 13.3333 7.33334 11.8409 7.33334 10ZM18.3334 10C18.3334 11.6533 17.7863 13.1788 16.8632 14.4054C17.5554 15.1095 18.4417 15.6223 19.4353 15.8572C20.7849 15.099 22.3419 14.6667 24 14.6667C24.0642 14.6667 24.1283 14.6673 24.1922 14.6686C25.3007 13.6913 26 12.2606 26 10.6667C26 7.72115 23.6122 5.33333 20.6667 5.33333C19.4418 5.33333 18.3134 5.74623 17.4131 6.44042C17.9994 7.49451 18.3334 8.70825 18.3334 10ZM10.6667 17.3333C13.0344 17.3333 14.9991 17.7814 16.5559 18.3691C16.0143 19.0841 15.5733 19.8794 15.254 20.7342C14.0276 20.3135 12.4997 20 10.6667 20C7.75149 20 5.59621 20.6237 4.1919 21.2255C3.50822 21.5185 2.99979 21.8076 2.66667 22.0197V22.4C2.66667 23.1687 2.66771 23.6651 2.69857 24.0429C2.72817 24.4051 2.7784 24.5394 2.812 24.6053C2.93983 24.8562 3.1438 25.0602 3.39468 25.188C3.46061 25.2216 3.5949 25.2718 3.95712 25.3014C4.3349 25.3323 4.83127 25.3333 5.60001 25.3333H14.7612C14.8959 26.2749 15.1711 27.1711 15.5648 28H5.54861C4.84575 28 4.2394 28 3.73997 27.9592C3.21284 27.9162 2.68855 27.8211 2.18404 27.564C1.43139 27.1805 0.819471 26.5686 0.435979 25.816C0.17892 25.3115 0.0838312 24.7872 0.0407633 24.26C-3.97911e-05 23.7606 -2.08963e-05 23.1543 1.01014e-06 22.4515V22.4514V20.7201L0.443373 20.34L0.46663 20.3201L0.467717 20.3192C0.489716 20.3005 0.512082 20.2821 0.534608 20.264C0.570187 20.2355 0.618373 20.1977 0.679171 20.1521C0.800749 20.0609 0.972896 19.9383 1.19566 19.7951C1.64115 19.5087 2.28971 19.1395 3.14145 18.7745C4.84824 18.043 7.35963 17.3333 10.6667 17.3333ZM0.484935 20.3044C0.46141 20.3246 0.421423 20.3588 0.443373 20.34C0.514556 20.279 0.506961 20.2855 0.484935 20.3044ZM24 32C28.4183 32 32 28.4183 32 24C32 19.5817 28.4183 16 24 16C19.5817 16 16 19.5817 16 24C16 28.4183 19.5817 32 24 32ZM22.6667 20V22.6667H20V25.3333H22.6667V28H25.3333V25.3333H28V22.6667H25.3333V20H22.6667Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "157ec8385133",
                        link: {
                          to: "/industry/healthcare",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Healthcare",
                        subtitle: null,
                        subtitleV2Raw: [
                          {
                            markDefs: [],
                            children: [
                              {
                                text: "Elevate care by simplifying spend",
                                _key: "6b788c3749f9",
                                _type: "span",
                                marks: [],
                              },
                            ],
                            _type: "block",
                            style: "normal",
                            _key: "95559c722764",
                          },
                        ],
                        icon: {
                          mono: '<svg width="22" height="22" viewBox="0 0 22 22" fill=currentColor xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M6 6L0 6V16H6V22H16V16H22V6L16 6V0H6V6ZM8 2V8L2 8V14H8V20H14V14H20V8L14 8V2H8Z" fill=currentColor/>\n</svg>',
                        },
                      },
                      {
                        _key: "c01313cc7ff3",
                        link: {
                          to: "/industry/technology",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Technology",
                        subtitle: null,
                        subtitleV2Raw: [
                          {
                            _key: "4e3ae1a4e614",
                            markDefs: [],
                            children: [
                              {
                                _type: "span",
                                marks: [],
                                text: "Control spend and fuel innovation",
                                _key: "85e719657131",
                              },
                            ],
                            _type: "block",
                            style: "normal",
                          },
                        ],
                        icon: {
                          mono: '<svg width="24" height="21" viewBox="0 0 24 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M2.47117 16.9754C1.70016 16.9754 1.0939 16.758 0.652389 16.3231C0.217463 15.8815 0 15.272 0 14.4944V2.59324C0 1.81565 0.217463 1.20938 0.652389 0.774459C1.0939 0.339533 1.70016 0.12207 2.47117 0.12207H21.5288C22.2998 0.12207 22.9028 0.339533 23.3377 0.774459C23.7792 1.20938 24 1.81565 24 2.59324V14.4944C24 15.272 23.7792 15.8815 23.3377 16.3231C22.9028 16.758 22.2998 16.9754 21.5288 16.9754H2.47117ZM2.31301 12.3988H21.6771C21.9605 12.3988 22.1021 12.2605 22.1021 11.9837V2.71186C22.1021 2.49439 22.0395 2.32635 21.9143 2.20774C21.7891 2.08253 21.6244 2.01993 21.4201 2.01993H2.5799C2.37562 2.01993 2.21087 2.08253 2.08567 2.20774C1.96046 2.32635 1.89786 2.49439 1.89786 2.71186V11.9837C1.89786 12.2605 2.03624 12.3988 2.31301 12.3988ZM9 19V15.8792H15V19.0117L9 19ZM8.72817 20.5537C8.47776 20.5537 8.26359 20.4647 8.08567 20.2868C7.91433 20.1089 7.82867 19.898 7.82867 19.6542C7.82867 19.4038 7.91433 19.1896 8.08567 19.0117C8.26359 18.8404 8.47776 18.7547 8.72817 18.7547H15.2718C15.5222 18.7547 15.7331 18.8404 15.9044 19.0117C16.0758 19.1896 16.1614 19.4038 16.1614 19.6542C16.1614 19.898 16.0758 20.1089 15.9044 20.2868C15.7331 20.4647 15.5222 20.5537 15.2718 20.5537H8.72817Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "b6f631dcf896",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "For partners",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: {
                  to: null,
                  toExternal: null,
                  noFollow: false,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: false,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "32731f9ee7ac",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "3362e675a734",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "d5fde9919472",
                        link: {
                          to: "/partners/accounting",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Accounting firms",
                        subtitle: "Simplify close and earn rewards",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M10.6667 4C7.35296 4 4.66667 6.68629 4.66667 10C4.66667 13.3137 7.35296 16 10.6667 16C13.9804 16 16.6667 13.3137 16.6667 10C16.6667 6.68629 13.9804 4 10.6667 4ZM7.33334 10C7.33334 8.15905 8.82572 6.66667 10.6667 6.66667C12.5076 6.66667 14 8.15905 14 10C14 11.8409 12.5076 13.3333 10.6667 13.3333C8.82572 13.3333 7.33334 11.8409 7.33334 10Z" fill="currentColor"/>\n<path d="M18.3334 10C18.3334 11.6533 17.7863 13.1788 16.8632 14.4054C17.8308 15.3896 19.1774 16 20.6667 16C23.6122 16 26 13.6122 26 10.6667C26 7.72115 23.6122 5.33333 20.6667 5.33333C19.4418 5.33333 18.3134 5.74623 17.4131 6.44042C17.9994 7.49451 18.3334 8.70825 18.3334 10Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M21.3333 21.4744V28H5.54861C4.84575 28 4.23939 28 3.73997 27.9592C3.21284 27.9162 2.68855 27.8211 2.18404 27.564C1.43139 27.1805 0.81947 26.5686 0.435976 25.816C0.178918 25.3115 0.0838297 24.7872 0.0407617 24.26C-4.33574e-05 23.7606 -2.2695e-05 23.1543 1.14681e-06 22.4514V20.7201C0.865588 19.9782 0.310448 20.4539 0.466628 20.3201L0.467715 20.3192C0.489714 20.3005 0.51208 20.2821 0.534606 20.264C0.570185 20.2355 0.618371 20.1977 0.679169 20.1521C0.800747 20.0609 0.972894 19.9383 1.19566 19.7951C1.64114 19.5087 2.28971 19.1395 3.14144 18.7745C4.84824 18.043 7.35963 17.3333 10.6667 17.3333C14.0255 17.3333 16.5734 18.2351 18.2963 19.158C19.1553 19.6182 19.807 20.0823 20.2519 20.4398C20.4744 20.6187 20.6458 20.7713 20.7661 20.8841C20.8263 20.9405 20.8737 20.987 20.9084 21.0219C20.9258 21.0393 20.94 21.0539 20.9511 21.0653L20.9706 21.0858L20.9728 21.0882L20.9738 21.0893C21.1327 21.2595 20.6069 20.6962 21.3333 21.4744ZM2.66667 22.0197V22.4C2.66667 23.1687 2.66771 23.6651 2.69857 24.0429C2.72817 24.4051 2.7784 24.5394 2.81199 24.6053C2.93982 24.8562 3.1438 25.0602 3.39468 25.188C3.46061 25.2216 3.5949 25.2718 3.95712 25.3014C4.3349 25.3323 4.83126 25.3333 5.6 25.3333H18.6667V22.588C18.6398 22.5657 18.6114 22.5425 18.5815 22.5185C18.2486 22.251 17.7336 21.8818 17.037 21.5086C15.6488 20.7649 13.53 20 10.6667 20C7.75149 20 5.59621 20.6237 4.19189 21.2255C3.50822 21.5185 2.99978 21.8076 2.66667 22.0197Z" fill="currentColor"/>\n<path d="M22.6667 21.2174V28H27.7333C29.2268 28 29.9736 28 30.544 27.7094C31.0458 27.4537 31.4537 27.0457 31.7094 26.544C32 25.9735 32 25.2268 32 23.7333V20.6667C32 20.6667 27.5556 17.3333 21.3333 17.3333C20.0653 17.3333 18.9264 17.4441 17.9168 17.6205C21.0834 19.1522 22.6667 21.2174 22.6667 21.2174Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "102d59011244",
                        link: {
                          to: "/product/embedded-finance",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "B2B software",
                        subtitle: "Embed Brex cards in your products",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.00004 5.3335C4.00004 3.12436 5.7909 1.3335 8.00004 1.3335H24C26.2092 1.3335 28 3.12436 28 5.3335V6.35202C28.8184 7.08445 29.3334 8.14883 29.3334 9.3335V10.352C30.1517 11.0844 30.6667 12.1488 30.6667 13.3335V26.6668C30.6667 28.876 28.8758 30.6668 26.6667 30.6668H5.33337C3.12424 30.6668 1.33337 28.876 1.33337 26.6668V13.3335C1.33337 12.1488 1.84837 11.0844 2.66671 10.352V9.3335C2.66671 8.14883 3.18171 7.08445 4.00004 6.35202V5.3335ZM24 4.00016C24.7364 4.00016 25.3334 4.59712 25.3334 5.3335H6.66671C6.66671 4.59712 7.26366 4.00016 8.00004 4.00016H24ZM25.3334 8.00016H6.66671C5.93033 8.00016 5.33337 8.59712 5.33337 9.3335H26.6667C26.6667 8.59712 26.0698 8.00016 25.3334 8.00016ZM5.33337 12.0002C4.59699 12.0002 4.00004 12.5971 4.00004 13.3335V24.0002H15.0844C15.8758 24.0002 16.6263 23.6486 17.133 23.0407L18.8671 20.9597C19.3738 20.3517 20.1243 20.0002 20.9157 20.0002H28V13.3335C28 12.5971 27.4031 12.0002 26.6667 12.0002H5.33337Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "61e299c9bbb1d90316237b8db7700aec",
                        link: {
                          to: "/solutions/private-equity",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Private equity",
                        subtitle: "Arm your portfolio with the tools to win",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill=currentColor xmlns="http://www.w3.org/2000/svg">\n<path d="M12 0C18.6274 0 24 5.37258 24 12C24 12.7176 23.9372 13.4206 23.8164 14.1035C23.3303 13.3793 22.7122 12.7513 21.9971 12.2529C21.9991 12.169 22 12.0844 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C12.0844 22 12.169 21.9991 12.2529 21.9971C12.7513 22.7122 13.3793 23.3303 14.1035 23.8164C13.4206 23.9372 12.7176 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM18 12C21.3137 12 24 14.6863 24 18C24 21.3137 21.3137 24 18 24C14.6863 24 12 21.3137 12 18C12 14.6863 14.6863 12 18 12ZM18 14C16.8954 14 16 14.8954 16 16V17H15V21H21V17H20V16C20 14.8954 19.1046 14 18 14ZM10 14V15H11.6738C11.5002 15.5 11 16.5 11 17H8V14H10ZM18 15C18.5523 15 19 15.4477 19 16V17H17V16C17 15.4477 17.4477 15 18 15ZM13 4V7H16V10H14V9H11C10.4477 9 10 9.44771 10 10C10 10.5523 10.4477 11 11 11H13C13.7365 11 14.4115 11.2657 14.9336 11.7061C14.2519 12.0388 13.6322 12.4792 13.0967 13.0049C13.065 13.0019 13.0325 13 13 13H11C9.34315 13 8 11.6569 8 10C8 8.34315 9.34315 7 11 7V4H13Z" fill=currentColor/>\n</svg>',
                        },
                      },
                      {
                        _key: "9f4ba3f252376c1f4e27749ba7682cec",
                        link: {
                          to: "/solutions/venture-capital",
                          toExternal: null,
                          noFollow: false,
                          hash: null,
                        },
                        text: "Venture capital",
                        subtitle: "Manage spend for your firm & portfolio",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '    <svg\n      width="24"\n      height="24"\n      viewBox="0 0 24 24"\n      fill="none"\n      xmlns="http://www.w3.org/2000/svg"\n    >\n      <path\n        fill-rule="evenodd"\n        clip-rule="evenodd"\n        d="M23.8162 14.1036C23.937 13.4206 24 12.7177 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C12.7177 24 13.4206 23.937 14.1036 23.8162C13.3793 23.3301 12.7509 22.7122 12.2525 21.9969C12.1686 21.999 12.0844 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.0844 21.999 12.1686 21.9969 12.2525C22.7122 12.7509 23.3301 13.3793 23.8162 14.1036ZM18 24C21.3137 24 24 21.3137 24 18C24 14.6863 21.3137 12 18 12C14.6863 12 12 14.6863 12 18C12 21.3137 14.6863 24 18 24ZM19 14L15 19H17.5L17 22L21 17H18.5L19 14ZM14.9332 11.7058C14.4111 11.2654 13.7365 11 13 11H11C10.4477 11 10 10.5523 10 10C10 9.44771 10.4477 9 11 9H14V10H16V7H13V4H11V7C9.34315 7 8 8.34315 8 10C8 11.6569 9.34315 13 11 13H13C13.0325 13 13.0646 13.0016 13.0963 13.0046C13.6318 12.4789 14.2515 12.0386 14.9332 11.7058ZM11.4616 15.5338C11.5462 15.3303 11.6235 15.1443 11.6736 15H10V14H8V17H11C11 16.6443 11.253 16.0356 11.4616 15.5338L11.4616 15.5338Z"\n        fill="currentColor"\n      />\n    </svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _key: "3adc58d91a4b",
        _type: "navMenu",
        text: "Resources",
        description: null,
        submenu: [
          {
            _key: "79d0fdf35784",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "Customer Hub",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: { to: "", toExternal: null, noFollow: null, hash: null },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "86ec301ad222",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "/support",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Help Center",
                        subtitle: "FAQs and best practices",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M10.5 17.5C10.5 16.6716 11.1716 16 12 16C12.8284 16 13.5 16.6716 13.5 17.5C13.5 18.3284 12.8284 19 12 19C11.1716 19 10.5 18.3284 10.5 17.5Z" fill="currentColor"/>\n<path d="M12 5C9.79086 5 8 6.79086 8 9H10C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9V9.39445C14 10.0632 13.6658 10.6876 13.1094 11.0585L12.7812 11.2774C11.6684 12.0192 11 13.2681 11 14.6056V15H13V14.6056C13 13.9368 13.3342 13.3124 13.8906 12.9415L14.2188 12.7226C15.3316 11.9808 16 10.7319 16 9.39445V9C16 6.79086 14.2091 5 12 5Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "78c4db945bb1",
                        link: {
                          to: "/training",
                          toExternal: null,
                          noFollow: null,
                          hash: null,
                        },
                        text: "Live training",
                        subtitle: "Live training and guides",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="21" viewBox="0 0 24 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M2.47117 16.9754C1.70016 16.9754 1.0939 16.758 0.652389 16.3231C0.217463 15.8815 0 15.272 0 14.4944V2.59324C0 1.81565 0.217463 1.20938 0.652389 0.774459C1.0939 0.339533 1.70016 0.12207 2.47117 0.12207H21.5288C22.2998 0.12207 22.9028 0.339533 23.3377 0.774459C23.7792 1.20938 24 1.81565 24 2.59324V14.4944C24 15.272 23.7792 15.8815 23.3377 16.3231C22.9028 16.758 22.2998 16.9754 21.5288 16.9754H2.47117ZM2.31301 12.3988H21.6771C21.9605 12.3988 22.1021 12.2605 22.1021 11.9837V2.71186C22.1021 2.49439 22.0395 2.32635 21.9143 2.20774C21.7891 2.08253 21.6244 2.01993 21.4201 2.01993H2.5799C2.37562 2.01993 2.21087 2.08253 2.08567 2.20774C1.96046 2.32635 1.89786 2.49439 1.89786 2.71186V11.9837C1.89786 12.2605 2.03624 12.3988 2.31301 12.3988ZM9 19V15.8792H15V19.0117L9 19ZM8.72817 20.5537C8.47776 20.5537 8.26359 20.4647 8.08567 20.2868C7.91433 20.1089 7.82867 19.898 7.82867 19.6542C7.82867 19.4038 7.91433 19.1896 8.08567 19.0117C8.26359 18.8404 8.47776 18.7547 8.72817 18.7547H15.2718C15.5222 18.7547 15.7331 18.8404 15.9044 19.0117C16.0758 19.1896 16.1614 19.4038 16.1614 19.6542C16.1614 19.898 16.0758 20.1089 15.9044 20.2868C15.7331 20.4647 15.5222 20.5537 15.2718 20.5537H8.72817Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: "",
                          toExternal:
                            "https://www.brex.com/product-announcements",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Product releases",
                        subtitle: "See what's new",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="fill=currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M3 2C1.89543 2 1 2.89543 1 4V17C1 18.1046 1.89543 19 3 19H9C9.53043 19 10.0391 19.2107 10.4142 19.5858C10.7893 19.9609 11 20.4696 11 21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21C13 20.4696 13.2107 19.9609 13.5858 19.5858C13.9609 19.2107 14.4696 19 15 19H21C22.1046 19 23 18.1046 23 17V4C23 2.89543 22.1046 2 21 2H16C14.6739 2 13.4021 2.52678 12.4645 3.46447C12.2962 3.63275 12.1411 3.81178 12 3.99997C11.8589 3.81178 11.7038 3.63275 11.5355 3.46447C10.5979 2.52678 9.32608 2 8 2H3ZM13 17.5359C13.6029 17.1878 14.2918 17 15 17H21V4H16C15.2044 4 14.4413 4.31607 13.8787 4.87868C13.3161 5.44129 13 6.20435 13 7V17.5359ZM11 17.5359V7C11 6.20435 10.6839 5.44129 10.1213 4.87868C9.55871 4.31607 8.79565 4 8 4H3V17H9C9.70823 17 10.3971 17.1878 11 17.5359Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "4ce7782d1713ef14f57e6d62fb24e62e",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "Connect with Brex",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: null,
                link: { to: "", toExternal: null, noFollow: null, hash: null },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "86ec301ad222",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: null,
                          toExternal: "https://www.brex.com/resources/webinars",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Webinars",
                        subtitle: "Watch and learn",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="21" viewBox="0 0 24 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M2.47117 16.9754C1.70016 16.9754 1.0939 16.758 0.652389 16.3231C0.217463 15.8815 0 15.272 0 14.4944V2.59324C0 1.81565 0.217463 1.20938 0.652389 0.774459C1.0939 0.339533 1.70016 0.12207 2.47117 0.12207H21.5288C22.2998 0.12207 22.9028 0.339533 23.3377 0.774459C23.7792 1.20938 24 1.81565 24 2.59324V14.4944C24 15.272 23.7792 15.8815 23.3377 16.3231C22.9028 16.758 22.2998 16.9754 21.5288 16.9754H2.47117ZM2.31301 12.3988H21.6771C21.9605 12.3988 22.1021 12.2605 22.1021 11.9837V2.71186C22.1021 2.49439 22.0395 2.32635 21.9143 2.20774C21.7891 2.08253 21.6244 2.01993 21.4201 2.01993H2.5799C2.37562 2.01993 2.21087 2.08253 2.08567 2.20774C1.96046 2.32635 1.89786 2.49439 1.89786 2.71186V11.9837C1.89786 12.2605 2.03624 12.3988 2.31301 12.3988ZM9 19V15.8792H15V19.0117L9 19ZM8.72817 20.5537C8.47776 20.5537 8.26359 20.4647 8.08567 20.2868C7.91433 20.1089 7.82867 19.898 7.82867 19.6542C7.82867 19.4038 7.91433 19.1896 8.08567 19.0117C8.26359 18.8404 8.47776 18.7547 8.72817 18.7547H15.2718C15.5222 18.7547 15.7331 18.8404 15.9044 19.0117C16.0758 19.1896 16.1614 19.4038 16.1614 19.6542C16.1614 19.898 16.0758 20.1089 15.9044 20.2868C15.7331 20.4647 15.5222 20.5537 15.2718 20.5537H8.72817Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "78c4db945bb1",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/resources/events",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Events",
                        subtitle: "Connect in person",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M9 10H11V12H9V10Z" fill="currentColor"/>\n<path d="M15 10H13V12H15V10Z" fill="currentColor"/>\n<path d="M17 10H19V12H17V10Z" fill="currentColor"/>\n<path d="M15 14H13V16H15V14Z" fill="currentColor"/>\n<path d="M9 14H11V16H9V14Z" fill="currentColor"/>\n<path d="M7 14H5V16H7V14Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.75374 1.32398C4.43407 1.80348 4.20873 2.3784 4.09199 3H3C1.34315 3 0 4.34315 0 6V18C0 19.6569 1.34314 21 3 21H21C22.6569 21 24 19.6569 24 18V6C24 4.34315 22.6569 3 21 3H19.908C19.7913 2.3784 19.5659 1.80348 19.2463 1.32398C18.7651 0.602302 17.9907 0 17 0C16.0093 0 15.2349 0.602302 14.7537 1.32398C14.4341 1.80348 14.2087 2.3784 14.092 3H9.90801C9.79127 2.3784 9.56593 1.80348 9.24626 1.32398C8.76515 0.602302 7.99067 0 7 0C6.00933 0 5.23485 0.602302 4.75374 1.32398ZM6.41784 2.43338C6.31464 2.58818 6.2224 2.77939 6.15101 3H7.84899C7.7776 2.77939 7.68536 2.58818 7.58216 2.43338C7.33942 2.06927 7.1139 2 7 2C6.8861 2 6.66058 2.06927 6.41784 2.43338ZM17.849 3C17.7776 2.77939 17.6854 2.58818 17.5822 2.43338C17.3394 2.06927 17.1139 2 17 2C16.8861 2 16.6606 2.06927 16.4178 2.43338C16.3146 2.58818 16.2224 2.77939 16.151 3H17.849ZM17.849 5H9.90801C9.79127 5.6216 9.56593 6.19652 9.24626 6.67602C8.76515 7.3977 7.99067 8 7 8V6C7.1139 6 7.33942 5.93073 7.58216 5.56662C7.68536 5.41182 7.7776 5.22061 7.84899 5H3C2.44772 5 2 5.44771 2 6V18C2 18.5523 2.44772 19 3 19H21C21.5523 19 22 18.5523 22 18V6C22 5.44771 21.5523 5 21 5H19.908C19.7913 5.6216 19.5659 6.19652 19.2463 6.67602C18.7651 7.3977 17.9907 8 17 8V6C17.1139 6 17.3394 5.93073 17.5822 5.56662C17.6854 5.41182 17.7776 5.22061 17.849 5Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/careers",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Careers",
                        subtitle: "Join us – we're hiring",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M16 2.66675C12.355 2.66675 9.40004 5.65152 9.40004 9.33342C9.40004 13.0153 12.355 16.0001 16 16.0001C19.6451 16.0001 22.6 13.0153 22.6 9.33342C22.6 5.65152 19.6451 2.66675 16 2.66675ZM12.3334 9.33342C12.3334 7.28792 13.975 5.62971 16 5.62971C18.0251 5.62971 19.6667 7.28792 19.6667 9.33342C19.6667 11.3789 18.0251 13.0371 16 13.0371C13.975 13.0371 12.3334 11.3789 12.3334 9.33342ZM16 17.4816C16.4303 17.4816 16.8581 17.4952 17.2822 17.5207C16.4707 18.3619 15.8157 19.3551 15.3642 20.4534C12.3611 20.5369 9.46695 21.1932 7.25482 21.8635C6.07692 22.2205 5.10664 22.577 4.4345 22.8427C4.37629 22.8657 4.32034 22.888 4.26671 22.9096V23.1112C4.26671 23.9653 4.26785 24.5169 4.3018 24.9366C4.33436 25.3391 4.38962 25.4883 4.42657 25.5616C4.56718 25.8403 4.79155 26.0669 5.06753 26.209C5.14004 26.2463 5.28776 26.3021 5.6862 26.335C6.10177 26.3693 6.64777 26.3705 7.49338 26.3705H14.9704C15.252 27.4461 15.7207 28.4461 16.3396 29.3334H7.43685H7.43678C6.66366 29.3334 5.99669 29.3335 5.44734 29.2881C4.8675 29.2403 4.29078 29.1346 3.73582 28.849C2.90791 28.4229 2.23479 27.743 1.81295 26.9067C1.53019 26.3461 1.42559 25.7636 1.37821 25.1779C1.33333 24.623 1.33335 23.9493 1.33338 23.1683V23.1683V20.9781L2.18543 20.5809C2.18543 20.5809 2.1798 20.5835 2.18678 20.5803L2.18873 20.5793L2.19436 20.5767L2.21256 20.5684L2.27619 20.5395C2.33054 20.515 2.40854 20.4804 2.50876 20.437C2.70913 20.3503 2.99859 20.2285 3.36559 20.0834C4.09901 19.7935 5.14539 19.4093 6.41193 19.0255C8.93291 18.2616 12.3835 17.4816 16 17.4816ZM24 32.0001C28.4183 32.0001 32 28.4184 32 24.0001C32 19.5818 28.4183 16.0001 24 16.0001C19.5818 16.0001 16 19.5818 16 24.0001C16 28.4184 19.5818 32.0001 24 32.0001ZM22.6667 20.0001V22.6667H20V25.3334H22.6667V28.0001H25.3334V25.3334H28V22.6667H25.3334V20.0001H22.6667Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "52ad2aa9a6dac50077eafbfec3134452",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryWhite",
            title: {
              text: "Resource Center",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: "/resources",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "86ec301ad222",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "8f0c28831467",
                    _type: "linkListNavModule",
                    modifier: null,
                    linkModifier: null,
                    links: [
                      {
                        _key: "b8ef1fb6be23",
                        link: {
                          to: null,
                          toExternal: "https://www.brex.com/journal",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Blog",
                        subtitle: "Get news and insights",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M18 0.585815L2 16.5858V22H7.41421L23.4142 6.00003L18 0.585815ZM4 20V17.4142L14.7071 6.70714L17.2929 9.29292L6.58579 20H4Z" fill="currentColor"/>\n</svg>',
                        },
                      },
                      {
                        _key: "74279666e82b",
                        link: {
                          to: "",
                          toExternal: "https://www.brex.com/resources/ebooks",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Exclusive reports",
                        subtitle: "Unlock research and guides",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="33" height="32" viewBox="0 0 33 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path d="M21.8333 18.6667V16H11.1667V18.6667H21.8333Z" fill="currentColor"/>\n<path d="M11.1667 24V21.3333H21.8333V24H11.1667Z" fill="currentColor"/>\n<path d="M16.5 6.66667H11.1667V9.33333H16.5V6.66667Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 4C4.5 1.79086 6.29086 0 8.5 0H21.0523L28.5 7.44772V28C28.5 30.2091 26.7091 32 24.5 32H8.5C6.29086 32 4.5 30.2091 4.5 28V4ZM8.5 2.66667C7.76362 2.66667 7.16667 3.26362 7.16667 4V28C7.16667 28.7364 7.76362 29.3333 8.5 29.3333H24.5C25.2364 29.3333 25.8333 28.7364 25.8333 28V9.33333H19.1667V2.66667H8.5Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                      {
                        _key: "78c4db945bb1",
                        link: {
                          to: "",
                          toExternal:
                            "https://www.brex.com/resources/case-studies",
                          noFollow: null,
                          hash: null,
                        },
                        text: "Customer stories",
                        subtitle: "Learn from the best",
                        subtitleV2Raw: null,
                        icon: {
                          mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M16.0002 2.66663C12.3551 2.66663 9.40016 5.65139 9.40016 9.33329C9.40016 13.0152 12.3551 16 16.0002 16C19.6452 16 22.6002 13.0152 22.6002 9.33329C22.6002 5.65139 19.6452 2.66663 16.0002 2.66663ZM12.3335 9.33329C12.3335 7.28779 13.9751 5.62959 16.0002 5.62959C18.0252 5.62959 19.6668 7.28779 19.6668 9.33329C19.6668 11.3788 18.0252 13.037 16.0002 13.037C13.9751 13.037 12.3335 11.3788 12.3335 9.33329Z" fill="currentColor"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M29.9331 21.3834L29.9296 21.3814L29.9238 21.378L29.9052 21.3673L29.8407 21.3307C29.7858 21.2998 29.7072 21.2562 29.6063 21.2016C29.4046 21.0924 29.1135 20.9394 28.7446 20.7571C28.0076 20.393 26.9557 19.9101 25.6818 19.4276C23.1502 18.4687 19.6654 17.4814 16.0002 17.4814C12.3836 17.4814 8.93303 18.2615 6.41205 19.0254C5.14551 19.4092 4.09913 19.7934 3.36571 20.0833C2.99871 20.2284 2.70925 20.3501 2.50888 20.4369C2.40867 20.4803 2.33066 20.5149 2.27631 20.5394L2.21268 20.5682L2.19448 20.5766L2.18885 20.5792L2.18691 20.5801C2.17992 20.5834 2.18555 20.5808 2.18555 20.5808L1.3335 20.978V23.1682C1.33347 23.9491 1.33345 24.6229 1.37834 25.1778C1.42571 25.7635 1.53031 26.346 1.81307 26.9066C2.23491 27.7429 2.90803 28.4228 3.73594 28.8489C4.2909 29.1345 4.86762 29.2402 5.44746 29.288C5.99683 29.3333 6.66382 29.3333 7.43697 29.3333H24.5634C25.3365 29.3333 26.0035 29.3333 26.5529 29.288C27.1327 29.2402 27.7094 29.1345 28.2644 28.8489C29.0923 28.4228 29.7654 27.7429 30.1873 26.9066C30.47 26.346 30.5746 25.7635 30.622 25.1778C30.6669 24.6229 30.6669 23.9492 30.6668 23.1682V21.811C30.6668 21.811 30.2196 21.5504 29.9331 21.3834ZM4.26683 23.1111V22.9094C4.32046 22.8879 4.37641 22.8655 4.43462 22.8425C5.10676 22.5769 6.07704 22.2203 7.25494 21.8634C9.62285 21.1459 12.7722 20.4444 16.0002 20.4444C19.1794 20.4444 22.2946 21.309 24.6518 22.2019C25.8224 22.6453 26.7872 23.0884 27.4557 23.4187C27.5549 23.4677 27.6475 23.5142 27.7332 23.5578C27.7319 24.166 27.726 24.5949 27.6984 24.9365C27.6658 25.339 27.6106 25.4882 27.5736 25.5614C27.433 25.8402 27.2087 26.0668 26.9327 26.2089C26.8602 26.2462 26.7124 26.302 26.314 26.3349C25.8984 26.3692 25.3524 26.3703 24.5068 26.3703H7.4935C6.64789 26.3703 6.10189 26.3692 5.68632 26.3349C5.28789 26.302 5.14016 26.2462 5.06765 26.2089C4.79168 26.0668 4.5673 25.8402 4.42669 25.5614C4.38974 25.4882 4.33448 25.339 4.30193 24.9365C4.26797 24.5167 4.26683 23.9652 4.26683 23.1111Z" fill="currentColor"/>\n</svg>\n',
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            _key: "41c298baca51",
            _type: "navGroup",
            span: 1,
            theme: "PrimaryGray",
            title: {
              text: "The latest",
              linkOnlyOnMobile: false,
              hideOnDesktop: false,
              hideOnMobile: false,
              link: {
                _key: null,
                _type: "navLink",
                text: "View all",
                link: {
                  to: null,
                  toExternal: "https://www.brex.com/resources",
                  noFollow: null,
                  hash: null,
                },
              },
            },
            addSpacerAfterOnMobile: true,
            collapseOnMobile: false,
            hideOnDesktop: false,
            hideOnMobile: false,
            columns: [
              {
                _key: "24bcb773c1dd",
                _type: "navColumn",
                span: 1,
                modules: [
                  {
                    _key: "d14d2a279104",
                    _type: "linkHeroNavModule",
                    title: "A new chapter: Brex comes to the EU",
                    subtitle: null,
                    subtitleV2Raw: [
                      {
                        markDefs: [],
                        children: [
                          {
                            marks: [],
                            text: "Learn how Brex's new EU license unlocks intelligent finance for over 200,000 European companies.",
                            _key: "4bc17f1e4ff80",
                            _type: "span",
                          },
                        ],
                        _type: "block",
                        style: "normal",
                        _key: "5fc6e0130960",
                      },
                    ],
                    link: {
                      to: "/journal/eu-license",
                      toExternal: null,
                      noFollow: false,
                      hash: null,
                    },
                    icon: null,
                    media: {
                      media: {
                        type: "IMAGE",
                        datUrl:
                          "https://brand.brex.com/transform/deba553d-9c29-48e0-8154-d6fa596b7fff/1232FINAL-EU-blog-image",
                        description: null,
                        aspectRatio: 0.5275,
                        videoUrl: null,
                      },
                      mediaStyle: {
                        borderRadius: "6px",
                        customBorderRadius: null,
                      },
                      disableVideoLoop: false,
                    },
                    modifier: null,
                    mediaPosition: "top",
                    showMediaOnMobile: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _key: "94381d8efb96",
        _type: "navLink",
        text: "Customers",
        link: {
          to: "/customers",
          toExternal: null,
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "852f2e01f2ec39bc74c89ce6050293fc",
        _type: "navLink",
        text: "Pricing",
        link: {
          to: "",
          toExternal: "https://www.brex.com/pricing",
          noFollow: null,
          hash: null,
        },
      },
    ],
    right: [
      {
        _key: "7140f7b3727f",
        _type: "navLink",
        text: "Sign in",
        link: {
          to: null,
          toExternal: "https://dashboard.brex.com/",
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "31052062d8c7",
        _type: "navLink",
        text: "See a demo",
        link: {
          to: "/book-a-demo",
          toExternal: null,
          noFollow: null,
          hash: null,
        },
      },
      {
        _key: "55593003b8b9",
        _type: "navLink",
        text: "Get started",
        link: { to: "/signup", toExternal: null, noFollow: null, hash: null },
      },
    ],
    cta: {
      text: "Control all your spend before it happens, all in one place.",
      link: {
        _key: null,
        _type: "navLink",
        text: "Get started",
        link: { to: "/sales", toExternal: null, noFollow: null, hash: null },
      },
    },
  },
};
